/*
* @license
* Pipeline Theme (c) Groupthought Themes
*
* The contents of this file should not be modified.
* add any minor changes to assets/custom.js
*
*/
! function(t, e, i, s, o, r, n, a, l, c, h) {
    "use strict";

    function d(t) {
        var e = Object.create(null);
        return t && Object.keys(t).forEach((function(i) {
            if ("default" !== i) {
                var s = Object.getOwnPropertyDescriptor(t, i);
                Object.defineProperty(e, i, s.get ? s : {
                    enumerable: !0,
                    get: function() {
                        return t[i]
                    }
                })
            }
        })), e.default = t, Object.freeze(e)
    }
    var u = d(o);

    function p(t) {
        const e = t.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        e.forEach((t => {
            i.querySelector(`[id="${t.id}"]`) || i.appendChild(t)
        }))
    }

    function m(t) {
        t.querySelectorAll(".float__wrapper").forEach((t => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e && i.addEventListener("keyup", (t => {
                "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float")
            })), i && i.value && i.value.length && e.classList.add("label--float")
        }))
    }

    function g(t) {
        t.querySelectorAll(".errors").forEach((t => {
            t.setAttribute("tabindex", "0"), t.setAttribute("aria-live", "assertive"), t.setAttribute("role", "alert")
        }))
    }

    function y() {
        const t = {};
        return t.windowHeight = window.innerHeight, t.announcementHeight = v("#shopify-section-announcement"), t.toolbarHeight = v("[data-toolbar-height]"), t.footerHeight = v('[data-section-type*="footer"]'), t.menuHeight = v("[data-header-height]"), t.headerHeight = t.menuHeight + t.announcementHeight, t.logoHeight = function() {
            const t = v("[data-footer-logo]");
            return t > 0 ? t + 20 : 0
        }(), t.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? t.menuHeight : 0, t.backfillHeight = v("[data-header-backfill]"), t
    }

    function f() {
        document.addEventListener("theme:resize", w),
            function() {
                const {
                    windowHeight: t,
                    announcementHeight: e,
                    toolbarHeight: i,
                    headerHeight: s,
                    logoHeight: o,
                    menuHeight: r,
                    footerHeight: n,
                    stickyHeader: a,
                    backfillHeight: l
                } = y();
                document.documentElement.style.setProperty("--scrollbar-width", `${b()}px`), document.documentElement.style.setProperty("--footer-logo", `${o}px`), document.documentElement.style.setProperty("--full-screen", `${t}px`), document.documentElement.style.setProperty("--three-quarters", .75 * t + "px"), document.documentElement.style.setProperty("--two-thirds", .66 * t + "px"), document.documentElement.style.setProperty("--one-half", .5 * t + "px"), document.documentElement.style.setProperty("--one-third", .33 * t + "px"), document.documentElement.style.setProperty("--one-fifth", .2 * t + "px"), document.documentElement.style.setProperty("--menu-height", `${r}px`), document.documentElement.style.setProperty("--announcement-height", `${e}px`), document.documentElement.style.setProperty("--toolbar-height", `${i}px`), document.documentElement.style.setProperty("--header-height", `${s}px`), document.documentElement.style.setProperty("--footer-height", `${n}px`), document.documentElement.style.setProperty("--content-full", t - s - o / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
                let c = Math.abs(l - r) > 1 ? `${r}px` : "auto";
                document.documentElement.style.setProperty("--menu-backfill-height", c)
            }()
    }

    function w() {
        const {
            windowHeight: t,
            announcementHeight: e,
            toolbarHeight: i,
            headerHeight: s,
            logoHeight: o,
            menuHeight: r,
            footerHeight: n,
            stickyHeader: a,
            backfillHeight: l
        } = y();
        document.documentElement.style.setProperty("--scrollbar-width", `${b()}px`), document.documentElement.style.setProperty("--full-screen", `${t}px`), document.documentElement.style.setProperty("--menu-height", `${r}px`), document.documentElement.style.setProperty("--announcement-height", `${e}px`), document.documentElement.style.setProperty("--toolbar-height", `${i}px`), document.documentElement.style.setProperty("--header-height", `${s}px`), document.documentElement.style.setProperty("--footer-height", `${n}px`), document.documentElement.style.setProperty("--content-full", t - s - o / 2 + "px"), document.documentElement.style.setProperty("--menu-height-sticky", `${a}px`);
        let c = Math.abs(l - r) > 1 ? `${r}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", c)
    }

    function v(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0
    }

    function b() {
        const t = document.createElement("div");
        t.style.visibility = "hidden", t.style.overflow = "scroll", t.style.msOverflowStyle = "scrollbar", document.body.appendChild(t);
        const e = document.createElement("div");
        t.appendChild(e);
        const i = t.offsetWidth - e.offsetWidth;
        return t.parentNode.removeChild(t), i
    }

    function S(t, e) {
        let i = 64,
            s = 0;
        e.forEach((t => {
            if (t.offsetHeight > s) {
                const e = parseInt(window.getComputedStyle(t).marginTop) + parseInt(window.getComputedStyle(t).marginBottom);
                e > i && (i = e), s = t.offsetHeight
            }
        }));
        const o = t.querySelectorAll("[data-overflow-background]");
        [t, ...o].forEach((t => {
            t.style.setProperty("min-height", `calc(${s+i}px + var(--menu-height))`)
        }))
    }

    function E(t) {
        let e = document.querySelector("[data-footer-logo]") ? document.querySelector("[data-footer-logo]").clientHeight + 20 : 0;
        const i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if ((null !== s && t.getAttribute("data-section-id") !== s || !i) && (e = 0), window.innerWidth < window.theme.sizes.medium) {
            return void t.querySelectorAll("[data-overflow-frame]").forEach((t => {
                const e = t.querySelectorAll("[data-overflow-content]");
                S(t, e)
            }))
        }
        const o = document.createElement("div");
        t.prepend(o), o.style.display = "none", o.style.width = getComputedStyle(t).getPropertyValue("--outer");
        const r = 2 * parseInt(getComputedStyle(o).getPropertyValue("width"));
        t.firstChild.remove();
        let n = 0;
        const a = t.querySelectorAll("[data-overflow-frame]");
        t.querySelectorAll("[data-overflow-content]").forEach((t => {
            t.offsetHeight > n && (n = t.offsetHeight)
        }));
        [...a, ...t.querySelectorAll("[data-overflow-background]")].forEach((t => {
            t.style.setProperty("min-height", `${n+r}px`)
        })), t.style.setProperty("min-height", `${n+r+2+e}px`)
    }

    function L(t) {
        const i = t.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((t => {
                const e = t.querySelectorAll(".js-overflow-content");
                S(t, e), document.addEventListener("theme:resize", (() => {
                    S(t, e)
                }))
            }));
            const s = t.querySelectorAll("[data-slideshow-wrapper]");
            s.length && s.forEach((t => {
                const i = e.data(t);
                void 0 !== i && i.reloadCells()
            }))
        }
        const s = t.querySelectorAll("[data-overflow-wrapper]");
        s && s.forEach((t => {
            E(t), document.addEventListener("theme:resize", (() => {
                E(t)
            }))
        }))
    }

    function k(t, e = 500, i = !1) {
        var s, o, r, n, a;

        function l() {
            var c = Date.now() - n;
            c < e && c >= 0 ? s = setTimeout(l, e - c) : (s = null, i || (a = t.apply(r, o), r = o = null))
        }
        null == e && (e = 100);
        var c = function() {
            r = this, o = arguments, n = Date.now();
            var c = i && !s;
            return s || (s = setTimeout(l, e)), c && (a = t.apply(r, o), r = o = null), a
        };
        return c.clear = function() {
            s && (clearTimeout(s), s = null)
        }, c.flush = function() {
            s && (a = t.apply(r, o), r = o = null, clearTimeout(s), s = null)
        }, c
    }
    window.requestIdleCallback = window.requestIdleCallback || function(t) {
        var e = Date.now();
        return setTimeout((function() {
            t({
                didTimeout: !1,
                timeRemaining: function() {
                    return Math.max(0, 50 - (Date.now() - e))
                }
            })
        }), 1)
    }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
        clearTimeout(t)
    };
    let T, A = window.innerWidth,
        q = window.innerHeight;

    function C() {
        document.dispatchEvent(new CustomEvent("theme:resize", {
            bubbles: !0
        })), A !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
            bubbles: !0
        })), A = window.innerWidth), q !== window.innerHeight && (document.dispatchEvent(new CustomEvent("theme:resize:height", {
            bubbles: !0
        })), q = window.innerHeight)
    }
    let x, P = window.pageYOffset,
        $ = null,
        M = null,
        I = null,
        H = null,
        D = 0;

    function _() {
        const t = window.pageYOffset;
        t > P ? (M = !0, $ = !1) : t < P ? (M = !1, $ = !0) : ($ = null, M = null), P = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
            detail: {
                up: $,
                down: M,
                position: t
            },
            bubbles: !1
        })), $ && !I && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
            detail: {
                position: t
            },
            bubbles: !1
        })), M && !H && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
            detail: {
                position: t
            },
            bubbles: !1
        })), H = M, I = $
    }

    function B(t) {
        let e = t.target;
        t.detail && t.detail instanceof Element && (e = t.detail), i.disableBodyScroll(e), document.documentElement.setAttribute("data-scroll-locked", "")
    }

    function F() {
        if (D = setTimeout((() => {
            document.body.removeAttribute("data-drawer-closing")
        }), 20), document.body.hasAttribute("data-drawer-closing")) return document.body.removeAttribute("data-drawer-closing"), void(D && clearTimeout(D));
        document.body.setAttribute("data-drawer-closing", ""), document.documentElement.removeAttribute("data-scroll-locked"), i.clearAllBodyScrollLocks()
    }
    window.addEventListener("resize", (() => {
        T && window.cancelAnimationFrame(T), T = window.requestAnimationFrame(k(C, 50))
    })), window.addEventListener("scroll", (function() {
        x && window.cancelAnimationFrame(x), x = window.requestAnimationFrame(_)
    }), {
        passive: !0
    }), window.addEventListener("theme:scroll:lock", B), window.addEventListener("theme:scroll:unlock", F), document.addEventListener("load", (t => {
        ! function(t) {
            "IMG" == t.tagName && t.classList.contains("loading-shimmer") && t.classList.remove("loading-shimmer")
        }(t.target)
    }), !0), window.addEventListener("DOMContentLoaded", (() => {
        f(), m(document), g(document), p(document), window.theme.settings.animate_scroll && t.refresh()
    })), window.addEventListener("load", (() => {
        document.querySelectorAll("img.loading-shimmer").forEach((t => {
            t.complete && t.classList.remove("loading-shimmer")
        })), L(document)
    })), document.addEventListener("shopify:section:load", (e => {
        const i = e.target;
        m(i), g(i), p(i), L(i), window.theme.settings.animate_scroll && t.refresh()
    })), document.addEventListener("shopify:section:reorder", (() => {
        document.dispatchEvent(new CustomEvent("theme:header:check", {
            bubbles: !1
        }))
    }));
    const W = (t, e = !1, i = "block") => {
        t && (e ? t.style.removeProperty("display") : t.style.display = i)
    };

    function O(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    O.prototype = Error.prototype;
    const R = "data-scrollbar-slider",
        N = "[data-scrollbar-arrow-prev]",
        z = "[data-scrollbar-arrow-next]",
        V = "is-hidden",
        j = 200;
    let U = class {
        init() {
            this.arrowNext && this.arrowPrev && (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events())
        }
        resize() {
            document.addEventListener("theme:resize", (() => {
                window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow()
            }))
        }
        events() {
            this.arrowNext.addEventListener("click", (t => {
                t.preventDefault(), this.goToNext()
            })), this.arrowPrev.addEventListener("click", (t => {
                t.preventDefault(), this.goToPrev()
            })), this.scrollbar.addEventListener("scroll", (() => {
                this.togglePrevArrow(), this.toggleNextArrow()
            }))
        }
        goToNext() {
            const t = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
            this.move(t), this.arrowPrev.classList.remove(V), this.toggleNextArrow()
        }
        goToPrev() {
            const t = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
            this.move(t), this.arrowNext.classList.remove(V), this.togglePrevArrow()
        }
        toggleNextArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowNext.classList.toggle(V, 0 === this.scrollbar.scrollLeft) : this.arrowNext.classList.toggle(V, Math.round(this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1) >= this.scrollbar.scrollWidth)
            }), j)
        }
        togglePrevArrow() {
            setTimeout((() => {
                window.isRTL ? this.arrowPrev.classList.toggle(V, Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >= this.scrollbar.scrollWidth) : this.arrowPrev.classList.toggle(V, this.scrollbar.scrollLeft <= 0)
            }), j)
        }
        scrollToVisibleElement() {
            [].forEach.call(this.scrollbar.children, (t => {
                t.addEventListener("click", (e => {
                    ("a" === e.target.tagName.toLowerCase() || e.currentTarget && "a" === e.currentTarget.tagName.toLowerCase() || e.currentTarget && e.currentTarget.querySelector("a")) && e.preventDefault(), this.move(t.offsetLeft - t.clientWidth)
                }))
            }))
        }
        move(t) {
            this.scrollbar.scrollTo({
                top: 0,
                left: t,
                behavior: "smooth"
            })
        }
        constructor(t) {
            this.scrollbar = t, this.arrowNext = this.scrollbar.parentNode.querySelector(z), this.arrowPrev = this.scrollbar.parentNode.querySelector(N), this.init(), this.resize(), this.scrollbar.hasAttribute(R) && this.scrollToVisibleElement()
        }
    };
    const J = "[data-sibling-inner]";
    let Q = class {
        init() {
            this.siblings.forEach((t => {
                new U(t)
            }))
        }
        constructor(t) {
            this.siblings = t.querySelectorAll(J), this.init()
        }
    };
    const G = {
            onLoad() {
                new Q(this.container)
            }
        },
        Y = {
            expires: 7,
            path: "/",
            domain: window.location.hostname
        };
    let X = class {
        write(t) {
            document.cookie = `${this.options.name}=${t}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        read() {
            let t = [];
            const e = document.cookie.split("; ").find((t => t.startsWith(this.options.name)));
            if (-1 !== document.cookie.indexOf("; ") && e) {
                const e = document.cookie.split("; ").find((t => t.startsWith(this.options.name))).split("=")[1];
                null !== e && (t = e.split(","))
            }
            return t
        }
        destroy() {
            document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`
        }
        remove(t) {
            const e = this.read(),
                i = e.indexOf(t); - 1 !== i && (e.splice(i, 1), this.write(e))
        }
        constructor(t = {}) {
            this.options = {
                ...Y,
                ...t
            }
        }
    };
    const K = 4,
        Z = 10,
        tt = "[data-recently-viewed-products]",
        et = "data-limit",
        it = "[data-recent-link-tab]",
        st = "[data-recent-wrapper]",
        ot = "[data-recently-viewed-tab]",
        rt = "[data-tabs-holder-scroll]",
        nt = "[data-api-content]",
        at = "data-minimum",
        lt = "hide",
        ct = "section-without-title--skip",
        ht = {
            expires: 90,
            name: "shopify_recently_viewed"
        },
        dt = [],
        ut = [];
    const pt = {
        onLoad() {
            dt[this.id] = new class {
                renderProducts() {
                    const t = this.cookie.read(),
                        e = [];
                    let i = 0;
                    if (t.length > 0) {
                        for (let s = 0; s < t.length; s++) {
                            const o = t[s];
                            if (ut.includes(o)) continue;
                            const r = `${window.theme.routes.root_url}products/${o}?section_id=api-product-grid-item`;
                            if (e.push(r), i++, i === this.howManyToShow || i === t.length - 1) break
                        }
                        if (e.length > 0 && e.length >= this.minimum) {
                            this.container.classList.remove(lt), this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.remove(lt), this.container.classList.add(ct));
                            const t = e.map((t => fetch(t, {
                                    mode: "no-cors"
                                }).then(this.handleErrors))),
                                i = [];
                            Promise.allSettled(t).then((t => Promise.all(t.map((async t => {
                                "fulfilled" === t.status && i.push(await t.value.text())
                            }))))).then((() => {
                                i.forEach((t => {
                                    const e = document.createElement("div"),
                                        i = document.createElement("div");
                                    e.innerHTML = t, i.classList.add("product-grid-slide"), i.setAttribute("data-carousel-slide", null), i.setAttribute("data-item", null), i.innerHTML = e.querySelector(nt).innerHTML, this.wrapper.appendChild(i)
                                })), new Q(this.container)
                            })).then((() => {
                                W(this.wrapper, !0), this.container.dispatchEvent(new CustomEvent("theme:recent-products:added", {
                                    bubbles: !0
                                }))
                            }))
                        } else if (this.recentViewedTab) {
                            const t = Array.prototype.filter.call(this.recentViewedTab.parentNode.children, (t => t !== this.recentViewedTab)).length > 1;
                            this.recentViewedLink && this.recentViewedLink.previousElementSibling && (this.tabsHolderScroll.classList.add(lt), this.container.classList.remove(ct)), t || this.container.classList.add(lt)
                        } else this.container.classList.add(lt)
                    }
                }
                handleErrors(t) {
                    return t.ok ? t : t.text().then((function(e) {
                        throw new O({
                            status: t.statusText,
                            headers: t.headers,
                            text: e
                        })
                    }))
                }
                constructor(t) {
                    this.container = t.container, this.cookie = new X(ht), this.wrapper = this.container.querySelector(tt), null !== this.wrapper && (this.howManyToShow = parseInt(this.container.querySelector(st).getAttribute(et)) || K, this.minimum = parseInt(this.container.querySelector(st).getAttribute(at)), this.recentViewedTab = this.container.querySelector(ot), this.recentViewedLink = this.container.querySelector(it), this.tabsHolderScroll = this.container.querySelector(rt), this.renderProducts())
                }
            }(this)
        }
    };

    function mt() {
        const t = "(any-pointer: coarse)",
            e = `(max-width: ${window.theme.sizes.medium}px)`,
            i = `(min-width: ${window.theme.sizes.medium+1}px) and (max-width: ${window.theme.sizes.large}px)`,
            s = `(min-width: ${window.theme.sizes.large+1}px)`;
        mt.isTouch = () => {
            const e = window.matchMedia(t).matches;
            return document.documentElement.classList.toggle("supports-touch", e), e
        }, mt.isMobile = () => window.matchMedia(e).matches, mt.isTablet = () => window.matchMedia(i).matches, mt.isDesktop = () => window.matchMedia(s).matches;
        const o = [
            [t, mt.isTouch],
            [e, mt.isMobile],
            [i, mt.isTablet],
            [s, mt.isDesktop]
        ];
        mt.onChange = t => {
            o.forEach((e => {
                window.matchMedia(e[0]).addEventListener("change", (() => {
                    e[1]() && t && t()
                }))
            }))
        }
    }

    function gt() {
        this.entries = []
    }

    function yt(t, e) {
        ft(t);
        var i = function(t, e) {
            ft(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var i = [];
            return e.forEach((function(e) {
                for (var s = 0; s < t.options.length; s++) {
                    if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                        i[s] = e.value;
                        break
                    }
                }
            })), i
        }(t, e);
        return function(t, e) {
            return ft(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e), t.variants.filter((function(t) {
                return e.every((function(e, i) {
                    return t.options[i] === e
                }))
            }))[0] || null
        }(t, i)
    }

    function ft(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    mt(), gt.prototype.add = function(t, e, i) {
        this.entries.push({
            element: t,
            event: e,
            fn: i
        }), t.addEventListener(e, i)
    }, gt.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var wt = '[name="id"]',
        vt = '[name="selling_plan"]',
        bt = '[name^="options"]',
        St = '[name="quantity"]',
        Et = '[name^="properties"]';
    const Lt = {};

    function kt(t = {}) {
        if (t.type || (t.type = "json"), t.url) return Lt[t.url] ? Lt[t.url] : function(t, e) {
            const i = new Promise(((i, s) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    i(t)
                })).catch((t => {
                    s(t)
                })) : function(t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                        o = !1,
                        r = document.createElement("script");
                    r.src = t, r.onload = r.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? i() : (o = !0, e())
                    }, s.appendChild(r)
                }(t, (function() {
                    i()
                }), (function() {
                    s()
                }))
            }));
            return Lt[t] = i, i
        }(t.url, t.type);
        if (t.json) {
            if (Lt[t.json]) return Promise.resolve(Lt[t.json]);
            {
                const e = window.fetch(t.json).then((t => t.json())).then((e => (Lt[t.json] = e, e))).catch((e => {
                    Lt[t.json] = null
                }));
                return Lt[t.json] = e, e
            }
        }
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Lt[e] ? Lt[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    i = new Promise(((e, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, i) {
                                        i ? e(i) : t()
                                    }(e, i, t)
                                }
                            }])
                        } catch (t) {
                            i(t)
                        }
                    }));
                return Lt[e] = i, i
            }(t)
        }
        return Promise.reject()
    }
    const Tt = "[data-swapper-wrapper]",
        At = "[data-swapper-target]",
        qt = "data-swapper-hover";
    let Ct = {};

    function xt(t) {
        Ct[t.id] = [];
        t.querySelectorAll(Tt).forEach((e => {
            Ct[t.id].push(new class {
                init() {
                    this.hovers.forEach((t => {
                        t.addEventListener("mouseenter", function() {
                            const e = t.getAttribute(qt);
                            this.target.innerHTML = `${e}`
                        }.bind(this))
                    })), this.hovers.forEach((t => {
                        t.addEventListener("mouseleave", function() {
                            this.target.innerHTML = this.deafaultContent
                        }.bind(this))
                    })), this.hovers.forEach((t => {
                        t.addEventListener("click", function() {
                            const e = t.getAttribute(qt);
                            this.deafaultContent = `${e}`
                        }.bind(this))
                    }))
                }
                constructor(t) {
                    this.container = t, this.target = this.container.querySelector(At), this.hovers = this.container.querySelectorAll(`[${qt}]`), this.target && this.hovers.length && (this.deafaultContent = this.target.innerHTML, this.init())
                }
            }(e))
        }))
    }
    const Pt = {
            onLoad() {
                xt(this.container)
            }
        },
        $t = {
            color: "ash"
        },
        Mt = "data-swatch",
        It = "[data-grid-item]",
        Ht = "data-grid-image-default",
        Dt = "data-grid-image-target",
        _t = "data-swatch-image",
        Bt = "data-swatch-image-id",
        Ft = "data-swatch-variant",
        Wt = "[data-grid-swatches]",
        Ot = "[data-swatch-template]",
        Rt = "data-swatch-handle",
        Nt = "data-swatch-label",
        zt = "is-fade";
    let Vt = class extends HTMLElement {
        init() {
            this.setStyles(), this.variant && this.outer && this.outer.addEventListener("theme:quickview:media", (t => {
                t && t.detail && t.detail.media && (this.media = t.detail.media)
            }))
        }
        setStyles() {
            this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`), this.colorMatch.path && (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`), this.element.style.setProperty("background-size", "cover"))
        }
        replaceImage() {
            if (this.imageReplace && this.imageSlide && this.imageId) {
                if (this.imageSlide.hasAttribute(Dt) && this.imageSlide.getAttribute(Dt) !== this.imageId) {
                    this.imageSlide.classList.add(zt);
                    const t = 1e3 * parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                    setTimeout((() => {
                        this.imageSlide.classList.remove(zt)
                    }), t)
                }
                this.imageSlide.setAttribute(Dt, this.imageId), this.imageSlide.style.setProperty("background-color", "#fff"), this.imageSlide.hasAttribute(Ht) || this.imageSlide.setAttribute(Ht, window.getComputedStyle(this.imageSlide).backgroundImage), this.imageSlide.style.setProperty("background-image", this.imageReplace)
            }
        }
        constructor() {
            super(), this.element = this.querySelector(`[${Mt}]`), this.colorString = this.element.getAttribute(Mt), this.image = this.element.getAttribute(_t), this.imageId = this.element.getAttribute(Bt), this.variant = this.element.getAttribute(Ft), this.outer = this.element.closest(It), this.media = null, this.imageSlide = null, this.imageDefault = null, this.stopSlideAnimation = !1;
            const t = new class {
                getColor() {
                    return this.match
                }
                init() {
                    return kt({
                        json: window.theme.assets.swatches
                    }).then((t => this.matchColors(t, this.settings.color))).catch((t => {
                        console.log("failed to load swatch colors script"), console.log(t)
                    }))
                }
                matchColors(t, e) {
                    let i = "#E5E5E5",
                        s = null;
                    const o = window.theme.assets.base || "/",
                        r = e.toLowerCase().replace(/\s/g, ""),
                        n = t.colors;
                    if (n) {
                        const t = t => Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r,
                            e = n.findIndex(t);
                        if (e > -1) {
                            const t = Object.values(n[e])[0],
                                r = t.toLowerCase();
                            r.includes(".jpg") || r.includes(".jpeg") || r.includes(".png") || r.includes(".svg") ? (s = `${o}${encodeURIComponent(t)}`, i = "#888888") : i = t
                        }
                    }
                    return {
                        color: this.settings.color,
                        path: s,
                        hex: i
                    }
                }
                constructor(t = {}) {
                    this.settings = {
                        ...$t,
                        ...t
                    }, this.match = this.init()
                }
            }({
                color: this.colorString
            });
            t.getColor().then((t => {
                this.colorMatch = t, this.init()
            }))
        }
    };

    function jt(t) {
        t.querySelectorAll(Wt).forEach((t => {
            new class {
                init() {
                    this.wrap.innerHTML = "", this.swatches.forEach(((t, e) => {
                        let i = this.product.variants.find((e => e.options.includes(t)));
                        const s = i.featured_media ? i.featured_media.preview_image.src : "",
                            o = i.featured_media ? i.featured_media.id : "",
                            r = Math.floor(9999 * Math.random());
                        this.wrap.innerHTML += u.render(this.template, {
                            color: t,
                            uniq: `${this.product.id}-${i.id}-${r}`,
                            variant: i.id,
                            product_id: this.product.id,
                            image_id: o,
                            image: s,
                            index: e
                        })
                    })), new U(this.wrap)
                }
                constructor(t) {
                    this.template = document.querySelector(Ot).innerHTML, this.wrap = t, this.handle = t.getAttribute(Rt);
                    const e = t.getAttribute(Nt).trim().toLowerCase();
                    (function(t) {
                        const e = `${window.theme.routes.root_url}products/${t}.js`;
                        return window.fetch(e).then((t => t.json())).catch((t => {
                            console.error(t)
                        }))
                    })(this.handle).then((t => {
                        this.product = t, this.colorOption = t.options.find((function(t) {
                            return t.name.toLowerCase() === e || null
                        })), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                    }))
                }
            }(t)
        }))
    }
    const Ut = {
            onLoad() {
                jt(this.container), xt(this.container)
            }
        },
        Jt = "[data-custom-scrollbar-items]",
        Qt = "[data-custom-scrollbar]",
        Gt = "[data-custom-scrollbar-track]",
        Yt = "hide",
        Xt = {};
    let Kt = class {
        events() {
            this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)), this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)), document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)), document.addEventListener("theme:resize:width", this.calculatePosition.bind(this))
        }
        calculateTrackWidth() {
            const t = document.createElement("div");
            this.holderItems.prepend(t), t.style.display = "none", t.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer");
            const e = parseInt(getComputedStyle(t).getPropertyValue("width"));
            this.holderItems.firstChild.remove(), this.scrollbarWidth = 0 === this.scrollbar.clientWidth ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth, setTimeout((() => {
                const t = this.children[0].clientWidth,
                    i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                    s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                this.scrollWidth = this.children.length * (t + i + s) + e - i, this.trackWidth = (this.scrollbarWidth + e) / this.scrollWidth * 100, this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth, this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                const o = Math.ceil(this.trackWidth) >= 100;
                this.scrollbar.classList.toggle(Yt, o)
            }), 100)
        }
        calculatePosition() {
            let t = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
            t *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth, t = t < 0 ? 0 : t, t = isNaN(t) ? 0 : t, this.scrollbar.style.setProperty("--position", `${Math.round(t)}px`), document.dispatchEvent(new CustomEvent("theme:scrollbar:scroll", {
                bubbles: !0,
                detail: {
                    holder: this.holderItems
                }
            }))
        }
        constructor(t, e = null) {
            this.holderItems = t.querySelector(Jt), this.scrollbar = t.querySelector(Qt), this.scrollbarTrack = t.querySelector(Gt), this.trackWidth = 0, this.scrollWidth = 0, this.scrollbar && this.holderItems && (this.children = e || this.holderItems.children, this.events(), this.calculateTrackWidth())
        }
    };
    const Zt = {
            onLoad() {
                Xt[this.id] = new Kt(this.container)
            }
        },
        te = "[data-carousel]",
        ee = "data-carousel-progress",
        ie = "[data-carousel-slide]",
        se = "[data-grid-slide]",
        oe = "[data-wrapper]",
        re = "[data-carousel-track]",
        ne = "data-options",
        ae = "data-custom-scrollbar-items",
        le = ".flickity-button.previous",
        ce = ".flickity-button.next",
        he = "data-recently-viewed-products",
        de = "data-related-products",
        ue = "[data-section-id]",
        pe = "flickity-force-arrows-top",
        me = "not-moved-arrows",
        ge = "hide",
        ye = "flickity-enabled",
        fe = "hidden-arrows",
        we = "flickity-static",
        ve = 112;
    let be = class extends HTMLElement {
        connectedCallback() {
            this.carousel = this.container.querySelector(te), this.carouselTrack = this.container.querySelector(re), this.wrapper = this.container.closest(oe), this.section = this.container.closest(ue), this.slidesVisible = null, this.carouselInstance = null, this.carouselPrev = null, this.carouselNext = null, this.customOptions = {}, this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier(), this.carousel && this.carousel.hasAttribute(he) ? this.section.addEventListener("theme:recent-products:added", (() => {
                this.init()
            })) : this.carousel && this.carousel.hasAttribute(de) ? this.section.addEventListener("theme:related-products:added", (() => {
                this.init()
            })) : this.init()
        }
        init() {
            this.carousel && (this.slidesTotal = this.carousel.querySelectorAll(ie).length, this.getGridLayout(), this.trackVisibleSlides(), this.carousel.hasAttribute(ne) && (this.customOptions = JSON.parse(decodeURIComponent(this.carousel.getAttribute(ne)))), this.initCarousel(), this.calculatedArrowsTopPosition(), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent), this.carousel.hasAttribute(ee) && this.progressBarCalculate(), this.carousel.hasAttribute(ae) && new Kt(this.container))
        }
        initCarousel() {
            this.options = {
                accessibility: !0,
                contain: !0,
                freeScroll: !0,
                prevNextButtons: !0,
                wrapArround: !1,
                groupCells: !1,
                autoPlay: !1,
                pageDots: !1,
                cellAlign: window.isRTL ? "right" : "left",
                rightToLeft: window.isRTL,
                dragThreshold: 10,
                arrowShape: {
                    x0: 10,
                    x1: 60,
                    y1: 50,
                    x2: 65,
                    y2: 45,
                    x3: 20
                },
                on: {
                    resize: () => {
                        this.toggleArrows(), this.calculatedArrowsTopPosition(), setTimeout((() => {
                            this.visibleSlides()
                        }), 100)
                    }
                },
                ...this.customOptions
            }, this.carouselInstance = new s(this.carousel, this.options), this.carouselPrev = this.carousel.querySelector(le), this.carouselNext = this.carousel.querySelector(ce), this.container.addEventListener("theme:tab:change", (() => {
                this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(le), this.carouselNext = this.carousel.querySelector(ce)
            })), this.carouselInstance.on("dragStart", (() => {
                this.carouselInstance.slider.style.pointerEvents = "none", mt.isMobile || this.containDrag()
            })), this.carouselInstance.on("dragEnd", (() => {
                this.carouselInstance.slider.style.pointerEvents = "auto", mt.isMobile || this.containDrag()
            })), this.carouselInstance.on("change", (t => this.lockArrows(t))), setTimeout((() => {
                this.visibleSlides()
            }), 100), Shopify.designMode && setTimeout((() => {
                this.carouselInstance.options.watchCSS && !this.carousel.classList.contains(ye) ? (this.carouselInstance.destroy(), this.carouselInstance = new s(this.carousel, this.options), this.carouselInstance.resize(), this.carouselPrev = this.carousel.querySelector(le), this.carouselNext = this.carousel.querySelector(ce)) : this.carouselInstance.resize()
            }), 10), this.carousel.classList.toggle(we, this.smallItems === this.carousel.querySelectorAll(ie).length), jt(this.container), new Q(this.container)
        }
        calculatedArrowsTopPosition() {
            const t = this.container.querySelector(se);
            if (t) {
                const e = t.offsetHeight / 2;
                this.carousel.style.setProperty("--buttons-top", `${e}px`)
            }
        }
        toggleWrapperModifier() {
            if (!this.wrapper) return;
            const t = Number(getComputedStyle(document.documentElement).getPropertyValue("--scrollbar-width").replace("px", "")),
                e = this.wrapper.clientWidth;
            this.wrapperWidthWithGutter = e + ve + t, window.innerWidth >= this.wrapperWidthWithGutter && (this.wrapper.classList.remove(pe), this.section.classList.add(me)), window.innerWidth < this.wrapperWidthWithGutter && (this.wrapper.classList.add(pe), this.section.classList.remove(me))
        }
        progressBarCalculate() {
            null !== this.carouselInstance && this.carouselTrack && this.carouselInstance.on("scroll", (t => {
                t = 100 * Math.max(0, Math.min(1, t)) + "%", this.carouselTrack.style.width = t
            }))
        }
        getGridLayout() {
            this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3, this.mediumItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) || this.largeItems, this.smallItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) || this.mediumItems || this.largeItems
        }
        visibleSlides() {
            if (!this.carousel) return;
            this.getGridLayout();
            const t = this.carousel.clientWidth || this.carouselInstance.size.width,
                e = null !== this.carouselInstance && this.carouselInstance.selectedElement ? this.carouselInstance.selectedElement.clientWidth : this.carousel.querySelector(ie).clientWidth,
                i = null !== this.carouselInstance && this.carouselInstance.slides ? this.carouselInstance.slides.length : this.carousel.querySelectorAll(ie).length,
                s = Math.floor(t / e);
            this.section.classList.remove(fe), this.carouselPrev && this.carouselNext && (this.carouselPrev.classList.remove(ge), this.carouselNext.classList.remove(ge)), window.innerWidth > window.theme.sizes.large && !this.options.groupCells && s <= this.largeItems && i <= this.largeItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth >= window.theme.sizes.medium && window.innerWidth <= window.theme.sizes.large && !this.options.groupCells && s <= this.mediumItems && i <= this.mediumItems && this.carouselPrev && this.carouselNext && this.hideArrows(), window.innerWidth < window.theme.sizes.medium && !this.options.groupCells && s <= this.smallItems && i <= this.smallItems && this.carouselPrev && this.carouselNext && this.hideArrows()
        }
        trackVisibleSlides() {
            const t = window.matchMedia(`(max-width: ${window.theme.sizes.medium-1}px)`),
                e = window.matchMedia(`(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large-1}px)`),
                i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
            t.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.smallItems)
            })), !t.matches || (this.slidesVisible = this.smallItems), e.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.mediumItems)
            })), !e.matches || (this.slidesVisible = this.mediumItems), i.addEventListener("change", (t => {
                !t.matches || (this.slidesVisible = this.largeItems)
            })), !i.matches || (this.slidesVisible = this.largeItems)
        }
        containDrag() {
            const t = this.slidesTotal - this.slidesVisible;
            this.carouselInstance.selectedIndex >= t && (this.carouselInstance.select(t), this.lockArrows(this.carouselInstance.selectedIndex))
        }
        lockArrows(t) {
            if (this.options.wrapAround || this.options.groupCells) return;
            const e = parseInt(t),
                i = this.slidesTotal - this.slidesVisible;
            this.carouselNext.disabled = e >= i
        }
        showArrows() {
            this.carouselPrev.classList.remove(ge), this.carouselNext.classList.remove(ge), this.section.classList.remove(fe)
        }
        hideArrows() {
            this.carouselPrev.classList.add(ge), this.carouselNext.classList.add(ge), this.section.classList.add(fe)
        }
        toggleArrows() {
            this.carouselPrev && this.carouselNext && (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows())
        }
        constructor() {
            super(), this.container = this
        }
    };

    function Se(t, e) {
        e = e || {}, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function i(s) {
            s.target.removeEventListener(s.type, i), void 0 !== e.className && t.classList.remove(e.className)
        }))
    }

    function Ee(t) {
        t = t || {};
        var e = window.location.hash,
            i = document.getElementById(e.slice(1));
        if (i && t.ignore && i.matches(t.ignore)) return !1;
        e && i && Se(i, t)
    }

    function Le(t) {
        return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((function(e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (i = e.hash.substr(1), null === document.getElementById(i)) return !1;
            var i, s = document.querySelector(e.hash);
            return !!s && (e.addEventListener("click", (function() {
                Se(s, t)
            })), !0)
        }))
    }

    function ke(t) {
        return Array.prototype.slice.call(t.querySelectorAll("[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]")).filter((function(t) {
            return Boolean(t.offsetWidth || t.offsetHeight || t.getClientRects().length)
        }))
    }
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", be);
    var Te = {};

    function Ae(t, e) {
        e = e || {};
        var i = ke(t),
            s = e.elementToFocus || t,
            o = i[0],
            r = i[i.length - 1];
        qe(), Te.focusin = function(e) {
            t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(), e.target !== t && e.target !== r && e.target !== o || document.addEventListener("keydown", Te.keydown)
        }, Te.focusout = function() {
            document.removeEventListener("keydown", Te.keydown)
        }, Te.keydown = function(e) {
            "Tab" === e.code && (e.target !== r || e.shiftKey || (e.preventDefault(), o.focus()), e.target !== t && e.target !== o || !e.shiftKey || (e.preventDefault(), r.focus()))
        }, document.addEventListener("focusout", Te.focusout), document.addEventListener("focusin", Te.focusin), Se(s, e)
    }

    function qe() {
        document.removeEventListener("focusin", Te.focusin), document.removeEventListener("focusout", Te.focusout), document.removeEventListener("keydown", Te.keydown)
    }
    var Ce = Object.freeze({
        __proto__: null,
        forceFocus: Se,
        focusHash: Ee,
        bindInPageLinks: Le,
        focusable: ke,
        trapFocus: Ae,
        removeTrapFocus: qe,
        accessibleLinks: function(t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var i, s, o, r = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window."
                    },
                    n = e.prefix || "a11y",
                    a = {
                        newWindow: n + "-new-window-message",
                        external: n + "-external-message",
                        newWindowExternal: n + "-new-window-external-message"
                    };
                t.forEach((function(t) {
                    var e = t.getAttribute("target"),
                        i = t.getAttribute("rel"),
                        s = function(t) {
                            return t.hostname !== window.location.hostname
                        }(t),
                        o = "_blank" === e,
                        r = null === i || -1 === i.indexOf("noopener");
                    if (o && r) {
                        var n = null === i ? "noopener" : i + " noopener";
                        t.setAttribute("rel", n)
                    }
                    s && o ? t.setAttribute("aria-describedby", a.newWindowExternal) : s ? t.setAttribute("aria-describedby", a.external) : o && t.setAttribute("aria-describedby", a.newWindow)
                })), i = r, s = document.createElement("ul"), o = Object.keys(i).reduce((function(t, e) {
                    return t + "<li id=" + a[e] + ">" + i[e] + "</li>"
                }), ""), s.setAttribute("hidden", !0), s.innerHTML = o, document.body.appendChild(s)
            }
        }
    });
    const xe = (t, e) => {
            let i, s;
            return function o(...r) {
                const n = Date.now();
                s = clearTimeout(s), !i || n - i >= e ? (t.apply(null, r), i = n) : s = setTimeout(o.bind(null, ...r), e - (n - i))
            }
        },
        Pe = "[data-size-button]",
        $e = "[data-media-slide]",
        Me = "is-expanded";
    let Ie = class {
        init() {
            this.sizeButtons.forEach((t => {
                t.addEventListener("click", (() => {
                    t.classList.toggle(Me), t.closest($e).classList.toggle(Me)
                }))
            }))
        }
        constructor(t) {
            this.container = t, this.sizeButtons = this.container.querySelectorAll(Pe), this.sizeButtons.length > 0 && this.init()
        }
    };
    const He = "data-quickview",
        De = "data-quickview-holder",
        _e = "[data-product-quickview-ajax]",
        Be = "[data-quickview-modal]",
        Fe = "[data-drawer-scrolls]",
        We = "[data-quickview-modal-template]",
        Oe = "[data-quickview-head]",
        Re = "[data-quickview-form-area]",
        Ne = "[data-toggle-button]",
        ze = "[data-media-slide]",
        Ve = "[data-media-id]",
        je = "data-popup-",
        Ue = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Je = "hide",
        Qe = "is-active",
        Ge = "is-expanded",
        Ye = "loading",
        Xe = 250,
        Ke = 400;
    let Ze = class extends HTMLElement {
        static get observedAttributes() {
            return [He]
        }
        attributeChangedCallback(t, e, i) {
            e && (this.disconnectedCallback(), this.connectedCallback())
        }
        connectedCallback() {
            if (this.quickviewHolder = this.container.querySelector(`[${De}]`), this.modalCloseEvent = () => this.modalClose(), this.clickQuickviewEvent = t => this.clickQuickviewButton(t), this.quickviewHolder) {
                if (this.modalTemplate = this.quickviewHolder.querySelector(We), this.modal = document.querySelector(Be), this.modalID = this.quickviewHolder.getAttribute(De), this.modalContent = null, this.modalScroll = null, this.scrollLockEnable = !0, this.windowH = window.innerHeight, this.triggerButton = this.quickviewHolder.querySelector(`[${je}${this.modalID}]`), this.handle = this.triggerButton ? this.triggerButton.getAttribute(`${je}${this.modalID}`) : null, this.modalTemplate && !this.modal) {
                    const t = this.modalTemplate.innerHTML,
                        e = document.createElement("div");
                    e.innerHTML = t, this.modalHtml = e.querySelector(Be), document.body.appendChild(this.modalHtml), this.modal = document.querySelector(Be)
                }
                this.modalTemplate && this.triggerButton && this.triggerButton.addEventListener("click", this.clickQuickviewEvent)
            }
        }
        clickQuickviewButton(t) {
            t.preventDefault(), this.modal && this.modalID && (this.modal.id = this.modalID), document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1), this.container.classList.add(Ye), this.getQuickviewHTML()
        }
        getQuickviewHTML() {
            window.fetch(`${window.theme.routes.root_url}products/${this.handle}?section_id=api-product-quickview`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.modalContent = this.modal.querySelector(_e), this.modalContent.innerHTML = e.querySelector("[data-api-content]").innerHTML, this.modalScroll = this.modal.querySelector(Fe);
                const i = this.modalContent.querySelector(Ve);
                if (i) {
                    const t = document.createElement("div");
                    t.innerHTML = i.parentElement.innerHTML, this.quickviewHolder.dispatchEvent(new CustomEvent("theme:quickview:media", {
                        bubbles: !0,
                        detail: {
                            media: t
                        }
                    }))
                }
                this.modalCreate(), this.container.classList.remove(Ye)
            }))
        }
        modalCreate() {
            r.show(this.modalID, {
                onShow: (t, e, i) => {
                    this.quickviewHead = t.querySelector(Oe), this.quickviewFormArea = t.querySelector(Re), this.toggleButton = t.querySelector(Ne), this.toggleForm("loading"), document.addEventListener("theme:resize", xe((() => {
                        this.toggleForm("resize")
                    }), 500)), this.clickEventToggleForm();
                    const s = t.querySelector(Ue);
                    Ae(t, {
                        elementToFocus: s
                    }), this.modal.addEventListener("theme:quickview:close", this.modalCloseEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                        bubbles: !0,
                        detail: this.modalScroll
                    })), new Ie(this.modal)
                },
                onClose: (t, e, i) => {
                    t.querySelectorAll(ze).forEach((t => {
                        t.dispatchEvent(new CustomEvent("pause"))
                    })), qe(), e.focus(), this.modal.removeEventListener("theme:quickview:close", this.modalCloseEvent), this.scrollLockEnable ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })) : this.scrollLockEnable = !0
                }
            })
        }
        modalClose() {
            r.close(this.modalID)
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new O({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        toggleForm(t) {
            this.windowH === window.innerHeight && "resize" === t || (this.toggleButton.classList.contains(Je) || this.toggleButton.classList.add(Je), this.quickviewFormArea.classList.contains(Ge) || this.quickviewFormArea.classList.add(Ge), "resize" === t && (this.quickviewFormArea.classList.add(Ge), this.toggleButton.classList.add(Je), this.windowH = window.innerHeight), setTimeout((() => {
                const e = window.innerHeight - this.quickviewHead.offsetHeight - this.quickviewFormArea.offsetHeight,
                    i = e < Xe;
                e < Ke && e > Xe || i ? (this.toggleButton.classList.remove(Je), this.toggleButton.classList.add(Qe)) : this.toggleButton.classList.add(Je), i ? ("loading" === t && (this.quickviewFormArea.classList.add(Ye), setTimeout((() => {
                    this.quickviewFormArea.classList.remove(Ye)
                }), 50)), this.quickviewFormArea.classList.remove(Ge), this.toggleButton.classList.remove(Qe)) : this.quickviewFormArea.classList.add(Ge)
            }), 200))
        }
        clickEventToggleForm() {
            this.toggleButton && this.toggleButton.addEventListener("click", (() => {
                this.toggleButton.classList.toggle(Qe), this.quickviewFormArea.classList.toggle(Ge)
            }))
        }
        disconnectedCallback() {
            this.modalTemplate && this.triggerButton && this.triggerButton.removeEventListener("click", this.clickQuickviewEvent)
        }
        constructor() {
            super(), this.container = this
        }
    };
    const ti = (t, e = 500, i = !0) => {
            let s = window.getComputedStyle(t).display;
            if (i && "none" !== s) return;
            t.style.removeProperty("display"), "none" === s && (s = "block"), t.style.display = s;
            let o = t.offsetHeight;
            t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, t.offsetHeight, t.style.boxSizing = "border-box", t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", t.style.transitionProperty = "height, margin, padding", t.style.transitionDuration = e + "ms", t.style.height = o + "px", t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), window.setTimeout((() => {
                t.style.removeProperty("height"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function")
            }), e)
        },
        ei = (t, e = 500) => {
            t.style.transitionProperty = "height, margin, padding", t.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)", t.style.transitionDuration = e + "ms", t.style.boxSizing = "border-box", t.style.height = t.offsetHeight + "px", t.offsetHeight, t.style.overflow = "hidden", t.style.height = 0, t.style.paddingTop = 0, t.style.paddingBottom = 0, t.style.marginTop = 0, t.style.marginBottom = 0, window.setTimeout((() => {
                t.style.display = "none", t.style.removeProperty("height"), t.style.removeProperty("padding-top"), t.style.removeProperty("padding-bottom"), t.style.removeProperty("margin-top"), t.style.removeProperty("margin-bottom"), t.style.removeProperty("overflow"), t.style.removeProperty("transition-duration"), t.style.removeProperty("transition-property"), t.style.removeProperty("transition-timing-function")
            }), e)
        };

    function ii(t, ...e) {
        e.forEach((e => {
            ! function(t, e) {
                if (!Reflect.has(t.constructor.prototype, e)) throw new Error(`${t} does not define property "${e}"`);
                if (Reflect.getOwnPropertyDescriptor(t.constructor.prototype, e).writable) throw new Error(`${t} does not define property "${e}" as a getter`);
                const i = Reflect.get(t, e);
                Reflect.defineProperty(t, e, {
                    get: () => (void 0 !== i && (Reflect.deleteProperty(t, e), Reflect.defineProperty(t, e, {
                        value: i
                    })), i)
                })
            }(t, e)
        }))
    }
    const si = {
            wrapper: "[data-add-action-wrapper]",
            addButton: "[data-add-to-cart]",
            errorBoundary: "[data-error-boundary]",
            errorDisplay: "[data-error-display]",
            popdown: "[data-product-add-popdown-wrapper]",
            disabledAjax: '[data-ajax-disable="true"]',
            quickviewModal: "[data-quickview-modal]",
            inputFile: '[type="file"]'
        },
        oi = "loading",
        ri = "has-success",
        kly = "hide-kalviyo",
        ni = 3500,
        ai = 5e3;
    let li = class extends HTMLElement {
        connectedCallback() {
            this.button && this.initWithForm()
        }
        get popdown() {
            return document.querySelector(si.popdown)
        }
        get disabledAjax() {
            return document.querySelector(si.disabledAjax)
        }
        get button() {
            return this.wrapper.querySelector(si.addButton)
        }
        get errors() {
            const t = this.wrapper.querySelector(si.errors);
            if (!t) {
                const t = this.wrapper.closest(si.errorBoundary);
                if (t) return t.querySelector(si.errorDisplay)
            }
            return t
        }
        initWithForm() {
            this.button.addEventListener("click", function(t) {
                t.preventDefault();
                const e = t.target.closest("form");
                if (e.querySelector(si.inputFile)) return;
                this.disabledAjax || t.preventDefault(), this.button.setAttribute("disabled", !0), this.button.classList.add(oi), this.button.classList.add(kly);
                var productForm = new FormData(e);
                if (!productForm.get("selling_plan")) {
                    const selectedSellingPlanEl = document.querySelector('.yotpo-selected [name="selling_plan"]');
                    const sellingPlanId = selectedSellingPlanEl && selectedSellingPlanEl.value ? selectedSellingPlanEl.value : '';
                    productForm.append("selling_plan", sellingPlanId);
                }
                const i = productForm,
                    s = new URLSearchParams(i).toString();
                this.addToCartAction(s)
            }.bind(this))
        }
        addToCartAction(t) {
            const e = `${window.theme.routes.cart}/add.js`,
                i = this;
            n.post(e, t, {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }).then((function(t) {
                i.onSuccess(t.data)
            })).catch((function(t) {
                console.warn(t), i.onError(t.data)
            }))
        }
        onSuccess(t) {
            this.updateHeaderTotal(), this.button.classList.remove(oi), this.button.classList.add(ri), setTimeout((() => {
                this.button.classList.remove(kly), this.button.classList.remove(ri), this.button.removeAttribute("disabled")
            }), ni), this.button.closest(si.quickviewModal) && this.button.closest(si.quickviewModal).dispatchEvent(new CustomEvent("theme:quickview:close")), window.theme.state.cartOpen ? document.dispatchEvent(new CustomEvent("theme:cart:reload", {
                bubbles: !0
            })) : this.popdown.dispatchEvent(new CustomEvent("theme:cart:popdown", {
                detail: {
                    variant: t
                },
                bubbles: !0
            })), this.disabledAjax && window.location.reload()
        }
        onError(t) {
            let e = "Network error: please try again";
            t && t.description && (e = t.description);
            const i = `<div class="errors">${e}</div>`;
            this.button.classList.remove(oi), this.button.removeAttribute("disabled"), this.errors.innerHTML = i, ti(this.errors), setTimeout((() => {
                ei(this.errors)
            }), ai)
        }
        updateHeaderTotal() {
            n.get(`${window.theme.routes.cart}.js`).then((t => {
                document.dispatchEvent(new CustomEvent("theme:cart:change", {
                    detail: {
                        cart: t.data
                    },
                    bubbles: !0
                }))
            })).catch((t => {
                console.error(t)
            }))
        }
        constructor() {
            super(), this.wrapper = this, ii(this, "popdown", "button")
        }
    };
    customElements.get("") || customElements.define("product-quickview", Ze), customElements.get("product-add-button") || customElements.define("product-add-button", li);
    const ci = "[data-address-wrapper]",
        hi = "[data-new-address-form]",
        di = "[new-address-form-inner]",
        ui = ".address-new-toggle",
        pi = ".address-edit-toggle",
        mi = ".address-delete",
        gi = "hide",
        yi = "data-form-id",
        fi = "data-confirm-message",
        wi = "Are you sure you wish to delete this address?",
        vi = "#EditAddress",
        bi = "AddressCountryNew",
        Si = "AddressProvinceNew",
        Ei = "AddressProvinceContainerNew",
        Li = ".address-country-option",
        ki = "AddressCountry",
        Ti = "AddressProvince",
        Ai = "AddressProvinceContainer";
    const qi = document.querySelector(ci);
    qi && new class {
        init() {
            if (this.addressNewForm) {
                const t = this.section,
                    e = this.addressNewForm.querySelector(di);
                this.customerAddresses();
                const i = t.querySelectorAll(ui);
                i.length && i.forEach((t => {
                    t.addEventListener("click", (function() {
                        e.classList.toggle(gi)
                    }))
                }));
                const s = t.querySelectorAll(pi);
                s.length && s.forEach((e => {
                    e.addEventListener("click", (function() {
                        const e = this.getAttribute(yi);
                        t.querySelector(`${vi}_${e}`).classList.toggle(gi)
                    }))
                }));
                const o = t.querySelectorAll(mi);
                o.length && o.forEach((t => {
                    t.addEventListener("click", (function() {
                        const t = this.getAttribute(yi),
                            e = this.getAttribute(fi);
                        confirm(e || wi) && Shopify.postLink(window.theme.routes.account_addresses_url + "/" + t, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(bi, Si, {
                hideElement: Ei
            }), this.section.querySelectorAll(Li).forEach((t => {
                const e = t.getAttribute(yi),
                    i = `${ki}_${e}`,
                    s = `${Ti}_${e}`,
                    o = `${Ai}_${e}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: o
                })
            }))
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector(hi), this.init()
        }
    }(qi), document.querySelector("#RecoverPassword") && function() {
        var t = {
            recoverPasswordForm: "#RecoverPassword",
            hideRecoverPasswordLink: "#HideRecoverPasswordLink"
        };

        function e(t) {
            t.preventDefault(), s()
        }

        function i() {
            "#recover" === window.location.hash && s()
        }

        function s() {
            var t = document.querySelector("#CustomerEmail").value;
            document.querySelector("#RecoverEmail").value = t, document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"), document.querySelector("#CustomerLoginForm").classList.toggle("display-none")
        }

        function o() {
            document.querySelector(".reset-password-success") && document.querySelector("#ResetSuccess").classList.remove("display-none")
        }
        i(), o(), document.querySelector(t.recoverPasswordForm).addEventListener("click", e), document.querySelector(t.hideRecoverPasswordLink).addEventListener("click", e)
    }(), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const Ci = window.Shopify.theme.sections.registered,
        xi = window.Shopify.theme.sections.instances,
        Pi = "data-section-id",
        $i = "data-section-type";
    let Mi = class {
        callFunctions(t, e = null) {
            this.callStack[t].forEach((t => {
                const i = {
                    id: this.id,
                    type: this.type,
                    container: this.container
                };
                e ? t.call(i, e) : t.call(i)
            }))
        }
        onLoad() {
            this.callFunctions("onLoad")
        }
        onUnload() {
            this.callFunctions("onUnload")
        }
        onSelect(t) {
            this.callFunctions("onSelect", t)
        }
        onDeselect(t) {
            this.callFunctions("onDeselect", t)
        }
        onBlockSelect(t) {
            this.callFunctions("onBlockSelect", t)
        }
        onBlockDeselect(t) {
            this.callFunctions("onBlockDeselect", t)
        }
        onReorder(t) {
            this.callFunctions("onReorder", t)
        }
        constructor(t, e) {
            this.container = function(t) {
                if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                if (null === t.getAttribute(Pi)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + Pi + " attribute.");
                return t
            }(t), this.id = t.getAttribute(Pi), this.type = e.type, this.callStack = e.getStack();
            try {
                this.onLoad()
            } catch (t) {
                console.warn(`Error in section: ${this.id}`), console.warn(this), console.error(t)
            }
        }
    };

    function Ii(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== Ci[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, i] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i))
                    }
                }))
            }
        }(t, e);
        return Ci[t] = i, Ci
    }

    function Hi(t, e) {
        t = Bi(t), void 0 === e && (e = document.querySelectorAll("[" + $i + "]")), e = Fi(e), t.forEach((function(t) {
            const i = Ci[t];
            void 0 !== i && (e = e.filter((function(e) {
                return !(Di(e).length > 0) && (null !== e.getAttribute($i) && (e.getAttribute($i) !== t || (xi.push(new Mi(e, i)), !1)))
            })))
        }))
    }

    function Di(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element) Fi(t).forEach((function(t) {
            e = e.concat(xi.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof i) {
            Bi(t).forEach((function(t) {
                e = e.concat(xi.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function _i(t) {
        for (var e, i = 0; i < xi.length; i++)
            if (xi[i].id === t) {
                e = xi[i];
                break
            } return e
    }

    function Bi(t) {
        return "*" === t ? t = Object.keys(Ci) : "string" == typeof t ? t = [t] : t.constructor === Mi ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === Mi && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function Fi(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Pi + '="' + e + '"]');
        null !== i && Hi(i.getAttribute($i), i)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Pi + '="' + e + '"]');
        "object" == typeof Di(i)[0] && Di(i).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + Pi + '="' + e + '"]');
        "object" == typeof Di(i)[0] && Di(i).forEach((function(t) {
            var e = xi.map((function(t) {
                return t.id
            })).indexOf(t.id);
            xi.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = _i(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const Wi = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])';

    function Oi(t) {
        const e = `data-popup-${t}`;
        r.init({
            openTrigger: e,
            disableScroll: !0,
            onShow: (t, e, i) => {
                i.preventDefault();
                const s = t.querySelector(Wi);
                Ae(t, {
                    elementToFocus: s
                })
            },
            onClose: (t, e, i) => {
                i.preventDefault(), qe(), e.focus()
            }
        })
    }
    const Ri = "[data-toggle-password-modal]",
        Ni = ".storefront-password-form .errors",
        zi = {};
    Ii("password", {
        onLoad() {
            zi[this.id] = new class {
                init() {
                    Oi("password"), this.errors && this.trigger.click()
                }
                constructor(t) {
                    this.container = t.container, this.trigger = this.container.querySelector(Ri), this.errors = this.container.querySelector(Ni), this.init()
                }
            }(this)
        }
    }),
        function() {
            var t = "#QrCode",
                e = ".giftcard__code";
            const i = document.querySelector(t);
            if (i) {
                function o() {
                    const t = i.getAttribute("data-identifier");
                    new QRCode(i, {
                        text: t,
                        width: 120,
                        height: 120
                    })
                }
                window.addEventListener("load", o)
            }
            const s = document.querySelector(e);
            if (s) {
                function r() {
                    var t = document.querySelector("#GiftCardDigits"),
                        e = "";
                    if (document.body.createTextRange)(e = document.body.createTextRange()).moveToElementText(t), e.select();
                    else if (window.getSelection) {
                        var i = window.getSelection();
                        (e = document.createRange()).selectNodeContents(t), i.removeAllRanges(), i.addRange(e)
                    }
                }
                s.addEventListener("click", r())
            }
        }();
    const Vi = "[data-parallax-wrapper]",
        ji = "[data-parallax-img]";
    let Ui = {};
    const Ji = {
        onLoad() {
            Ui[this.id] = [];
            this.container.querySelectorAll(Vi).forEach((t => {
                const e = t.querySelector(ji);
                Ui[this.id].push(new a(e, {
                    center: !0,
                    round: !0,
                    frame: t
                }))
            }))
        },
        onUnload: function() {
            Ui[this.id].forEach((t => {
                "function" == typeof t.destroy && t.destroy()
            }))
        }
    };
    Ii("article", Ji);
    const Qi = "[data-ticker-frame]",
        Gi = "[data-ticker-scale]",
        Yi = "[data-ticker-text]",
        Xi = "data-clone",
        Ki = "ticker--animated",
        Zi = "ticker--unloaded",
        ts = "ticker__comparitor",
        es = 1.63,
        is = 100,
        ss = {};
    let os = class {
        unload() {
            document.removeEventListener("theme:resize", this.resizeEvent)
        }
        listen() {
            document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth()
        }
        checkWidth() {
            const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
            if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                if (this.text.classList.add(Ki), 1 === this.scale.childElementCount && (this.clone = this.text.cloneNode(!0), this.clone.setAttribute("aria-hidden", !0), this.clone.setAttribute(Xi, ""), this.scale.appendChild(this.clone), this.stopClone))
                    for (let t = 0; t < 10; t++) {
                        const t = this.text.cloneNode(!0);
                        t.setAttribute("aria-hidden", !0), t.setAttribute(Xi, ""), this.scale.appendChild(t)
                    }
                const t = this.text.clientWidth / is * es;
                this.scale.style.setProperty("--animation-time", `${t}s`)
            } else {
                this.text.classList.add(Ki);
                let t = this.scale.querySelector(`[${Xi}]`);
                t && this.scale.removeChild(t), this.text.classList.remove(Ki)
            }
        }
        constructor(t, e = !1) {
            this.frame = t, this.stopClone = e, this.scale = this.frame.querySelector(Gi), this.text = this.frame.querySelector(Yi), this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(ts), this.frame.appendChild(this.comparitor), this.scale.classList.remove(Zi), this.resizeEvent = k((() => this.checkWidth()), 300), this.listen()
        }
    };
    const rs = {
            onLoad() {
                ss[this.id] = [];
                this.container.querySelectorAll(Qi).forEach((t => {
                    ss[this.id].push(new os(t))
                }))
            },
            onUnload() {
                ss[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        ns = "data-slider-speed",
        as = "data-slide",
        ls = "data-slide-index";
    const cs = "[data-cart-message]",
        hs = "data-cart-message",
        ds = "[data-left-to-spend]",
        us = "[data-cart-progress]",
        ps = "data-limit",
        ms = "data-percent",
        gs = "is-success";
    let ys = class {
        init() {
            this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(ps)) * this.rate, this.shippingAmount = 0, this.circumference = 28 * Math.PI, this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(), this.listen()
        }
        listen() {
            document.addEventListener("theme:cart:change", function(t) {
                this.cart = t.detail.cart, this.render()
            }.bind(this))
        }
        render() {
            const t = this.cart.total_price;
            this.freeShippingMessageHandle(t), this.cart && this.cart.total_price && this.cartMessage.length > 0 && (this.shippingAmount = t, this.updateProgress())
        }
        freeShippingMessageHandle(t) {
            this.cartMessage.length > 0 && this.container.querySelectorAll(cs).forEach((e => {
                const i = e.hasAttribute(hs) && "true" === e.getAttribute(hs) && t >= this.cartFreeLimitShipping && 0 !== t;
                e.classList.toggle(gs, i)
            }))
        }
        cartBarProgress(t = null) {
            this.container.querySelectorAll(us).forEach((e => {
                this.setProgress(e, null === t ? e.getAttribute(ms) : t)
            }))
        }
        setProgress(t, e) {
            const i = this.circumference - e / 100 * this.circumference / 2;
            t.style.strokeDashoffset = i
        }
        updateProgress() {
            const t = this.shippingAmount / this.cartFreeLimitShipping * 100;
            this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount), this.cartBarProgress(t > 100 ? 100 : t)
        }
        exchangeRateConversions(t, e) {
            const i = theme.settings.currency_code_enable ? l.formatMoney(t - e, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t - e, theme.moneyFormat);
            this.container.querySelectorAll(ds).forEach((t => {
                t.innerHTML = i.replace(".00", "")
            }))
        }
        constructor(t) {
            this.container = t, this.cartMessage = this.container.querySelectorAll(cs), this.rate = window.Shopify.currency.rate, this.cartMessage.length > 0 && this.init()
        }
    };
    const fs = "[data-bar]",
        ws = "[data-slide]",
        vs = "[data-ticker-frame]",
        bs = "[data-announcement-slider]",
        Ss = "data-slide",
        Es = "[data-ticker-scale]",
        Ls = "[data-ticker-text]",
        ks = "data-target-referrer",
        Ts = "data-slide",
        As = "mobile",
        qs = "desktop",
        Cs = "ticker--animated",
        xs = {};
    Ii("announcement", {
        onLoad() {
            xs[this.id] = [], xs[this.id].push(new class {
                init() {
                    this.removeAnnouncement(), this.slider ? this.slider && this.slides && this.slides.length > 1 ? this.initSliders() : this.initTickers() : this.initTickers(!0)
                }
                removeAnnouncement() {
                    for (let t = 0; t < this.slides.length; t++) {
                        const e = this.slides[t];
                        e.hasAttribute(ks) && (-1 !== this.locationPath.indexOf(e.getAttribute(ks)) || window.Shopify.designMode || e.parentNode.removeChild(e))
                    }
                }
                initSliders() {
                    this.slider = new class {
                        init() {
                            const t = {
                                initialIndex: 0,
                                autoPlay: this.speed,
                                contain: !0,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                wrapAround: !0,
                                groupCells: !1,
                                cellAlign: "left",
                                freeScroll: !1,
                                prevNextButtons: !0,
                                draggable: !0,
                                rightToLeft: window.isRTL,
                                on: {
                                    ready: () => {
                                        setTimeout((() => {
                                            this.slideshow.dispatchEvent(new CustomEvent("theme:announcement:loaded", {
                                                bubbles: !0,
                                                detail: {
                                                    slider: this
                                                }
                                            }))
                                        }), 50)
                                    }
                                }
                            };
                            this.flkty = new s(this.slideshow, t), this.flkty && (document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:scroll", this.scrollEvent))
                        }
                        resizeEvents() {
                            this.flkty.resize()
                        }
                        scrollEvents() {
                            if (this.flkty && this.speed) {
                                const t = this.flkty.element,
                                    e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                                window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
                            }
                        }
                        onUnload() {
                            this.slideshow && this.flkty && (document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty.options.watchCSS = !1, this.flkty.destroy())
                        }
                        onBlockSelect(t) {
                            if (!this.slideshow) return;
                            const e = this.slideshow.querySelector(`[${as}="${t.detail.blockId}"]`);
                            if (!e) return;
                            const i = parseInt(e.getAttribute(ls));
                            this.flkty.selectCell(i), this.flkty.stopPlayer()
                        }
                        onBlockDeselect() {
                            this.flkty.playPlayer()
                        }
                        constructor(t, e) {
                            this.container = t, this.slideshow = e;
                            const i = this.slideshow.getAttribute(ns);
                            this.speed = !!i && parseInt(i), this.scrollEvent = () => this.scrollEvents(), this.resizeEvent = () => this.resizeEvents(), this.slideshow && (this.flkty = null, this.init())
                        }
                    }(this.container, this.slider), this.slider.flkty.reposition(), this.barHolder.addEventListener("theme:announcement:loaded", (() => {
                        this.initTickers()
                    }))
                }
                initTickers(t = !1) {
                    const e = this.barHolder.querySelector(vs);
                    e && new os(e, t)
                }
                toggleTicker(t, e) {
                    const i = document.querySelector(Es),
                        s = document.querySelector(`[${Ss}="${t.detail.blockId}"]`);
                    e && s && (i.setAttribute("data-stop", ""), i.querySelectorAll(Ls).forEach((t => {
                        t.classList.remove(Cs), t.style.transform = `translate3d(${-(s.offsetLeft-s.clientWidth)}px, 0, 0)`
                    }))), !e && s && (i.querySelectorAll(Ls).forEach((t => {
                        t.classList.add(Cs), t.removeAttribute("style")
                    })), i.removeAttribute("data-stop"))
                }
                onBlockSelect(t) {
                    this.slider && "function" == typeof this.slider.onBlockSelect ? this.slider.onBlockSelect(t) : (document.querySelectorAll(`[${Ts}="${t.detail.blockId}"]`).forEach((t => {
                        t.classList.contains(As) && (this.hasDeviceClass = As), t.classList.contains(qs) && (this.hasDeviceClass = qs), "" !== this.hasDeviceClass && t.classList.remove(this.hasDeviceClass)
                    })), this.toggleTicker(t, !0))
                }
                onBlockDeselect(t) {
                    this.slider && "function" == typeof this.slider.onBlockDeselect ? this.slider.onBlockDeselect(t) : ("" !== this.hasDeviceClass && document.querySelectorAll(`[${Ts}="${t.detail.blockId}"]`).forEach((t => {
                        t.classList.add(this.hasDeviceClass)
                    })), this.toggleTicker(t, !1))
                }
                onUnload() {
                    this.slider && "function" == typeof this.slider.onUnload && this.slider.onUnload()
                }
                constructor(t) {
                    this.container = t.container, this.barHolder = this.container.querySelector(fs), this.locationPath = location.href, this.slides = this.barHolder.querySelectorAll(ws), this.slider = this.barHolder.querySelector(bs), this.hasDeviceClass = "", new ys(this.container), this.init()
                }
            }(this))
        },
        onUnload() {
            xs[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            xs[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            xs[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
            }))
        }
    });
    const Ps = "[data-ticker-frame]",
        $s = "data-slide",
        Ms = "[data-ticker-scale]",
        Is = "[data-ticker-text]",
        Hs = "ticker--animated",
        Ds = {};
    Ii("logos", {
        onLoad() {
            Ds[this.id] = [], Ds[this.id].push(new class {
                init() {
                    this.initTickers(!0)
                }
                initTickers(t = !1) {
                    const e = this.container.querySelector(Ps);
                    e && new os(e, t)
                }
                toggleTicker(t, e) {
                    const i = this.container.querySelector(Ms),
                        s = this.container.querySelector(`[${$s}="${t.detail.blockId}"]`);
                    e && s && i && (i.setAttribute("data-stop", ""), i.querySelectorAll(Is).forEach((t => {
                        t.classList.remove(Hs), t.style.transform = `translate3d(${-(s.offsetLeft-s.clientWidth)}px, 0, 0)`
                    }))), !e && s && i && (i.querySelectorAll(Is).forEach((t => {
                        t.classList.add(Hs), t.removeAttribute("style")
                    })), i.removeAttribute("data-stop"))
                }
                onBlockSelect(t) {
                    this.toggleTicker(t, !0)
                }
                onBlockDeselect(t) {
                    this.toggleTicker(t, !1)
                }
                constructor(t) {
                    this.container = t.container, this.init()
                }
            }(this))
        },
        onBlockSelect(t) {
            Ds[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Ds[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
            }))
        }
    }), Ii("blog", Ji);
    var _s = "[data-drawer]",
        Bs = "[data-drawer-scrolls]",
        Fs = "[data-predictive-search-input]",
        Ws = "[data-drawer-underlay]",
        Os = "[data-stagger-animation]",
        Rs = "data-drawer-toggle",
        Ns = ":scope > * > [data-animates]",
        zs = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        Vs = "drawer--visible",
        js = "display-none",
        Us = {};
    const Js = {
            onLoad() {
                Us[this.id] = [];
                this.container.querySelectorAll(_s).forEach((t => {
                    Us[this.id].push(new class {
                        unload() {}
                        connectToggle() {
                            this.buttons.forEach((t => {
                                t.addEventListener("click", function(t) {
                                    t.preventDefault(), this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", {
                                        bubbles: !1
                                    }))
                                }.bind(this))
                            }))
                        }
                        connectDrawer() {
                            this.drawer.addEventListener("theme:drawer:toggle", function() {
                                this.drawer.classList.contains(Vs) ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", {
                                    bubbles: !1
                                })) : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                    bubbles: !1
                                }))
                            }.bind(this)), this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)), this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this))
                        }
                        staggerChildAnimations() {
                            this.staggers.forEach((t => {
                                t.querySelectorAll(Ns).forEach(((t, e) => {
                                    t.style.transitionDelay = 50 * e + 10 + "ms"
                                }))
                            }))
                        }
                        closers() {
                            this.drawer.addEventListener("keyup", function(t) {
                                "Escape" === t.code && (this.hideDrawer(), this.buttons[0].focus())
                            }.bind(this)), this.underlay.addEventListener("click", function() {
                                this.hideDrawer()
                            }.bind(this))
                        }
                        focusFirst() {
                            const t = this.drawer.querySelector(Fs);
                            if (t) t.focus();
                            else {
                                const t = this.drawer.querySelector(zs);
                                Ae(this.drawer, {
                                    elementToFocus: t
                                })
                            }
                        }
                        showDrawer() {
                            this.drawer.classList.remove(js), setTimeout((() => {
                                this.buttons.forEach((t => t.setAttribute("aria-expanded", !0))), this.drawer.classList.add(Vs), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0,
                                    detail: this.drawerScrolls
                                })), this.drawer.addEventListener("transitionend", this.focusFirst.bind(this), {
                                    once: !0
                                }), this.drawer.addEventListener("transitioncancel", this.focusFirst.bind(this), {
                                    once: !0
                                })
                            }), 1)
                        }
                        hideDrawer() {
                            this.buttons.forEach((t => t.setAttribute("aria-expanded", !0))), this.drawer.classList.remove(Vs), this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            })), document.dispatchEvent(new CustomEvent("theme:sliderule:close", {
                                bubbles: !1
                            })), qe(), setTimeout((() => {
                                this.drawer.classList.contains(Vs) || this.drawer.classList.add(js)
                            }), 800)
                        }
                        constructor(t) {
                            this.drawer = t, this.drawerScrolls = this.drawer.querySelector(Bs), this.underlay = this.drawer.querySelector(Ws), this.key = this.drawer.dataset.drawer;
                            const e = `[${Rs}='${this.key}']`;
                            this.buttons = document.querySelectorAll(e), this.staggers = this.drawer.querySelectorAll(Os), this.connectToggle(), this.connectDrawer(), this.closers(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onUnload: function() {
                Us[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Qs = "#shopify-section-announcement",
        Gs = "data-header-transparent",
        Ys = "[data-header-wrapper] header",
        Xs = "js__header__stuck",
        Ks = "js__header__stuck--animated",
        Zs = "js__header__stuck--trigger-animation",
        to = "js__header__stuck__backdrop";
    let eo = {};
    const io = {
            onLoad() {
                eo = new class {
                    unload() {
                        document.removeEventListener("theme:scroll", this.listen), document.removeEventListener("theme:scroll:up", this.scrollUpDirectional), document.removeEventListener("theme:scroll:down", this.scrollDownDirectional)
                    }
                    listen() {
                        (this.sticks || this.animated) && document.addEventListener("theme:scroll", (t => {
                            t.detail.down ? (!this.currentlyStuck && t.detail.position > this.stickDown && this.stickSimple(), !this.currentlyBlurred && t.detail.position > this.blur && this.addBlur()) : (t.detail.position <= this.stickUp && this.unstickSimple(), t.detail.position <= this.blur && this.removeBlur())
                        })), this.animated && (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)), document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)))
                    }
                    stickSimple() {
                        this.animated && this.cls.add(Ks), this.cls.add(Xs), this.wrapper.setAttribute(Gs, !1), this.currentlyStuck = !0
                    }
                    unstickSimple() {
                        this.cls.remove(Xs), this.wrapper.setAttribute(Gs, this.transparent), this.animated && this.cls.remove(Ks), this.currentlyStuck = !1
                    }
                    scrollDownInit() {
                        window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur()
                    }
                    stickDirectional() {
                        this.cls.add(Zs)
                    }
                    unstickDirectional() {
                        this.cls.remove(Zs)
                    }
                    scrollDownDirectional() {
                        this.unstickDirectional()
                    }
                    scrollUpDirectional() {
                        window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional()
                    }
                    addBlur() {
                        this.cls.add(to), this.currentlyBlurred = !0
                    }
                    removeBlur() {
                        this.cls.remove(to), this.currentlyBlurred = !1
                    }
                    constructor(t) {
                        this.wrapper = t, this.type = this.wrapper.dataset.headerSticky, this.transparent = this.wrapper.dataset.headerTransparent, this.sticks = "sticky" === this.type, this.animated = "directional" === this.type, this.currentlyStuck = !1, this.cls = this.wrapper.classList;
                        const e = document.querySelector(Qs),
                            i = e ? e.clientHeight : 0,
                            s = document.querySelector(Ys).clientHeight;
                        this.blur = s + i, this.stickDown = s + i, this.stickUp = i, "false" !== this.wrapper.getAttribute(Gs) && (this.blur = i), this.sticks && (this.stickDown = i, this.scrollDownInit()), this.listen()
                    }
                }(this.container)
            },
            onUnload: function() {
                "function" == typeof eo.unload && eo.unload()
            }
        },
        so = "data-hover-disclosure-toggle",
        oo = "[data-hover-disclosure]",
        ro = "[data-top-link]",
        no = "[data-header-wrapper]",
        ao = "[data-stagger]",
        lo = "[data-stagger-first]",
        co = "[data-stagger-second]",
        ho = "[data-grid-item], [data-header-image]",
        uo = "is-visible",
        po = "meganav--visible",
        mo = "grandparent";
    let go = {},
        yo = {};
    const fo = {
            onLoad() {
                go[this.id] = [], yo = this.container.querySelectorAll(oo), yo.forEach((t => {
                    go[this.id].push(new class {
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure()
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        showDisclosure() {
                            this.grandparent ? this.wrapper.classList.add(po) : this.wrapper.classList.remove(po), this.trigger.setAttribute("aria-expanded", !0), this.trigger.classList.add(uo), this.disclosure.classList.add(uo)
                        }
                        hideDisclosure() {
                            this.disclosure.classList.remove(uo), this.trigger.classList.remove(uo), this.trigger.setAttribute("aria-expanded", !1), this.wrapper.classList.remove(po)
                        }
                        staggerChildAnimations() {
                            this.disclosure.querySelectorAll(ao).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            })), this.disclosure.querySelectorAll(lo).forEach(((t, e) => {
                                const i = 150 * e;
                                t.style.transitionDelay = `${i}ms`, t.parentElement.querySelectorAll(co).forEach(((t, e) => {
                                    const s = 20 * (e + 1);
                                    t.style.transitionDelay = `${i+s}ms`
                                }))
                            })), this.disclosure.querySelectorAll(ho).forEach(((t, e) => {
                                t.style.transitionDelay = 80 * (e + 1) + "ms"
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", function(t) {
                                this.disclosure.classList.contains(uo) || (t.preventDefault(), this.showDisclosure())
                            }.bind(this), {
                                passive: !0
                            })
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("pointerenter", this.showDisclosure.bind(this)), this.link.addEventListener("focus", this.showDisclosure.bind(this)), this.trigger.addEventListener("pointerleave", this.hideDisclosure.bind(this)), this.trigger.addEventListener("focusout", function(t) {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            }.bind(this)), this.disclosure.addEventListener("keyup", function(t) {
                                "Escape" === t.code && this.hideDisclosure()
                            }.bind(this))
                        }
                        constructor(t) {
                            this.disclosure = t, this.wrapper = t.closest(no), this.key = this.disclosure.id;
                            const e = `[${so}='${this.key}']`;
                            this.trigger = document.querySelector(e), this.link = this.trigger.querySelector(ro), this.grandparent = this.trigger.classList.contains(mo), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.connectHoverToggle(), this.handleTablets(), this.staggerChildAnimations()
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                go[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                go[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            },
            onUnload: function() {
                go[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        wo = "[data-main-menu-text-item]",
        vo = "[data-text-items-wrapper]",
        bo = ".navtext",
        So = "data-menu-active",
        Eo = "[data-header-wrapper]",
        Lo = "data-underline-current",
        ko = ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext";
    let To = {},
        Ao = null;
    const qo = {
            onLoad() {
                To[this.id] = [];
                this.container.querySelectorAll(vo).forEach((t => {
                    To[this.id].push(new class {
                        init() {
                            if (this.itemList.length) {
                                if (this.listen(), this.listenResize(), this.textBottom = null, this.setHeight(), Ao) {
                                    if (this.defaultItem) {
                                        const t = this.defaultItem.offsetLeft || 0;
                                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`)
                                    }
                                    this.reset()
                                } else {
                                    const t = this.sectionOuter.querySelector(wo).offsetLeft;
                                    this.sectionOuter.style.setProperty("--bar-left", `${t}px`), this.sectionOuter.style.setProperty("--bar-width", "0px")
                                }
                                this.sectionOuter.style.setProperty("--bar-opacity", "1")
                            }
                        }
                        unload() {
                            document.removeEventListener("theme:resize", this.reset), Ao = null
                        }
                        listenResize() {
                            document.addEventListener("theme:resize", this.reset.bind(this))
                        }
                        setDefault() {
                            this.defaultItem && (Ao = {
                                left: this.defaultItem.offsetLeft || null,
                                width: this.defaultItem.clientWidth || null
                            })
                        }
                        setHeight() {
                            const t = this.wrapper.clientHeight,
                                e = this.itemList[0].querySelector(bo).clientHeight,
                                i = Math.floor(t / 2 - e / 2) - 4;
                            this.textBottom !== i && (this.sectionOuter.style.setProperty("--bar-text", `${e}px`), this.sectionOuter.style.setProperty("--bar-bottom", `${i}px`), this.textBottom = i)
                        }
                        listen() {
                            this.itemList.forEach((t => {
                                t.addEventListener("pointerenter", (t => {
                                    const e = t.target.querySelector(bo);
                                    this.startBar(e)
                                }))
                            })), this.wrapper.addEventListener("pointerleave", this.clearBar.bind(this))
                        }
                        startBar(t) {
                            this.setHeight();
                            let e = "false" !== this.sectionOuter.getAttribute(So),
                                i = t.offsetLeft,
                                s = t.clientWidth;
                            e ? this.render(s, i) : (this.sectionOuter.setAttribute(So, !0), this.render(0, i), setTimeout((() => {
                                this.render(s, i)
                            }), 10))
                        }
                        render(t, e) {
                            this.sectionOuter.style.setProperty("--bar-left", `${e}px`), this.sectionOuter.style.setProperty("--bar-width", `${t}px`)
                        }
                        reset() {
                            this.setDefault(), Ao && Ao.left && Ao.width ? (this.sectionOuter.style.setProperty("--bar-left", `${Ao.left}px`), this.sectionOuter.style.setProperty("--bar-width", `${Ao.width}px`)) : this.sectionOuter.style.setProperty("--bar-width", "0px")
                        }
                        clearBar() {
                            this.sectionOuter.setAttribute(So, !1), setTimeout((() => {
                                "false" !== this.sectionOuter.getAttribute(So) || this.reset()
                            }), 150)
                        }
                        constructor(t) {
                            this.wrapper = t, this.itemList = this.wrapper.querySelectorAll(wo), this.sectionOuter = document.querySelector(Eo), this.underlineCurrent = "true" === this.sectionOuter.getAttribute(Lo), this.defaultItem = null, this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(ko)), this.setDefault(), document.fonts.ready.then((() => {
                                this.init()
                            }))
                        }
                    }(t))
                }))
            },
            onUnload: function() {
                To[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                })), delete To[this.id]
            }
        },
        Co = "data-header-cart-price",
        xo = "data-header-cart-count",
        Po = "data-header-cart-full";
    const $o = {
            onLoad() {
                new class {
                    listen() {
                        document.addEventListener("theme:cart:change", function(t) {
                            this.cart = t.detail.cart, this.update()
                        }.bind(this))
                    }
                    update() {
                        this.cart && (this.prices.forEach((t => {
                            t.setAttribute(Co, this.cart.total_price);
                            const e = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                            t.innerHTML = e
                        })), this.counts.forEach((t => {
                            t.setAttribute(xo, this.cart.item_count), t.innerHTML = `${this.cart.item_count}`
                        })), this.dots.forEach((t => {
                            const e = this.cart.item_count > 0;
                            t.setAttribute(Po, e)
                        })))
                    }
                    constructor(t) {
                        this.section = t, this.counts = this.section.querySelectorAll(`[${xo}]`), this.prices = this.section.querySelectorAll(`[${Co}]`), this.dots = this.section.querySelectorAll(`[${Po}]`), this.cart = null, this.listen()
                    }
                }(this.container)
            }
        },
        Mo = "[data-search-popdown-wrap]",
        Io = "data-popdown-toggle",
        Ho = "[data-close-popdown]",
        Do = "[data-predictive-search-input]",
        _o = "[data-search-underlay]",
        Bo = "underlay--visible",
        Fo = "is-visible";
    let Wo = {};
    const Oo = {
            onLoad() {
                Wo[this.id] = {};
                const t = this.container.querySelector(`[${Io}]`);
                t && (Wo[this.id] = new class {
                    initTriggerEvents() {
                        this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.trigger.addEventListener("click", function(t) {
                            t.preventDefault(), this.showPopdown()
                        }.bind(this)), this.trigger.addEventListener("keyup", function(t) {
                            "Space" === t.code && this.showPopdown()
                        }.bind(this))
                    }
                    initPopdownEvents() {
                        this.popdown.addEventListener("keyup", function(t) {
                            "Escape" === t.code && this.hidePopdown()
                        }.bind(this)), this.close.addEventListener("click", function() {
                            this.hidePopdown()
                        }.bind(this)), this.underlay.addEventListener("click", function() {
                            this.hidePopdown()
                        }.bind(this))
                    }
                    hidePopdown() {
                        this.popdown.classList.remove(Fo), this.underlay.classList.remove(Bo), this.trigger.focus(), qe(), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }))
                    }
                    showPopdown() {
                        this.popdown.classList.add(Fo), this.underlay.classList.add(Bo), Ae(this.popdown, {
                            elementToFocus: this.input
                        }), this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        }))
                    }
                    constructor(t) {
                        this.trigger = t, this.key = this.trigger.getAttribute(Io), this.popdown = document.querySelector(`[id='${this.key}']`), this.input = this.popdown.querySelector(Do), this.close = this.popdown.querySelector(Ho), this.wrapper = this.popdown.closest(Mo), this.underlay = this.wrapper.querySelector(_o), this.initTriggerEvents(), this.initPopdownEvents()
                    }
                }(t))
            },
            onUnload: function() {
                "function" == typeof Wo[this.id].unload && Wo[this.id].unload()
            }
        },
        Ro = "data-grid-item-variant";
    let No = class extends HTMLElement {
        connectedCallback() {
            this.gridItemVariantLinks.length && this.gridItemVariantLinks.forEach((t => {
                t.hasAttribute(Ro) && (this.swatchHoverEvent(t), this.swatchClickEvent(t))
            }))
        }
        swatchHoverEvent(t) {
            t.addEventListener("mouseenter", (() => {
                if (t.hasAttribute(Ro)) {
                    const e = t.getAttribute(Ro);
                    this.container.querySelectorAll(`product-grid-item-variant[${Ro}="${e}"] product-grid-item-image`).forEach((t => {
                        t.setAttribute("loading", "eager")
                    }))
                }
            }))
        }
        swatchClickEvent(t) {
            t.addEventListener("click", (e => {
                if (e.preventDefault(), this.container.querySelectorAll(`a[${Ro}]`).forEach((t => t.removeAttribute("aria-selected"))), t.setAttribute("aria-selected", "true"), t.hasAttribute(Ro)) {
                    const e = t.getAttribute(Ro);
                    this.container.querySelectorAll(`product-grid-item-variant[${Ro}]`).forEach((t => {
                        t.getAttribute(Ro) === e ? t.removeAttribute("hidden") : t.setAttribute("hidden", "")
                    }))
                }
            }))
        }
        constructor() {
            super(), this.container = this, this.gridItemVariantLinks = this.container.querySelectorAll(`a[${Ro}]`)
        }
    };
    const zo = "[data-grid-link]",
        Vo = "data-grid-images",
        jo = "data-grid-image",
        Uo = "data-grid-image-target",
        Jo = "data-grid-current-image",
        Qo = "data-grid-pagination",
        Go = "data-grid-page",
        Yo = "data-slide-for-filter-selected-variant",
        Xo = "data-slide-for-variant-media",
        Ko = "data-slideshow-style",
        Zo = "--width",
        tr = "is-active",
        er = "is-mobile",
        ir = "product-grid-item__pagination";
    let sr = class extends HTMLElement {
        static get observedAttributes() {
            return ["hidden"]
        }
        preloadImage(t) {
            if (this.isMobile) return;
            const e = [...this.images][t];
            if (!e) throw new Error(`No child element at index ${t}`);
            e.setAttribute("loading", "eager")
        }
        preloadImages() {
            [...this.imagesHolder.children].forEach(((t, e) => this.preloadImage(e)))
        }
        connectedCallback() {
            this.toggleMobile(), document.addEventListener("theme:resize:width", (() => this.toggleMobile())), this.isMobile || (this.imageCount > 1 && (this.createPaging(), this.container.addEventListener("theme:swatch:change", (t => {
                const e = t.detail.id,
                    i = this.container.querySelector(`[${Uo}="${e}"]`);
                if (i) {
                    const e = i.getAttribute(jo);
                    this.pagingProgressCounter = 0, this.changeImage(e), t.detail.stopSlideAnimation && this.stopPaging()
                }
            })), this.container.addEventListener("mouseenter", (() => {
                switch (this.preloadImages(), this.slideshowStyle) {
                    case "cycle_images":
                        this.pagingProgressPause = this.isMobile, this.progressPaging();
                        break;
                    case "second_immediately":
                        this.changeImage(this.getNextIndex());
                        break;
                    case "disabled":
                        break;
                    default:
                        throw new Error(`Unknown option ${this.slideshowStyle}`)
                }
            })), this.container.addEventListener("mouseleave", (() => {
                this.pagingProgressPause = !0, this.resetSlideshow(), this.progressPaging()
            }))), this.intersectionObserver.observe(this.container))
        }
        attributeChangedCallback(t, e, i) {
            "hidden" === t && null == e && null != i && this.showVariant()
        }
        toggleMobile() {
            this.container.classList.toggle(er, this.isMobile)
        }
        get isMobile() {
            return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < window.theme.sizes.medium
        }
        resetSlideshow() {
            const t = this.container.querySelector(`[${Yo}]`);
            if (t) {
                let e = Number(t.getAttribute(jo));
                this.changeImage(e)
            } else this.changeImage(0);
            this.pagingProgressPause = !0
        }
        showVariant() {
            const t = this.container.querySelector(`[${Xo}]`);
            if (t) {
                let e = Number(t.getAttribute(jo));
                this.changeImage(e)
            } else this.changeImage(0);
            this.pagingProgressPause = !0
        }
        getNextIndex() {
            let t = this.container.querySelector(`[${jo}][${Jo}]`);
            if (t) {
                return (Number(t.getAttribute(jo)) + 1) % this.imageCount
            }
            return 0
        }
        changeImage(t) {
            const e = this.images[t % this.imageCount];
            e && (this.activeImages.forEach((t => t.removeAttribute(Jo))), e.setAttribute(Jo, "true"), "cycle_images" === this.slideshowStyle && this.changePaging(t))
        }
        changePaging(t = 0) {
            const e = this.container.querySelector(`[${Go}].${tr}`),
                i = this.container.querySelector(`[${Go}="${t}"]`);
            e && (e.style.setProperty(Zo, "100%"), e.classList.remove(tr)), i && (i.classList.add(tr), this.progressPaging())
        }
        progressPaging() {
            const t = this.container.querySelector(`[${Go}].${tr}`);
            t && !this.isMobile && (this.stopPaging(), 0 === this.pagingProgressCounter && t.style.setProperty(Zo, "0%"), this.interval = setInterval((() => {
                this.pagingProgressCounter >= 100 && !this.pagingProgressPause ? (this.stopPaging(), this.pagingProgressCounter = 0, this.changeImage(this.getNextIndex())) : this.pagingProgressPause || (this.pagingProgressCounter++, t.style.setProperty(Zo, `${this.pagingProgressCounter}%`))
            }), this.timeout / 100))
        }
        stopPaging() {
            this.interval && clearInterval(this.interval)
        }
        createPaging() {
            if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
                let t = "";
                for (let e = 0; e < this.imageCount; e++) {
                    let i = "";
                    0 === e && (i = `class="${tr}"`), t += `<span ${i} ${Go}="${e}">${e+1}</span>`
                }
                if ("" !== t) {
                    let e = this.container.querySelector(`[${Qo}]`);
                    e || (e = document.createElement("div"), e.className = ir, e.setAttribute(Qo, "")), e.innerHTML = t, this.imagesHolder.parentElement.prepend(e)
                }
            }
        }
        removePaging() {
            const t = this.container.querySelector(`[${Qo}]`);
            t && t.remove()
        }
        get imagesHolder() {
            return this.container.querySelector(`[${Vo}]`)
        }
        get images() {
            return this.imagesHolder.querySelectorAll(`[${jo}]`)
        }
        get activeImages() {
            return this.imagesHolder.querySelectorAll(`[${jo}][${Jo}]`)
        }
        get links() {
            return this.container.querySelectorAll(zo)
        }
        get slideshowStyle() {
            return this.container.getAttribute(Ko)
        }
        get imageCount() {
            return this.images.length
        }
        constructor() {
            super(), this.container = this, this.mobileStopSlideshow = "true", this.timeout = 1e3 * window.theme.settings.cycle_images_hover_delay || 1500, this.interval = null, this.pagingProgressPause = !1, this.pagingProgressCounter = 0, this.siblingsFetchCounter = 0, this.siblingLoadImageIndex = null, this.intersectionObserver = new IntersectionObserver((t => {
                t.forEach((t => {
                    t.isIntersecting && this.imageCount > 1 && this.preloadImage(1)
                }))
            }), {
                threshold: .1
            })
        }
    };
    const or = "data-grid-current-image",
        rr = "is-active";
    let nr = class extends HTMLElement {
        static get observedAttributes() {
            return ["loading", or]
        }
        connectedCallback() {
            null === this.getAttribute(or) ? this.hide() : this.show()
        }
        attributeChangedCallback(t, e, i) {
            switch (t) {
                case "loading":
                    null !== i && "eager" !== i || this.eagerLoad();
                    break;
                case or:
                    null === i ? this.hide() : this.show()
            }
        }
        show() {
            this.classList.add(rr)
        }
        hide() {
            this.classList.remove(rr)
        }
        eagerLoad() {
            const t = this.firstElementChild;
            switch (t.nodeName) {
                case "TEMPLATE":
                    const e = t,
                        i = e.content;
                    i.querySelectorAll("img").forEach((t => {
                        t.setAttribute("loading", "eager"), t.setAttribute("fetchpriority", "high")
                    })), e.replaceWith(i);
                    break;
                case "IMG":
                    t.setAttribute("loading", "eager"), t.setAttribute("fetchpriority", "high")
            }
        }
    };
    const ar = "[data-popout]",
        lr = "[data-popout-list]",
        cr = "data-popout-list-scroll",
        hr = "data-popout-toggle",
        dr = "[data-popout-input]",
        ur = "[data-popout-option]",
        pr = "data-popout-prevent",
        mr = "data-quantity-field",
        gr = "data-value",
        yr = "aria-expanded",
        fr = "aria-current",
        wr = "popout-list--visible",
        vr = "--current";
    let br = class extends HTMLElement {
        unload() {
            this.popoutOptions.length && this.popoutOptions.forEach((t => {
                t.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.removeEventListener("click", this._connectOptionsDispatch.bind(this))
            })), this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)), this.container.removeEventListener("keyup", this.containerKeyup.bind(this)), this.outsidePopupToggle && (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)))
        }
        popupToggleClick(t) {
            const e = "true" === t.currentTarget.getAttribute(yr);
            t.currentTarget.setAttribute(yr, !e), this.popoutList.classList.toggle(wr), this.popupListMaxWidth(), this.popoutList.hasAttribute(cr) && setTimeout((() => {
                this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0
                }))
            }), 1)
        }
        popupToggleFocusout(t) {
            this.container.contains(t.relatedTarget) || this._hideList()
        }
        popupListFocusout(t) {
            const e = t.currentTarget.contains(t.relatedTarget);
            this.popoutList.classList.contains(wr) && !e && this._hideList()
        }
        popupListMaxWidth() {
            this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth-this.popoutList.getBoundingClientRect().left)}px`
        }
        popupOptionsClick(t) {
            if ("#" === t.target.closest(ur).attributes.href.value) {
                t.preventDefault();
                let e = "";
                if (t.currentTarget.getAttribute(gr) && (e = t.currentTarget.getAttribute(gr)), this.popoutInput.value = e, this.popoutPrevent) {
                    this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(mr) && this.popoutInput.dispatchEvent(new Event("input"));
                    const i = this.popoutList.querySelector(`[class*="${vr}"]`);
                    let s = vr;
                    if (i && i.classList.length)
                        for (const t of i.classList)
                            if (t.includes(vr)) {
                                s = t;
                                break
                            } const o = this.popoutList.querySelector(`.${s}`);
                    o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                    const r = this.popoutList.querySelector(`[${fr}]`);
                    r && r.hasAttribute(`${fr}`) && (r.removeAttribute(`${fr}`), t.currentTarget.setAttribute(`${fr}`, "true")), "" !== e && (this.popoutToggle.textContent = e, this.outsidePopupToggle && (this.outsidePopupToggle.textContent = e)), this.popupToggleFocusout(t), this.popupListFocusout(t)
                } else this._submitForm(e)
            }
        }
        updatePopout(t) {
            const e = this.popoutList.querySelector(`[${gr}="${this.popoutInput.value}"]`);
            e && e.dispatchEvent(new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !0
                }
            }))
        }
        containerKeyup(t) {
            "Escape" === t.code && (this._hideList(), this.popoutToggle.focus())
        }
        bodyClick(t) {
            const e = this.container.contains(t.target),
                i = this.popoutList.classList.contains(wr);
            this.outsidePopupToggle, t.target, i && !e && this._hideList()
        }
        _connectToggle() {
            this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this))
        }
        _connectOptions() {
            this.popoutOptions.length && this.popoutOptions.forEach((t => {
                t.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)), t.addEventListener("click", this._connectOptionsDispatch.bind(this))
            }))
        }
        _connectOptionsDispatch(t) {
            const e = new CustomEvent("theme:popout:click", {
                cancelable: !0,
                bubbles: !0,
                detail: {
                    preventTrigger: !1
                }
            });
            t.target.dispatchEvent(e) || t.preventDefault()
        }
        _onFocusOut() {
            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.outsidePopupToggle && this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)), this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)), this.container.addEventListener("keyup", this.containerKeyup.bind(this)), document.body.addEventListener("click", this.bodyClick.bind(this))
        }
        _submitForm(t) {
            const e = this.container.closest("form");
            e && e.submit()
        }
        _hideList() {
            this.popoutList.classList.remove(wr), this.popoutToggle.setAttribute(yr, !1), this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(yr, !1)
        }
        constructor() {
            super(), this.container = this.querySelector(ar), this.popoutList = this.container.querySelector(lr), this.popoutToggle = this.container.querySelector(`[${hr}]`), this.outsidePopupToggle = document.querySelector(`[${hr}="${this.popoutList.id}"]`), this.popoutInput = this.container.querySelector(dr), this.popoutOptions = this.container.querySelectorAll(ur), this.popoutPrevent = "true" === this.container.getAttribute(pr), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popupListMaxWidth(), this.popoutInput && this.popoutInput.hasAttribute(mr) && document.addEventListener("theme:popout:update", this.updatePopout.bind(this)), document.addEventListener("theme:resize", (() => {
                this.popupListMaxWidth()
            }))
        }
    };
    const Sr = "[data-cart-note]";
    class Er {
        initInputs() {
            this.inputs.forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString() || "";
                    this.saveNotes(e)
                }.bind(this))
            }))
        }
        saveNotes(t) {
            window.fetch(`${window.theme.routes.cart}/update.js`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    note: t
                })
            }).catch((t => {
                console.error(t)
            }))
        }
        constructor(t) {
            this.inputs = t.querySelectorAll(Sr), this.initInputs()
        }
    }
    const Lr = (t, e = [], i = !1) => {
            const s = Object.keys(t).map((s => {
                let o = t[s];
                if ("[object Object]" === Object.prototype.toString.call(o) || Array.isArray(o)) return Array.isArray(t) ? e.push("") : e.push(s), Lr(o, e, Array.isArray(o));
                {
                    let t = s;
                    if (e.length > 0) {
                        t = (i ? e : [...e, s]).reduce(((t, e) => "" === t ? e : `${t}[${e}]`), "")
                    }
                    return i ? `${t}[]=${o}` : `${t}=${o}`
                }
            })).join("&");
            return e.pop(), s
        },
        kr = "html",
        Tr = "[data-submit-shipping]",
        Ar = "[data-shipping-estimate-form]",
        qr = "[data-response-template]",
        Cr = "#estimate_address_country",
        xr = "#estimate_address_province",
        Pr = "#estimate_address_zip",
        $r = "[data-response-wrapper]",
        Mr = "lang",
        Ir = "data-default",
        Hr = "shipping--success",
        Dr = "errors",
        _r = "disabled";
    class Br {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(_r)
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(_r)
        }
        render(t) {
            if (this.template && this.ratesWrapper) {
                const e = u.render(this.template, t);
                this.ratesWrapper.innerHTML = e
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display")
        }
        estimate(t) {
            const e = encodeURI(Lr({
                    shipping_address: t
                })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${e}`,
                s = this;
            n.get(i).then((function(t) {
                const e = s.sanitize(t);
                s.render(e), s.enableButtons(), s.ratesWrapper.style.removeProperty("display")
            })).catch((function(t) {
                const e = s.sanitizeErrors(t);
                s.render(e)
            }))
        }
        sanitize(t) {
            const e = {};
            if (e.class = Hr, e.items = [], t.data.shipping_rates && t.data.shipping_rates.length > 0) {
                t.data.shipping_rates.forEach((t => {
                    let i = {};
                    i.title = t.presentment_name, i.value = l.formatMoney(t.price, theme.moneyFormat), e.items.push(i)
                }))
            } else e.items[0] = {
                value: theme.strings.noShippingAvailable
            };
            return e
        }
        sanitizeErrors(t) {
            const e = {};
            if (e.class = Dr, e.items = [], "object" == typeof t.data)
                for (const [i, s] of Object.entries(t.data)) {
                    let t = {};
                    t.title = i.toString(), t.value = s.toString(), e.items.push(t)
                } else e.items[0] = {
                value: theme.strings.noShippingAvailable
            };
            return e
        }
        init() {
            const t = document.querySelector(kr);
            let e = "en";
            t.hasAttribute(Mr) && "" !== t.getAttribute(Mr) && (e = t.getAttribute(Mr)), this.form && c.AddressForm(this.form, e, {
                shippingCountriesOnly: !0
            }), this.country && this.country.hasAttribute(Ir) && this.province && this.province.hasAttribute(Ir) && this.country.addEventListener("change", (function() {
                this.country.removeAttribute(Ir), this.province.removeAttribute(Ir)
            })), this.button && this.button.addEventListener("click", function(t) {
                for (t.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild;) this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                this.ratesWrapper.style.display = "none";
                const e = {};
                let i = this.country.value,
                    s = this.province.value;
                const o = this.country.getAttribute(Ir);
                "" === i && o && "" !== o && (i = o);
                const r = this.province.getAttribute(Ir);
                "" === s && r && "" !== r && (s = r), e.zip = this.zip.value || "", e.country = i || "", e.province = s || "", this.estimate(e)
            }.bind(this))
        }
        constructor(t) {
            this.button = t.container.querySelector(Tr), this.template = t.container.querySelector(qr).innerHTML, this.ratesWrapper = t.container.querySelector($r), this.form = t.container.querySelector(Ar), this.country = t.container.querySelector(Cr), this.province = t.container.querySelector(xr), this.zip = t.container.querySelector(Pr), this.init()
        }
    }
    const Fr = "[data-quantity-selector]",
        Wr = "[data-increase-quantity]",
        Or = "[data-decrease-quantity]",
        Rr = "[data-quantity-input]";

    function Nr(t) {
        t.querySelectorAll(Fr).forEach((t => {
            new class {
                initButtons() {
                    this.increase.addEventListener("click", function(t) {
                        t.preventDefault();
                        let e = parseInt(this.input.value, 10);
                        e = isNaN(e) ? 0 : e, e++, this.input.value = e, this.input.dispatchEvent(new Event("change"))
                    }.bind(this)), this.decrease.addEventListener("click", function(t) {
                        t.preventDefault();
                        let e = parseInt(this.input.value, 10);
                        e = isNaN(e) ? 0 : e, e--, e = Math.max(this.min, e), this.input.value = e, this.input.dispatchEvent(new Event("change"))
                    }.bind(this))
                }
                constructor(t) {
                    this.wrapper = t, this.increase = this.wrapper.querySelector(Wr), this.decrease = this.wrapper.querySelector(Or), this.input = this.wrapper.querySelector(Rr), this.min = parseInt(this.input.getAttribute("min"), 10), this.initButtons()
                }
            }(t)
        }))
    }
    const zr = '[data-drawer="drawer-cart"]',
        Vr = "[data-shipping-estimate-form]",
        jr = "[data-cart-loading]",
        Ur = "[data-cart-form]",
        Jr = "[data-cart-empty]",
        Qr = "[data-cart-progress]",
        Gr = "[data-line-items]",
        Yr = "[data-cart-subtotal]",
        Xr = "[data-cart-bottom]",
        Kr = "[data-form-errors]",
        Zr = "[data-cart-item]",
        tn = "[data-cart-final]",
        en = "data-update-cart",
        sn = "data-remove-key",
        on = "[data-cart-page-upsell-wrapper]",
        rn = '[data-section-type="cart"]',
        nn = "[data-cart-bar]",
        an = "[data-cart-message]",
        ln = "[data-item-loadbar]",
        cn = "[data-cart-message-container]",
        hn = "[data-api-content]",
        dn = "cart--hidden",
        un = "cart--loading";
    let pn = class {
        listen() {
            document.addEventListener("theme:cart:change", function(t) {
                this.cart = t.detail.cart, this.stale = !0
            }.bind(this)), document.addEventListener("theme:cart:init", function() {
                this.init()
            }.bind(this)), document.addEventListener("theme:cart:reload", function() {
                this.stale = !0, this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML()))
            }.bind(this)), this.drawer && (this.drawer.addEventListener("theme:drawer:open", function() {
                this.cart ? this.loadHTML() : this.init().then((() => this.loadHTML())), window.theme.state.cartOpen = !0
            }.bind(this)), this.drawer.addEventListener("theme:drawer:close", (function() {
                window.theme.state.cartOpen = !1
            }))), new Er(this.container), new ys(this.container)
        }
        init() {
            return window.fetch(`${window.theme.routes.cart}.js`).then(this.handleErrors).then((t => t.json())).then((t => (this.cart = t, this.fireChange(t), t))).catch((t => {
                console.error(t)
            }))
        }
        loadHTML() {
            this.stale && (this.cart && this.cart.item_count > 0 ? this.loadForm() : (this.showEmpty(), this.cartMessages.forEach((t => {
                new ys(t)
            })))), this.stale = !1
        }
        initInputs() {
            this.inputs = this.container.querySelectorAll(`[${en}]`), this.inputs.forEach((t => {
                const e = t.getAttribute(en);
                t.addEventListener("change", function(t) {
                    const i = parseInt(t.target.value, 10);
                    this.latestClick = t.target.closest(Zr), this.lockState(), this.updateCart(e, i)
                }.bind(this))
            }))
        }
        initRemove() {
            this.removers = this.container.querySelectorAll(`[${sn}]`), this.removers.forEach((t => {
                const e = t.getAttribute(sn);
                t.addEventListener("click", function(t) {
                    t.preventDefault(), this.latestClick = t.target.closest(Zr), this.lockState(), this.updateCart(e, 0)
                }.bind(this))
            }))
        }
        lockState() {
            this.latestClick.querySelector(ln).style.display = "block", this.loader.classList.add(un)
        }
        updateCart(t, e) {
            window.fetch(`${window.theme.routes.cart}/change.js`, {
                method: "post",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: t,
                    quantity: e
                })
            }).then(this.handleErrors).then((t => t.json())).then((t => {
                this.cart = t, ei(this.errors), this.fireChange(t), this.stale = !0, this.loadHTML()
            })).catch((t => {
                if (!(t instanceof O)) {
                    let e = `<p>${t.message||window.theme.strings.stockout||"Could not update cart, please reload"}</p>`;
                    throw this.showError(e), t
                } {
                    var e, i;
                    let s = `<p>${(null===(e=t.json)||void 0===e?void 0:e.message)||t.message||window.theme.strings.stockout||"Could not update cart, please reload"}</p>`,
                        o = (null === (i = t.json) || void 0 === i ? void 0 : i.description) || "";
                    this.showError([s, o].join(" ")), this.loadForm()
                }
            }))
        }
        fireChange(t) {
            document.dispatchEvent(new CustomEvent("theme:cart:change", {
                detail: {
                    cart: t
                },
                bubbles: !0
            }))
        }
        updateTotal() {
            if (this.cart && this.cart.total_price) {
                const t = l.formatMoney(this.cart.total_price, theme.moneyFormat);
                this.finalPrice.innerHTML = t + ` ${theme.currencyCode}`
            }
            this.subtotal && this.cart && window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.subtotal.innerHTML = e.querySelector(hn).innerHTML
            }))
        }
        showError(t) {
            ei(this.errors), this.errors.innerHTML = t, window.setTimeout((() => {
                ti(this.errors)
            }), 600)
        }
        loadForm() {
            window.fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`).then(this.handleErrors).then((t => t.text())).then((t => {
                const e = document.createElement("div");
                e.innerHTML = t, this.items.innerHTML = e.querySelector(hn).innerHTML, this.showForm(), this.initQuantity(), this.initQuickview(), this.updateTotal()
            }))
        }
        initQuickview() {
            const t = this.items.querySelector(on),
                e = this.bottom.querySelector(on);
            e && e.remove(), this.cartPage && t && this.bottom.insertBefore(t, this.bottom.firstChild)
        }
        initQuantity() {
            Nr(this.container), this.initInputs(), this.initRemove()
        }
        showForm() {
            this.bar && this.bar.classList.remove(dn), this.ship && this.ship.classList.remove(dn), this.progress && this.progress.classList.remove(dn), this.form.classList.remove(dn), this.bottom.classList.remove(dn), this.loader.classList.remove(un), this.emptystate.classList.add(dn)
        }
        showEmpty() {
            this.bar && this.bar.classList.add(dn), this.ship && this.ship.classList.add(dn), this.progress && this.progress.classList.add(dn), this.emptystate.classList.remove(dn), this.loader.classList.remove(un), this.form.classList.add(dn), this.bottom.classList.add(dn)
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new O({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        constructor(t) {
            this.section = t, this.container = t.container, this.cartMessages = document.querySelectorAll(cn), this.bar = this.container.querySelector(nn), this.ship = this.container.querySelector(an), this.drawer = this.container.querySelector(zr), this.form = this.container.querySelector(Ur), this.loader = this.container.querySelector(jr), this.bottom = this.container.querySelector(Xr), this.items = this.container.querySelector(Gr), this.subtotal = this.container.querySelector(Yr), this.errors = this.container.querySelector(Kr), this.finalPrice = this.container.querySelector(tn), this.emptystate = this.container.querySelector(Jr), this.progress = this.container.querySelector(Qr), this.latestClick = null, this.cart = null, this.stale = !0, this.cartPage = document.querySelector(rn), this.listen()
        }
    };
    const mn = {
            onLoad() {
                this.container.querySelector(zr) && (this.cart = new pn(this));
                this.container.querySelector(Vr) && new Br(this)
            },
            onUnload: function() {
                this.cart && "function" == typeof this.cart.unload && this.cart.unload()
            }
        },
        gn = "[data-accordion-group]",
        yn = "data-accordion-trigger",
        fn = "[data-accordion-body]",
        wn = "data-accordion-body-mobile",
        vn = "data-range-holder",
        bn = "[data-section-id]",
        Sn = "accordion-is-open";
    let En = {},
        Ln = class {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style")), document.addEventListener("theme:resize", (() => {
                    window.innerWidth < window.theme.sizes.medium ? (this.init(), this.setDefaultState()) : (this.resetMobileAccordions(), this.body.removeAttribute("style"))
                }))
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.setDefaultState(), this.trigger.addEventListener("click", this.toggleEvent), this.body.addEventListener("keyup", this.keyboardEvent), this.body.addEventListener("theme:accordion:close", this.hideEvent)
            }
            hideEvents() {
                this.hideAccordion()
            }
            clickEvents(t) {
                t.preventDefault(), this.toggleState()
            }
            keyboardEvents(t) {
                "Escape" === t.code && (this.hideAccordion(), this.trigger.focus())
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent), this.body.removeEventListener("keyup", this.keyboardEvent), this.body.removeEventListener("theme:accordion:close", this.hideEvent)
            }
            setDefaultState() {
                this.trigger.classList.contains(Sn) ? W(this.body) : this.hideAccordion()
            }
            getSiblings() {
                const t = [...this.body.closest(bn).querySelectorAll(gn)].filter((t => t.contains(this.body))).shift();
                if (t) {
                    return [...t.querySelectorAll(fn)].filter((t => !t.contains(this.body)))
                }
                return []
            }
            closeSiblings() {
                this.syncBodies.forEach((t => {
                    t.dispatchEvent(new CustomEvent("theme:accordion:close", {
                        bubbles: !1
                    }))
                }))
            }
            toggleState() {
                this.trigger.classList.contains(Sn) ? this.hideAccordion() : (this.showAccordion(), this.closeSiblings(), this.body.hasAttribute(vn) && setTimeout((() => {
                    document.dispatchEvent(new CustomEvent("theme:price-range:reset", {
                        bubbles: !1
                    }))
                }), 400))
            }
            hideAccordion() {
                this.trigger.classList.remove(Sn), ei(this.body)
            }
            showAccordion() {
                this.trigger.classList.add(Sn), ti(this.body), setTimeout((() => {
                    this.checkInViewportAndScrollTo()
                }), 600)
            }
            checkInViewportAndScrollTo() {
                const t = this.trigger.getBoundingClientRect(),
                    e = (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
                t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth) || window.scrollTo({
                    top: e + t.top,
                    left: 0,
                    behavior: "smooth"
                })
            }
            onBlockSelect(t) {
                this.body.contains(t.target) && this.showAccordion()
            }
            onBlockDeselect(t) {
                this.body.contains(t.target) && this.hideAccordion()
            }
            constructor(t) {
                this.body = t, this.key = this.body.id;
                const e = `[${yn}='${this.key}']`;
                this.trigger = document.querySelector(e), this.toggleEvent = t => this.clickEvents(t), this.keyboardEvent = t => this.keyboardEvents(t), this.hideEvent = () => this.hideEvents(), this.syncBodies = this.getSiblings(), this.body.hasAttribute(wn) ? this.mobileAccordions() : this.init()
            }
        };
    const kn = {
            onLoad() {
                En[this.id] = [];
                this.container.querySelectorAll(fn).forEach((t => {
                    En[this.id].push(new Ln(t))
                }))
            },
            onUnload: function() {
                En[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            },
            onSelect: function() {
                "accordion-single" === this.type && this.container.querySelector(`[${yn}]`).click()
            },
            onDeselect: function() {
                "accordion-single" === this.type && this.container.querySelector(`[${yn}]`).click()
            },
            onBlockSelect(t) {
                En[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            },
            onBlockDeselect(t) {
                En[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
                }))
            }
        },
        Tn = t => {
            t && (t.style.display = "none")
        },
        An = 'input[type="search"]',
        qn = '[aria-selected="true"] a',
        Cn = 'button[type="reset"]',
        xn = "is-hidden";
    let Pn = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(xn);
            this.input.value.length > 0 && t ? this.resetButton.classList.remove(xn) : 0 !== this.input.value.length || t || this.resetButton.classList.add(xn)
        }
        onChange() {
            this.toggleResetButton()
        }
        shouldResetForm() {
            return !document.querySelector(qn)
        }
        onFormReset(t) {
            t.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.toggleResetButton(), t.target.querySelector(An).focus())
        }
        constructor() {
            super(), this.input = this.querySelector(An), this.resetButton = this.querySelector(Cn), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", k((t => {
                this.onChange(t)
            }), 300).bind(this)))
        }
    };
    customElements.define("header-search-form", Pn);
    const $n = '[role="option"]',
        Mn = '[aria-selected="true"]',
        In = "predictive-search",
        Hn = "[data-predictive-search-results]",
        Dn = "[data-predictive-search-status]",
        _n = "[data-predictive-search-input]",
        Bn = "[data-predictive-search-live-region-count-value]",
        Fn = "data-search-results-groups-wrapper",
        Wn = "[data-predictive-search-search-for-text]",
        On = "#shopify-section-predictive-search",
        Rn = '[aria-selected="true"] a',
        Nn = '[aria-selected="true"] a, button[aria-selected="true"]',
        zn = "[data-loading-indicator]";
    let Vn = class extends Pn {
        connectedCallback() {
            this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this))
        }
        getQuery() {
            return this.input.value.trim()
        }
        onChange() {
            super.onChange();
            const t = this.getQuery();
            var e;
            this.searchTerm && t.startsWith(this.searchTerm) || (null === (e = this.querySelector(Fn)) || void 0 === e || e.remove());
            this.updateSearchForTerm(this.searchTerm, t), this.searchTerm = t, this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset()
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(Rn) || t.preventDefault()
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController, this.closeResults(!0))
        }
        shouldResetForm() {
            return !document.querySelector(Rn)
        }
        onFocus() {
            const t = this.getQuery();
            t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
        }
        onFocusOut() {
            setTimeout((() => {
                this.contains(document.activeElement) || this.close()
            }))
        }
        onKeyup(t) {
            switch (this.getQuery().length || this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        updateSearchForTerm(t, e) {
            const i = this.querySelector(Wn),
                s = null == i ? void 0 : i.innerText;
            if (s) {
                var o;
                if ((null === (o = s.match(t)) || void 0 === o ? void 0 : o.length) > 1) return;
                const r = s.replace(t, e);
                i.innerText = r
            }
        }
        switchOption(t) {
            if (!this.getAttribute("open")) return;
            const e = "up" === t,
                i = this.querySelector(Mn),
                s = Array.from(this.querySelectorAll($n)).filter((t => null !== t.offsetParent));
            let o = 0;
            if (e && !i) return;
            let r = -1,
                n = 0;
            for (; - 1 === r && n <= s.length;) s[n] === i && (r = n), n++;
            if (this.statusElement.textContent = "", !e && i ? o = r === s.length - 1 ? 0 : r + 1 : e && (o = 0 === r ? s.length - 1 : r - 1), o === r) return;
            const a = s[o];
            a.setAttribute("aria-selected", !0), i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", a.id)
        }
        selectOption() {
            const t = this.querySelector(Nn);
            t && t.click()
        }
        getSearchResults(t) {
            const e = t.replace(" ", "-").toLowerCase();
            this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : (W(this.loader), fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`, {
                signal: this.abortController.signal
            }).then(this.handleErrors).then((t => t.text())).then((t => {
                const i = (new DOMParser).parseFromString(t, "text/html").querySelector(On).innerHTML;
                this.allPredictiveSearchInstances.forEach((t => {
                    t.cachedResults[e] = i
                })), this.renderSearchResults(i)
            })).catch((t => {
                console.error(t)
            })).finally((() => {
                Tn(this.loader)
            })))
        }
        setLiveRegionLoadingState() {
            this.statusElement = this.statusElement || this.querySelector(Dn), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
        }
        setLiveRegionText(t) {
            this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout((() => {
                this.statusElement.setAttribute("aria-hidden", "true")
            }), 1e3)
        }
        renderSearchResults(t) {
            this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
        }
        setLiveRegionResults() {
            this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(Bn).textContent)
        }
        open() {
            this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0
        }
        close(t = !1) {
            this.closeResults(t), this.isOpen = !1
        }
        closeResults(t = !1) {
            var e;
            t && (this.input.value = "", this.removeAttribute("results"));
            const i = this.querySelector(Mn);
            i && i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style")
        }
        reset() {
            this.predictiveSearchResults.innerHTML = "", this.input.val = "", this.a11y.removeTrapFocus()
        }
        handleErrors(t) {
            return t.ok ? t : t.json().then((function(e) {
                throw new O({
                    status: t.statusText,
                    headers: t.headers,
                    json: e
                })
            }))
        }
        constructor() {
            super(), this.wrapper = this, this.a11y = Ce, this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(In), this.cachedResults = {}, this.input = this.wrapper.querySelector(_n), this.isOpen = !1, this.predictiveSearchResults = this.querySelector(Hn), this.searchTerm = "", this.loader = this.wrapper.querySelector(zn)
        }
    };

    function jn() {
        return (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.small
    }
    const Un = 'input[type="search"]';
    let Jn = class extends Pn {
        setupEventListeners() {
            let t = [];
            this.allSearchInputs.forEach((e => t.push(e.form))), this.input.addEventListener("focus", this.onInputFocus.bind(this)), t.length < 2 || (t.forEach((t => t.addEventListener("reset", this.onFormReset.bind(this)))), this.allSearchInputs.forEach((t => t.addEventListener("input", this.onInput.bind(this)))))
        }
        onFormReset(t) {
            super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input)
        }
        onInput(t) {
            const e = t.target;
            this.keepInSync(e.value, e)
        }
        onInputFocus() {
            jn() || this.scrollIntoView({
                behavior: "smooth"
            })
        }
        keepInSync(t, e) {
            this.allSearchInputs.forEach((i => {
                i !== e && (i.value = t)
            }))
        }
        constructor() {
            super(), this.allSearchInputs = document.querySelectorAll(Un), this.setupEventListeners()
        }
    };
    const Qn = {
            drawer: "data-drawer-scrolls",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            children: ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope .sliderule-grid  > *"
        },
        Gn = "is-visible",
        Yn = "is-hiding",
        Xn = "is-hidden";
    let Kn = {};
    const Zn = {
            onLoad() {
                Kn[this.id] = [];
                this.container.querySelectorAll(Qn.slideruleWrappper).forEach((t => {
                    Kn[this.id].push(new class {
                        clickEvents() {
                            this.trigger.addEventListener("click", function() {
                                this.showSliderule()
                            }.bind(this)), this.exit.forEach((t => {
                                t.addEventListener("click", function() {
                                    this.hideSliderule()
                                }.bind(this))
                            }))
                        }
                        keyboardEvents() {
                            this.trigger.addEventListener("keyup", function(t) {
                                "Space" === t.code && this.showSliderule()
                            }.bind(this)), this.sliderule.addEventListener("keyup", function(t) {
                                "Escape" === t.code && (this.hideSliderule(), this.buttons[0].focus())
                            }.bind(this))
                        }
                        staggerChildAnimations(t = !1) {
                            (t ? Array.prototype.slice.call(this.children).slice().reverse() : this.children).forEach(((t, e) => {
                                t.style.transitionDelay = 50 * e + 10 + "ms"
                            }))
                        }
                        hideSliderule(t = !1) {
                            const e = window.getComputedStyle(this.pane),
                                i = 1e3 * parseFloat(e.getPropertyValue("transition-duration")),
                                s = t ? this.pane.querySelectorAll(`.${Gn}`) : this.children;
                            this.pane.style.setProperty("--sliderule-height", "auto"), this.staggerChildAnimations(!0), this.pane.classList.add(Yn), this.sliderule.classList.add(Yn), this.sliderule.classList.remove(Gn), s.forEach((t => {
                                t.classList.remove(Gn)
                            }));
                            const o = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(Qn.sliderulePane, o);
                            const r = t ? `[${Qn.dataAnimates}].${Xn}` : `[${Qn.dataAnimates}="${o}"].${Xn}`,
                                n = this.pane.querySelectorAll(r);
                            n.length && n.forEach((t => {
                                t.classList.remove(Xn)
                            })), setTimeout((() => {
                                this.pane.classList.remove(Yn), this.sliderule.classList.remove(Yn), this.staggerChildAnimations()
                            }), i)
                        }
                        showSliderule() {
                            this.pane.style.setProperty("--sliderule-height", "auto"), this.sliderule.classList.add(Gn), this.children.forEach((t => {
                                t.classList.add(Gn)
                            }));
                            const t = parseInt(this.pane.dataset.sliderulePane, 10),
                                e = t + 1;
                            this.pane.setAttribute(Qn.sliderulePane, e);
                            const i = this.pane.querySelectorAll(`[${Qn.dataAnimates}="${t}"]`);
                            if (i.length) {
                                const t = 1e3 * parseFloat(window.getComputedStyle(i[0]).getPropertyValue("transition-duration"));
                                setTimeout((() => {
                                    i.forEach((t => {
                                        t.classList.add(Xn)
                                    }))
                                }), t)
                            }
                            const s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                            this.pane.style.setProperty("--sliderule-height", `${s}px`);
                            const o = this.drawer.scrollTop,
                                r = this.pane.offsetTop;
                            r < o && this.pane.offsetHeight >= this.drawer.offsetHeight && this.drawer.scrollTo({
                                top: r,
                                left: 0,
                                behavior: "smooth"
                            })
                        }
                        closeSliderule() {
                            this.pane && this.pane.hasAttribute(Qn.sliderulePane) && parseInt(this.pane.getAttribute(Qn.sliderulePane)) > 0 && (this.hideSliderule(!0), parseInt(this.pane.getAttribute(Qn.sliderulePane)) > 0 && this.pane.setAttribute(Qn.sliderulePane, 0))
                        }
                        constructor(t) {
                            this.sliderule = t, this.wrapper = t.closest(Qn.wrapper), this.key = this.sliderule.id;
                            const e = `[${Qn.slideruleOpen}='${this.key}']`,
                                i = `[${Qn.slideruleClose}='${this.key}']`;
                            this.trigger = document.querySelector(e), this.drawer = document.querySelector(`[${Qn.drawer}]`), this.exit = document.querySelectorAll(i), this.pane = document.querySelector(`[${Qn.sliderulePane}]`), this.children = this.sliderule.querySelectorAll(Qn.children), this.trigger.setAttribute("aria-haspopup", !0), this.trigger.setAttribute("aria-expanded", !1), this.trigger.setAttribute("aria-controls", this.key), this.clickEvents(), this.staggerChildAnimations(), document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this))
                        }
                    }(t))
                }))
            }
        },
        ta = "[data-product-add-popdown-wrapper]",
        ea = "[data-close-popdown]",
        ia = "[data-api-content]",
        sa = '[data-ajax-disable="false"]',
        oa = '[data-ajax-disable="true"]',
        ra = '[data-drawer-toggle="drawer-cart"]',
        na = '[data-drawer="drawer-cart"]',
        aa = "is-visible";
    let la;
    const ca = {
            onLoad() {
                new class {
                    renderPopdown(t) {
                        const e = t.detail.variant,
                            i = `${window.theme.routes.root_url}variants/${e.id}/?section_id=api-product-popdown`,
                            s = this;
                        n.get(i).then((function(t) {
                            const e = document.createElement("div");
                            e.innerHTML = t.data, s.drawer.innerHTML = e.querySelector(ia).innerHTML, s.connectCartButton(), s.connectCloseButton()
                        })).catch((function(t) {
                            console.warn(t)
                        }))
                    }
                    connectCloseButton() {
                        this.drawer.classList.add(aa), this.drawer.querySelector(ea).addEventListener("click", function(t) {
                            t.preventDefault(), this.drawer.classList.remove(aa)
                        }.bind(this)), this.popdownTimer()
                    }
                    connectCartButton() {
                        const t = this.drawer.querySelector(ra),
                            e = document.querySelector(na);
                        e && t.addEventListener("click", function(t) {
                            t.preventDefault(), this.drawer.classList.remove(aa), e.dispatchEvent(new CustomEvent("theme:drawer:open", {
                                bubbles: !1
                            }))
                        }.bind(this))
                    }
                    popdownTimer() {
                        clearTimeout(la), la = setTimeout((() => {
                            this.drawer.classList.remove(aa)
                        }), 5e3)
                    }
                    constructor() {
                        this.drawer = document.querySelector(ta), this.cartSectionAjax = document.querySelector(sa), this.ajaxDisabled = document.querySelector(oa), document.addEventListener("theme:cart:popdown", (t => {
                            this.cartSectionAjax ? this.cartSectionAjax.dispatchEvent(new CustomEvent("theme:cart:reload", {
                                bubbles: !0
                            })) : this.ajaxDisabled ? window.location.reload() : this.renderPopdown(t)
                        }))
                    }
                }(this)
            }
        },
        ha = "[data-takes-space]",
        da = "[data-header-desktop]",
        ua = "js__header__clone",
        pa = "js__show__mobile",
        ma = "[data-header-backfill]",
        ga = "data-header-transparent",
        ya = "header-override-border",
        fa = ".main-content > .shopify-section:first-child [data-overlay-header]",
        wa = ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
        va = '.navlink[href="#"]',
        ba = "has-overlay";
    let Sa = {};
    Ii("header", [{
        onLoad() {
            Sa = new class {
                unload() {
                    document.removeEventListener("theme:resize", this.checkWidth)
                }
                checkForImage() {
                    this.overlayedImages = document.querySelectorAll(fa);
                    let t = document.querySelectorAll(wa).length;
                    this.overlayedImages.length && !t && this.transparent ? (document.querySelector(ma).style.display = "none", this.listenOverlay()) : this.wrapper.setAttribute(ga, !1), !this.overlayedImages.length || t || this.transparent || (this.wrapper.classList.add(ya), this.subtractHeaderHeight())
                }
                listenOverlay() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.subtractAnnouncementHeight()
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth()
                }
                killDeadLinks() {
                    this.deadLinks.forEach((t => {
                        t.onclick = t => {
                            t.preventDefault()
                        }
                    }))
                }
                subtractAnnouncementHeight() {
                    const {
                        windowHeight: t,
                        announcementHeight: e
                    } = y();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", t - e + "px"), i.classList.add(ba)
                    }))
                }
                subtractHeaderHeight() {
                    const {
                        windowHeight: t,
                        headerHeight: e
                    } = y();
                    this.overlayedImages.forEach((i => {
                        i.style.setProperty("--full-screen", t - e + "px")
                    }))
                }
                checkWidth() {
                    document.body.clientWidth < this.minWidth ? this.wrapper.classList.add(pa) : this.wrapper.classList.remove(pa)
                }
                getMinWidth() {
                    const t = this.wrapper.cloneNode(!0);
                    t.classList.add(ua), document.body.appendChild(t);
                    const e = t.querySelectorAll(ha);
                    let i = 0;
                    return i = 3 === e.length ? function(t) {
                        let e = [];
                        return t.forEach((t => {
                            e.push(t.clientWidth)
                        })), e[0] > e[2] ? e[2] = e[0] : e[0] = e[2], e.reduce(((t, e) => t + e))
                    }(e) : function(t) {
                        let e = 0;
                        return t.forEach((t => {
                            e += t.clientWidth
                        })), e
                    }(e), document.body.removeChild(t), i + 20 * e.length
                }
                constructor(t) {
                    this.wrapper = t, this.style = this.wrapper.dataset.style, this.desktop = this.wrapper.querySelector(da), this.transparent = "false" !== this.wrapper.getAttribute(ga), this.overlayedImages = document.querySelectorAll(fa), this.deadLinks = document.querySelectorAll(va), this.killDeadLinks(), "drawer" !== this.style && this.desktop && (this.minWidth = this.getMinWidth(), this.listenWidth()), this.checkForImage(), window.dispatchEvent(new Event("resize")), document.addEventListener("theme:header:check", this.checkForImage.bind(this))
                }
            }(this.container)
        },
        onUnload: function() {
            "function" == typeof Sa.unload && Sa.unload()
        }
    }, Js, Zn, io, fo, qo, $o, Oo, Ut, mn, ca, kn, rs]), customElements.get("popout-select") || customElements.define("popout-select", br), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr), customElements.get("predictive-search") || customElements.define("predictive-search", Vn), customElements.get("main-search") || customElements.define("main-search", Jn);
    const Ea = "[data-newsletter-form]",
        La = "has-success",
        ka = "has-error",
        Ta = {};
    const Aa = {
        onLoad() {
            Ta[this.id] = [];
            this.container.querySelectorAll(Ea).forEach((t => {
                Ta[this.id].push(new class {
                    init() {
                        this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                    }
                    newsletterSubmitEvent(t) {
                        this.stopSubmit && (t.preventDefault(), t.stopImmediatePropagation(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                    }
                    checkForChallengePage() {
                        this.isChallengePage = "/challenge" === window.location.pathname
                    }
                    writeStorage() {
                        void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id)
                    }
                    readStorage() {
                        this.formID = this.sessionStorage.getItem("newsletter_form_id")
                    }
                    removeStorage() {
                        this.sessionStorage.removeItem("newsletter_form_id")
                    }
                    showMessage() {
                        if (this.readStorage(), this.newsletter.id === this.formID) {
                            const t = document.getElementById(this.formID); - 1 !== window.location.search.indexOf("?customer_posted=true") ? (t.classList.remove(ka), t.classList.add(La)) : -1 !== window.location.search.indexOf("accepts_marketing") && (t.classList.remove(La), t.classList.add(ka)), this.removeStorage(), this.scrollToForm(t)
                        }
                    }
                    scrollToForm(t) {
                        const e = t.getBoundingClientRect();
                        e.top >= 0 && e.left >= 0 && e.bottom <= (window.innerHeight || document.documentElement.clientHeight) && e.right <= (window.innerWidth || document.documentElement.clientWidth) || setTimeout((() => {
                            window.scroll({
                                top: e.top,
                                left: 0,
                                behavior: "smooth"
                            })
                        }), 400)
                    }
                    unload() {
                        this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                    }
                    constructor(t) {
                        this.sessionStorage = window.sessionStorage, this.newsletter = t, this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                    }
                }(t))
            }))
        },
        onUnload() {
            Ta[this.id].forEach((t => {
                "function" == typeof t.unload && t.unload()
            }))
        }
    };
    Ii("footer", [kn, Aa]), customElements.get("popout-select") || customElements.define("popout-select", br);
    const qa = {
            cc_load_policy: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            controls: 1,
            showinfo: 0,
            ecver: 2,
            fs: 1,
            rel: 0
        },
        Ca = "iframe, [data-replace]",
        xa = "data-video-id";

    function Pa(t, e) {
        const i = {
                ...qa,
                ...e
            },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector(Ca),
            r = s.querySelector(`[${xa}]`).getAttribute(xa);
        kt({
            url: "https://www.youtube.com/iframe_api"
        });
        return window.youtubeLoaderPromise.then((() => {
            let t = new window.YT.Player(o, {
                videoId: r,
                playerVars: {
                    ...i
                },
                events: {
                    onStateChange: t => {
                        1 == t.data ? s.dispatchEvent(new CustomEvent("play")) : 2 == t.data && s.dispatchEvent(new CustomEvent("pause"))
                    }
                }
            });
            return s.addEventListener("pause", (() => {
                try {
                    t.pauseVideo()
                } catch (t) {
                    console.warn(t)
                }
            })), s.addEventListener("play", (() => {
                try {
                    t.playVideo ? t.playVideo() : t.addEventListener("onReady", (() => {
                        t.playVideo()
                    }))
                } catch (t) {
                    console.warn(t)
                }
            })), s.addEventListener("destroy", (() => {
                try {
                    t.destroy && t.destroy()
                } catch (t) {
                    console.warn(t)
                }
            })), t
        })).catch((t => {
            console.error(t)
        }))
    }
    window.youtubeLoaderPromise = new Promise((t => {
        window.onYouTubeIframeAPIReady = function() {
            t()
        }
    }));
    const $a = {
            autoplay: !0,
            loop: !0,
            controls: !0,
            muted: !1,
            playsinline: !0
        },
        Ma = "iframe, [data-replace]",
        Ia = "data-video-id";

    function Ha(t, e) {
        const i = {
                ...$a,
                ...e
            },
            s = document.querySelector(`[data-player="${t}"]`),
            o = s.querySelector(Ma),
            r = s.querySelector(`[${Ia}]`).getAttribute(Ia),
            n = kt({
                url: "https://player.vimeo.com/api/player.js"
            }),
            a = `select-${t}`;
        o.setAttribute("id", a);
        return n.then((() => {
            const t = new window.Vimeo.Player(a, {
                ...i,
                id: r
            });
            return t.on("play", (() => {
                s.dispatchEvent(new CustomEvent("play"))
            })), t.on("pause", (() => {
                s.dispatchEvent(new CustomEvent("pause"))
            })), s.addEventListener("pause", (() => {
                try {
                    t.pause && t.pause()
                } catch (t) {
                    console.warn(t)
                }
            })), s.addEventListener("play", (() => {
                t.play && t.getPaused().then((e => {
                    e && t.play()
                }))
            })), s.addEventListener("destroy", (() => {
                try {
                    t.destroy && t.destroy()
                } catch (t) {
                    console.log(t)
                }
            })), t
        })).catch((t => {
            console.error(t)
        }))
    }
    const Da = "[data-video-popup]",
        _a = "[data-video-autoplay]",
        Ba = "data-unique",
        Fa = "data-video-id",
        Wa = "data-video-type",
        Oa = "data-player";
    const Ra = {
            onLoad() {
                new class {
                    init() {
                        this.triggers.forEach((t => {
                            const e = t.getAttribute(Ba),
                                i = t.getAttribute(Fa),
                                s = t.getAttribute(Wa),
                                o = `${i}-${e}`,
                                n = document.querySelector(`[${Oa}="${o}"]`);
                            r.init({
                                onShow: () => {
                                    this.backgroundVideo && "function" == typeof this.backgroundVideo.pause && this.backgroundVideo.pause();
                                    let t = {};
                                    "youtube" === s ? t = Pa(o) : "vimeo" === s && (t = Ha(o)), t.then((() => {
                                        n.dispatchEvent(new CustomEvent("play"))
                                    }))
                                },
                                onClose: (t, e, i) => {
                                    i.preventDefault(), n.dispatchEvent(new CustomEvent("destroy")), this.backgroundVideo && "function" == typeof this.backgroundVideo.play && this.backgroundVideo.play()
                                },
                                openTrigger: `data-trigger-${i}-${e}`
                            })
                        }))
                    }
                    constructor(t) {
                        this.container = t.container, this.triggers = this.container.querySelectorAll(Da), this.backgroundVideo = this.container.querySelector(_a), this.init()
                    }
                }(this)
            }
        },
        Na = "[data-scroll-down]";
    const za = {
        onLoad() {
            this.scrollButton = new class {
                init() {
                    const t = this.wrapper.querySelectorAll(Na);
                    t && t.forEach((t => {
                        t.addEventListener("click", this.scroll.bind(this))
                    }))
                }
                scroll() {
                    const t = this.wrapper.offsetTop + this.wrapper.clientHeight;
                    window.scroll({
                        top: t,
                        left: 0,
                        behavior: "smooth"
                    })
                }
                constructor(t) {
                    this.wrapper = t, this.init()
                }
            }(this.container)
        },
        onUnload: function() {
            delete this.scrollButton
        }
    };
    Ii("video", [Ji, za, Ra]), Ii("page-faq", kn), Ii("hero", [Ji, za, Zt]);
    const Va = "[data-slider]",
        ja = "[data-grid-slide]",
        Ua = "[data-wrapper]",
        Ja = "data-custom-scrollbar-items",
        Qa = "data-show-dots",
        Ga = "wrapper",
        Ya = "wrapper--full",
        Xa = window.innerWidth - document.documentElement.clientWidth,
        Ka = 112,
        Za = {};
    const tl = {
        onLoad() {
            Za[this.id] = [];
            this.container.querySelectorAll(Va).forEach((t => {
                Za[this.id].push(new class {
                    init() {
                        const t = this,
                            e = {
                                initialIndex: 0,
                                accessibility: !0,
                                autoPlay: !1,
                                contain: !0,
                                pageDots: this.pageDots,
                                adaptiveHeight: !1,
                                wrapAround: !1,
                                groupCells: !1,
                                cellAlign: "left",
                                freeScroll: !0,
                                prevNextButtons: !0,
                                draggable: !0,
                                rightToLeft: window.isRTL,
                                watchCSS: !0,
                                arrowShape: {
                                    x0: 10,
                                    x1: 60,
                                    y1: 50,
                                    x2: 65,
                                    y2: 45,
                                    x3: 20
                                },
                                on: {
                                    ready: function() {
                                        t.removeIncorrectAria()
                                    }
                                }
                            };
                        this.flkty = new s(this.slideshow, e), this.container.addEventListener("theme:tab:change", (() => {
                            this.flkty.resize()
                        })), this.toggleWrapperModifier(), document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)), this.slideshow.hasAttribute(Ja) && new Kt(this.container), new Q(this.container)
                    }
                    toggleWrapperModifier() {
                        this.wrapper.classList.contains(Ga) && this.wrapper.classList.toggle(Ya, this.wrapperWidthWithGutter >= window.innerWidth)
                    }
                    removeIncorrectAria() {
                        this.slideshow.querySelectorAll('[aria-hidden="true"]').forEach((t => t.removeAttribute("aria-hidden")))
                    }
                    onUnload() {
                        this.slideshow && this.flkty && (this.flkty.options.watchCSS = !1, this.flkty.destroy())
                    }
                    constructor(t, e) {
                        if (this.container = t, this.slideshow = e, this.wrapper = this.container.querySelector(Ua), this.wrapperWidth = Number(getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", "")), this.wrapperWidthWithGutter = this.wrapperWidth + Ka + Xa, this.pageDots = "true" === this.slideshow.getAttribute(Qa), this.firstPhoto = this.container.querySelector(ja), this.firstPhoto) {
                            const t = this.firstPhoto.offsetHeight / 2;
                            this.slideshow.style.setProperty("--buttons-top", `${t}px`)
                        }
                        this.slideshow && (this.flkty = null, this.init())
                    }
                }(this.container, t))
            }))
        },
        onUnload(t) {
            Za[this.id].forEach((e => {
                "function" == typeof e.onUnload && e.onUnload(t)
            }))
        }
    };
    Ii("custom-content", [Ji, Ra, Ut, tl]), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr);
    const el = [],
        il = "[data-slideshow-wrapper]",
        sl = "data-slideshow-speed",
        ol = "data-slideshow-autoplay",
        rl = "data-slideshow-slides",
        nl = "[data-slide-custom-prev]",
        al = "[data-slide-custom-next]",
        ll = "data-slideshow-index",
        cl = "flickity-enabled";
    Ii("slideshow", [{
        onLoad() {
            el[this.id] = new class {
                init() {
                    const t = {
                        autoPlay: !(!this.autoplay || !this.speed) && parseInt(this.speed),
                        contain: !1,
                        pageDots: !0,
                        adaptiveHeight: !0,
                        accessibility: !0,
                        wrapAround: 2 !== this.slideCount,
                        prevNextButtons: !1,
                        draggable: !0,
                        fade: !0,
                        rightToLeft: window.isRTL
                    };
                    this.flkty = new e(this.wrapper, t), this.prevButtons.length && this.prevButtons.forEach((t => {
                        t.onclick = () => {
                            this.flkty.previous(!0, !1)
                        }
                    })), this.nextButtons.length && this.nextButtons.forEach((t => {
                        t.onclick = () => {
                            this.flkty.next(!0, !1)
                        }
                    })), document.addEventListener("theme:scroll", this.scrollEvent)
                }
                scrollEvents() {
                    if (this.flkty && this.autoplay && this.speed) {
                        const t = this.flkty.element,
                            e = t.getBoundingClientRect().top + window.scrollY + t.offsetHeight;
                        window.pageYOffset > e ? "playing" === this.flkty.player.state && this.flkty.pausePlayer() : "paused" === this.flkty.player.state && this.flkty.playPlayer()
                    }
                }
                unload() {
                    document.removeEventListener("theme:scroll", this.scrollEvent), this.flkty && this.wrapper && this.wrapper.classList.contains(cl) && this.flkty.destroy()
                }
                onBlockSelect(t) {
                    const e = t.target.closest(`[${ll}]`).getAttribute(ll),
                        i = parseInt(e);
                    this.flkty.selectCell(i), this.flkty.stopPlayer()
                }
                onBlockDeselect() {
                    this.autoplay && this.flkty.playPlayer()
                }
                constructor(t) {
                    this.container = t.container, this.wrapper = t.container.querySelector(il), this.speed = this.wrapper.getAttribute(sl), this.autoplay = "true" === this.wrapper.getAttribute(ol), this.slideCount = parseInt(this.wrapper.getAttribute(rl), 10), this.prevButtons = this.wrapper.querySelectorAll(nl), this.nextButtons = this.wrapper.querySelectorAll(al), this.flkty = null, this.scrollEvent = () => this.scrollEvents(), this.init()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof el[this.id].unload && el[this.id].unload()
        },
        onBlockSelect(t) {
            "function" == typeof el[this.id].onBlockSelect && el[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            "function" == typeof el[this.id].onBlockSelect && el[this.id].onBlockDeselect(t)
        }
    }, Ji, za]);
    const hl = "[data-range-slider]",
        dl = "[data-range-left]",
        ul = "[data-range-right]",
        pl = "[data-range-line]",
        ml = "[data-range-holder]",
        gl = "data-se-min",
        yl = "data-se-max",
        fl = "data-se-min-value",
        wl = "data-se-max-value",
        vl = "data-se-step",
        bl = "data-range-filter-update",
        Sl = "[data-field-price-min]",
        El = "[data-field-price-max]",
        Ll = "is-initialized";
    let kl = class {
        init() {
            this.setDefaultValues(), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent), this.touchRight.addEventListener("touchstart", this.onStartEvent), this.slider.classList.add(Ll)
        }
        setDefaultValues() {
            let t = this.min;
            this.slider.hasAttribute(fl) && (t = parseFloat(this.slider.getAttribute(fl)));
            let e = this.max;
            this.slider.hasAttribute(wl) && (e = parseFloat(this.slider.getAttribute(wl))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.slider.getAttribute(vl) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(vl)))), this.reset(), this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e)
        }
        reset() {
            this.touchLeft.style.left = "0px", this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(fl, t)
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(wl, t)
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent), document.addEventListener("touchend", this.onStopEvent)
        }
        onMove(t) {
            let e = t;
            if (t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.slider.getAttribute("on-change")) {
                new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(fl), this.slider.getAttribute(wl))
            }
            this.onChange(this.slider.getAttribute(fl), this.slider.getAttribute(wl))
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent), document.removeEventListener("touchend", this.onStopEvent), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.slider.getAttribute(fl), this.slider.getAttribute(wl))
        }
        onChange(t, e) {
            const i = this.slider.closest(ml);
            if (i) {
                const s = i.querySelector(Sl),
                    o = i.querySelector(El);
                s && o && (s.value = t, o.value = e)
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(bl) && this.slider.dispatchEvent(new CustomEvent("theme:range:update", {
                bubbles: !0
            }))
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (e = e * (this.max - this.min) + this.min, i = i * (this.max - this.min) + this.min, 0 !== this.step) {
                let t = Math.floor(e / this.step);
                e = this.step * t, t = Math.floor(i / this.step), i = this.step * t
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(fl, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(wl, i)
        }
        constructor(t) {
            this.container = t.container, this.slider = t.querySelector(hl), this.slider && (this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.slider.querySelector(dl), this.touchRight = this.slider.querySelector(ul), this.lineSpan = this.slider.querySelector(pl), this.min = parseFloat(this.slider.getAttribute(gl)), this.max = parseFloat(this.slider.getAttribute(yl)), this.step = 0, this.normalizeFact = 26, this.init(), document.addEventListener("theme:price-range:reset", (() => {
                this.setDefaultValues()
            })))
        }
    };
    const Tl = "data-filters",
        Al = "[data-filters-underlay]",
        ql = "data-default-hide",
        Cl = "data-filters-toggle",
        xl = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        Pl = "data-group-heading",
        $l = "data-show-more",
        Ml = "drawer--visible",
        Il = "filters--default-visible",
        Hl = "hidden",
        Dl = "is-hidden",
        _l = "focus-enabled",
        Bl = {};
    let Fl = class {
        unload() {
            this.filtersToggleButtons.length && this.filtersToggleButtons.forEach((t => {
                t.removeEventListener("click", this.connectToggleMemory)
            })), this.showMoreButtons.length && this.showMoreButtons.forEach((t => {
                t.removeEventListener("click", this.connectShowHiddenOptions)
            }))
        }
        expandingEvents() {
            this.showMoreButtons.length && this.showMoreButtons.forEach((t => {
                t.addEventListener("click", xe(this.connectShowHiddenOptions, 500))
            }))
        }
        showHiddenOptions(t) {
            const e = t.target.hasAttribute($l) ? t.target : t.target.closest(`[${$l}]`);
            e.classList.add(Dl), e.previousElementSibling.querySelectorAll(`.${Dl}`).forEach((t => {
                t.classList.remove(Dl)
            }))
        }
        connectToggle(t = !1) {
            this.filtersToggleButtons.forEach((e => {
                const i = null !== e.closest(`[${Tl}]`);
                (i && t || i && !t || !i && !t) && e.addEventListener("click", this.connectToggleMemory.bind(this))
            }))
        }
        connectToggleFunction(t) {
            "true" === t.currentTarget.getAttribute("aria-expanded") ? this.hideFilters() : this.showFilters()
        }
        onFocusOut() {
            this.container.addEventListener("focusout", function(t) {
                if (window.innerWidth >= window.theme.sizes.medium) return;
                const e = t.currentTarget.contains(t.relatedTarget),
                    i = this.container.classList.contains(Ml);
                document.body.classList.contains(_l) && i && !e && this.hideFilters()
            }.bind(this)), this.container.addEventListener("keyup", function(t) {
                "Escape" === t.code && (this.hideFilters(), this.filtersToggleButtons[0].focus())
            }.bind(this)), this.underlay.addEventListener("click", function() {
                this.hideFilters()
            }.bind(this))
        }
        getShowOnLoad() {
            const t = `[${ql}='false']`,
                e = document.querySelector(t),
                i = window.innerWidth >= window.theme.sizes.medium;
            return !(!e || !i)
        }
        showFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.container.classList.remove(Hl), setTimeout((() => {
                this.filtersToggleButtons.forEach((t => t.setAttribute("aria-expanded", !0))), this.filtersToggleButtons.forEach((t => t.classList.add(Ml))), this.container.classList.add(Ml), this.container.querySelector(xl).focus()
            }), 1)
        }
        hideFilters() {
            this.filtersToggleButtons = document.querySelectorAll(this.selector), this.filtersToggleButtons.forEach((t => t.setAttribute("aria-expanded", !1))), this.container.classList.remove(Ml), this.container.classList.remove(Il), this.filtersToggleButtons.forEach((t => t.classList.remove(Ml))), this.filtersToggleButtons.forEach((t => t.classList.remove(Il))), setTimeout((() => {
                this.container.classList.contains(Ml) || this.container.classList.add(Hl)
            }), 800)
        }
        constructor(t, e = !1) {
            this.container = t, this.underlay = this.container.querySelector(Al), this.groupHeadings = this.container.querySelectorAll(`[${Pl}]`), this.showMoreButtons = this.container.querySelectorAll(`[${$l}]`), this.triggerKey = this.container.getAttribute(Tl), this.selector = `[${Cl}='${this.triggerKey}']`, this.filtersToggleButtons = document.querySelectorAll(this.selector), this.connectToggleMemory = t => this.connectToggleFunction(t), this.connectShowHiddenOptions = t => this.showHiddenOptions(t), this.connectToggle(e), this.onFocusOut(), this.expandingEvents(), this.getShowOnLoad() ? this.showFilters() : this.hideFilters()
        }
    };
    const Wl = {
            onLoad() {
                Bl[this.id] = [];
                this.container.querySelectorAll(`[${Tl}]`).forEach((t => {
                    Bl[this.id].push(new Fl(t))
                }))
            },
            onUnload: function() {
                Bl[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Ol = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]"
        },
        Rl = "is-hidden",
        Nl = "is-loading",
        zl = 1e3,
        Vl = 1e3;
    const jl = {
        onLoad() {
            this.filterForm = new class {
                init() {
                    this.showAllOptions(), this.form && (new kl(this.form), this.sidebar.addEventListener("input", k((t => {
                        const e = t.type,
                            i = t.target;
                        if (!Ol.inputs.includes(e) || !this.form || "function" != typeof this.form.submit) return;
                        const s = this.form.querySelector(`[${Ol.priceMin}]`),
                            o = this.form.querySelector(`[${Ol.priceMax}]`);
                        if (i.hasAttribute(Ol.priceMin) || i.hasAttribute(Ol.priceMax)) {
                            const t = this.form.querySelector(`[${Ol.rangeMin}]`),
                                e = this.form.querySelector(`[${Ol.rangeMax}]`);
                            parseInt(t.getAttribute(Ol.rangeMinDefault));
                            const i = parseInt(e.getAttribute(Ol.rangeMaxDefault));
                            s.value && !o.value && (o.value = i), o.value && !s.value && (s.value = rangeMinDefault), s.value <= rangeMinDefault && o.value >= i && (s.placeholder = rangeMinDefault, o.placeholder = i, s.value = "", o.value = "")
                        }
                        this.filtering(t)
                    }), 1500)), this.form.addEventListener("theme:range:update", (t => this.updateRange(t)))), this.sidebar && this.sidebar.addEventListener("click", (t => this.updateFilterFromUrl(t))), this.activeFiltersHolder && this.activeFiltersHolder.addEventListener("click", (t => this.updateFilterFromUrl(t))), this.productsContainer && this.productsContainer.addEventListener("click", (t => this.updateFilterFromUrl(t))), xt(this.sidebar)
                }
                updateRange(t) {
                    if (this.form && "function" == typeof this.form.submit) {
                        const e = this.form.querySelector(`[${Ol.rangeMin}]`),
                            i = this.form.querySelector(`[${Ol.rangeMax}]`),
                            s = this.form.querySelector(`[${Ol.priceMin}]`),
                            o = this.form.querySelector(`[${Ol.priceMax}]`);
                        if (e && i && s && o && e.hasAttribute(Ol.rangeMin) && i.hasAttribute(Ol.rangeMax)) {
                            const r = parseInt(s.placeholder),
                                n = parseInt(o.placeholder),
                                a = parseInt(e.getAttribute(Ol.rangeMin)),
                                l = parseInt(i.getAttribute(Ol.rangeMax));
                            r === a && n === l || (s.value = a, o.value = l, this.filtering(t))
                        }
                    }
                }
                updateFilterFromUrl(t) {
                    const e = t.target;
                    if (e.matches(Ol.filterUpdateUrlButton) || e.closest(Ol.filterUpdateUrlButton) && e) {
                        t.preventDefault();
                        const i = e.matches(Ol.filterUpdateUrlButton) ? e : e.closest(Ol.filterUpdateUrlButton);
                        this.filtering(t, i.getAttribute("href"))
                    }
                }
                addToHistory(t, e = "") {
                    const i = this.sort ? this.sort.getAttribute(Ol.dataSort) : "";
                    if (!t || t && "popstate" !== t.type) {
                        if ("" === e) {
                            const e = new window.URL(window.location.href).searchParams,
                                s = Object.fromEntries(e),
                                o = e.toString();
                            if (o.includes("filter.") || o.includes("sort_by") || o.includes("page"))
                                for (const t in s)(t.includes("filter.") || t.includes("sort_by") || t.includes("page")) && e.delete(t);
                            if (this.form) {
                                const t = new URLSearchParams(new FormData(this.form));
                                for (let [i, s] of t.entries()) i.includes("filter.") && s && e.append(i, s);
                                const i = this.form.querySelector(`[${Ol.rangeMin}]`),
                                    s = this.form.querySelector(`[${Ol.rangeMax}]`),
                                    o = this.form.querySelector(`[${Ol.priceMin}]`),
                                    r = this.form.querySelector(`[${Ol.priceMax}]`);
                                if (i && s && o && r && i.hasAttribute(Ol.rangeMinDefault) && s.hasAttribute(Ol.rangeMaxDefault)) {
                                    const t = parseFloat(i.getAttribute(Ol.rangeMinDefault), 10),
                                        n = parseFloat(s.getAttribute(Ol.rangeMaxDefault), 10),
                                        a = "" === o.value ? parseFloat(o.placeholder, 10) : parseFloat(o.value, 10),
                                        l = "" === r.value ? parseFloat(r.placeholder, 10) : parseFloat(r.value, 10);
                                    a <= t && l >= n && (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"))
                                }
                            }
                            if (i || t && t.detail && t.detail.href) {
                                const s = i || t.detail.params;
                                e.set("sort_by", s)
                            }
                            const r = e.toString(),
                                n = r ? `?${r}` : location.pathname;
                            return void window.history.pushState(null, "", n)
                        }
                        window.history.pushState(null, "", e)
                    }
                }
                getFilterResult() {
                    this.productsContainer.classList.add(Nl), this.getGridValues();
                    const t = new window.URL(window.location.href);
                    t.searchParams.set("section_id", this.section.id), fetch(`${window.location.pathname}${t.search}`).then((t => t.text())).then((t => {
                        const e = document.createElement("div");
                        e.innerHTML = t, this.sidebar && (this.sidebar.innerHTML = e.querySelector(Ol.collectionSidebar).innerHTML), this.activeFiltersCount && (this.activeFiltersCount.innerHTML = e.querySelector(Ol.activeFiltersCount).innerHTML), this.productsContainer.innerHTML = e.querySelector(Ol.productsContainer).innerHTML, this.activeFiltersHolder.innerHTML = e.querySelector(Ol.activeFiltersHolder).innerHTML, this.activeFiltersHolder.parentNode.classList.toggle(Rl, "" === this.activeFiltersHolder.innerHTML), this.productsCount && (this.productsCount.innerHTML = e.querySelector(Ol.productsCount).innerHTML), this.setGridValues(), this.refreshFunctionalities(), setTimeout((() => {
                            this.productsContainer.classList.remove(Nl)
                        }), zl)
                    }))
                }
                refreshFunctionalities() {
                    this.form = this.container.querySelector(Ol.form), this.form && (new kl(this.form), this.form.addEventListener("theme:range:update", (t => this.updateRange(t)))), this.container.querySelectorAll(Ol.filtersWrappper).forEach((t => {
                        new Fl(t, !0)
                    })), this.container.querySelectorAll(Ol.accordionBody).forEach((t => {
                        new Ln(t)
                    })), new Q(this.container), this.sidebar && xt(this.sidebar), jt(this.container), this.showAllOptions(),  Nr(this.container)
                }
                getGridValues() {
                    this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(Ol.gridLarge)), this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(Ol.gridSmall))
                }
                setGridValues() {
                    this.layoutLarge && (this.layoutLarge = this.container.querySelector(`[${Ol.gridLarge}]`), this.layoutLarge.setAttribute(Ol.gridLarge, this.layoutLargeValue)), this.layoutSmall && (this.layoutSmall = this.container.querySelector(`[${Ol.gridSmall}]`), this.layoutSmall.setAttribute(Ol.gridSmall, this.layoutSmallValue))
                }
                showAllOptions() {
                    this.container.querySelectorAll(Ol.checkedOption).forEach((t => {
                        if (t.closest(Ol.optionHolder) && t.closest(Ol.optionHolder).classList.contains(Rl)) {
                            const e = t.closest(Ol.accordionBody).nextElementSibling;
                            e.classList.contains(Ol.classHidden) || e.dispatchEvent(new Event("click"))
                        }
                    }))
                }
                filtering(t, e = "") {
                    const i = this.headerIsSticky ? document.querySelector(Ol.headerHeight).getBoundingClientRect().height : 0,
                        s = this.container.offsetTop - i,
                        o = new IntersectionObserver((i => {
                            const [r] = i;
                            setTimeout((() => {
                                this.addToHistory(t, e), this.getFilterResult()
                            }), r.isIntersecting ? 10 : Vl), o.unobserve(this.productsContainer), r.isIntersecting || window.scrollTo({
                                top: s,
                                left: 0,
                                behavior: "smooth"
                            })
                        }), {
                            root: null,
                            rootMargin: `${i}px`,
                            threshold: 1
                        });
                    o.observe(this.productsContainer)
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.sidebar = this.container.querySelector(Ol.collectionSidebar), this.form = t.container.querySelector(Ol.form), this.sort = this.container.querySelector(`[${Ol.dataSort}]`), this.productsContainer = this.container.querySelector(Ol.productsContainer), this.activeFiltersHolder = this.container.querySelector(Ol.activeFiltersHolder), this.activeFiltersCount = this.container.querySelector(Ol.activeFiltersCount), this.productsCount = this.container.querySelector(Ol.productsCount), this.headerIsSticky = null !== document.querySelector(Ol.headerSticky), this.layoutLarge = this.container.querySelector(`[${Ol.gridLarge}]`), this.layoutSmall = this.container.querySelector(`[${Ol.gridSmall}]`), this.productsContainer && this.sidebar && this.init(), this.sort && this.container.addEventListener("theme:form:filter", (t => this.filtering(t))), (this.sidebar || this.sort) && window.addEventListener("popstate", (t => this.filtering(t)))
                }
            }(this)
        },
        onUnload() {
            this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload()
        }
    };
    Ii("search-page", [Wl, jl, Ut, kn]), customElements.get("popout-select") || customElements.define("popout-select", br), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr);
    const Ul = "[data-image-zoom]",
        Jl = "[data-modal-container]",
        Ql = "data-unique",
        Gl = "data-src";
    const Yl = {
        onLoad() {
            new class {
                init() {
                    this.triggers.forEach((t => {
                        const e = t.getAttribute(Ql),
                            i = this.modalContainer.querySelector(`#zoom-${e}`);
                        if (i) {
                            const t = this.container.querySelector(`#zoom-${e}`);
                            t && (i.parentNode.removeChild(i), this.modalContainer.appendChild(t))
                        }
                        r.init({
                            disableScroll: !0,
                            openTrigger: `data-popup-${e}`,
                            onShow: t => {
                                t.querySelectorAll(`[${Gl}]`, t).forEach((t => {
                                    if (null === t.getAttribute("src")) {
                                        const e = t.getAttribute(Gl);
                                        t.setAttribute("src", e)
                                    }
                                }))
                            },
                            onClose: (t, e, i) => {
                                i.preventDefault()
                            }
                        })
                    }))
                }
                constructor(t) {
                    this.container = t, this.triggers = this.container.querySelectorAll(Ul), this.modalContainer = document.querySelector(Jl), this.init()
                }
            }(this.container)
        }
    };
    Ii("gallery", [Yl, Ra, Zt]);
    const Xl = (t, e) => {
        const {
            el: i,
            elStyle: s,
            elHeight: o,
            rowsLimit: r,
            rowsWrapped: n,
            options: a
        } = t;
        let l = t.buffer,
            c = l;
        if (n === r + 1) return {
            ...t
        };
        const h = l;
        let d = n,
            u = o;
        return i.innerHTML = c = l.length ? `${l}${a.delimiter}${e}${a.replaceStr}` : `${e}${a.replaceStr}`, parseFloat(s.height) > parseFloat(o) && (d++, u = s.height, d === r + 1) ? (i.innerHTML = c = "." === h[h.length - 1] && "..." === a.replaceStr ? `${h}..` : `${h}${a.replaceStr}`, {
            ...t,
            elHeight: u,
            rowsWrapped: d
        }) : (i.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`, {
            ...t,
            buffer: c,
            elHeight: u,
            rowsWrapped: d
        })
    };
    ! function() {
        const t = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        document.documentElement.classList.toggle("supports-touch", t)
    }();
    let Kl = {},
        Zl = {},
        tc = {};
    const ec = "[data-product-slideshow]",
        ic = "[data-shopify-xr]",
        sc = "data-media-id",
        oc = "data-model-id",
        rc = "model-viewer",
        nc = "data-shopify-model3d-id",
        ac = "#ModelJson-";

    function lc(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
            for (const t in Kl)
                if (Kl.hasOwnProperty(t)) {
                    const e = Kl[t];
                    if (e.loaded) continue;
                    const i = document.querySelector(`${ac}${t}`);
                    i && (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)), e.loaded = !0)
                } window.ShopifyXR.setupXRElements()
        } else document.addEventListener("shopify_xr_initialized", (function() {
            lc()
        }))
    }

    function cc(t) {
        if (t) console.warn(t);
        else
            for (const t in Zl)
                if (Zl.hasOwnProperty(t)) {
                    const e = Zl[t];
                    e.modelViewerUi || (e.modelViewerUi = new Shopify.ModelViewerUI(e.$element)), hc(e)
                }
    }

    function hc(t) {
        const e = tc[t.sectionId];
        t.$container.addEventListener("pause", (function() {
            t.modelViewerUi.pause && t.modelViewerUi.pause()
        })), t.$container.addEventListener("play", (function() {
            t.modelViewerUi.play && (t.modelViewerUi.play(), e && e.$element && t && t.modelId && nc && e.$element.setAttribute(nc, t.modelId))
        })), t.$element.addEventListener("shopify_model_viewer_ui_toggle_play", (() => {
            t.$container.dispatchEvent(new CustomEvent("theme:media:play"))
        })), t.$element.addEventListener("shopify_model_viewer_ui_toggle_pause", (() => {
            t.$container.dispatchEvent(new CustomEvent("theme:media:pause"))
        }))
    }
    async function dc(t) {
        const e = document.querySelector(`[data-player="${t}"]`),
            i = e.querySelector("video");
        await kt({
            name: "video-ui",
            version: "1.0"
        });
        const s = new window.Shopify.Plyr(i);
        return e.addEventListener("pause", (() => {
            s.pause && s.pause()
        })), e.addEventListener("play", (() => {
            try {
                s.play ? s.paused && s.play() : s.addEventListener("onReady", (() => {
                    s.play()
                }))
            } catch (t) {
                console.warn(t)
            }
        })), e.addEventListener("destroy", (() => {
            try {
                s.destroy && s.destroy()
            } catch (t) {
                console.warn(t)
            }
        })), s
    }
    const uc = {
            productSlideshow: "[data-product-slideshow]",
            slideshowMobileStyle: "data-slideshow-mobile-style",
            slideshowDesktopStyle: "data-slideshow-desktop-style",
            productThumbs: "[data-product-thumbs]",
            leftThumbsHolder: "[data-thumbs-holder]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            dataMediaId: "data-media-id",
            dataMediaSelect: "data-media-select",
            mediaType: "data-type",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            modelViewerTag: "model-viewer",
            allPlayers: "[data-player]",
            loopVideo: "data-enable-video-looping",
            verticalAlignment: "[data-thumbnails-left]",
            arrowPrev: "[data-thumbs-arrow-prev]",
            arrowNext: "[data-thumbs-arrow-next]",
            aspectRatio: "data-aspect-ratio",
            flickitylockHeight: "flickity-lock-height"
        },
        pc = "is-activated",
        mc = "show",
        gc = "enable-video-draggable";

    function yc(t, e) {
        return "youtube" === e ? t.addEventListener("onStateChange", (t => {
            0 === t.data && t.target.playVideo()
        })) : "vimeo" === e && t.on("ended", (() => {
            t.play()
        })), t
    }
    const fc = "data-store-availability-container",
        wc = "[data-api-content]",
        vc = "[data-pickup-drawer]",
        bc = "[data-pickup-drawer-open]",
        Sc = "[data-pickup-drawer-close]",
        Ec = "[data-pickup-body]",
        Lc = "drawer--visible",
        kc = "hide",
        Tc = "is-pickup-visible";
    let Ac = {};
    const qc = {
            onLoad() {
                Ac[this.id] = new class {
                    fetchPickupAvailability(t) {
                        const e = this.container.querySelector(`[${fc}]`);
                        if (!e) return;
                        const i = t && t.detail.variant ? t.detail.variant.id : e.getAttribute(fc);
                        !t || t.detail.variant ? i && fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`).then(this.handleErrors).then((t => t.text())).then((t => {
                            const i = (new DOMParser).parseFromString(t, "text/html").querySelector(wc).innerHTML;
                            e.innerHTML = i, e.classList.remove(kc), this.drawer = this.container.querySelector(vc), this.buttonDrawerOpen = this.container.querySelector(bc), this.buttonDrawerClose = this.container.querySelectorAll(Sc), this.drawerBody = this.container.querySelector(Ec), this.buttonDrawerOpen && this.buttonDrawerOpen.addEventListener("click", (() => this.openDrawer())), this.buttonDrawerClose.length && this.buttonDrawerClose.forEach((t => {
                                t.addEventListener("click", (() => this.closeDrawer()))
                            }))
                        })).catch((t => {
                            console.error(t)
                        })) : e.classList.add(kc)
                    }
                    openDrawer() {
                        this.drawer && (document.body.classList.add(Tc), this.drawer.classList.add(Lc), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0
                        })))
                    }
                    closeDrawer() {
                        this.drawer && (document.body.classList.remove(Tc), this.drawer.classList.remove(Lc), this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })), this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        })))
                    }
                    handleErrors(t) {
                        return t.ok ? t : t.json().then((function(e) {
                            throw new O({
                                status: t.statusText,
                                headers: t.headers,
                                json: e
                            })
                        }))
                    }
                    constructor(t) {
                        this.container = t.container, this.drawer = null, this.buttonDrawerOpen = null, this.buttonDrawerClose = null, this.drawerBody = null, this.fetchPickupAvailability(), this.container.addEventListener("theme:variant:change", (t => this.fetchPickupAvailability(t)))
                    }
                }(this)
            }
        },
        Cc = "[data-product-form]",
        xc = "data-option-position",
        Pc = '[name^="options"], [data-popout-option]',
        $c = "data-value",
        Mc = "sold-out",
        Ic = "unavailable";
    const Hc = "[data-section-id]",
        Dc = "[data-quickview-modal]",
        _c = "[data-product-form]",
        Bc = "[data-product-slideshow]",
        Fc = "[data-add-to-cart]",
        Wc = "[data-add-to-cart-text]",
        Oc = "[data-compare-price]",
        Rc = "[data-compare-text]",
        Nc = "[data-buttons-wrapper]",
        zc = "[data-product-select]",
        Vc = "[data-price-wrapper]",
        jc = "[data-button-price]",
        Uc = "[data-product-json]",
        Jc = "[data-product-price]",
        Qc = "[data-product-unit-price]",
        Gc = "[data-product-base]",
        Yc = "[data-product-unit]",
        Xc = "data-enable-history-state",
        Kc = "data-option-position",
        Zc = "[data-option-value]",
        th = "[data-subscription-watch-price]",
        eh = "[data-subscription-selectors]",
        ih = "[data-price-off]",
        sh = "[data-price-off-type]",
        oh = "[data-price-off-amount]",
        rh = "[data-toggles-group]",
        nh = "data-group-toggle",
        ah = "[data-plan-description]",
        lh = "[data-remaining-count]",
        ch = "data-remaining-max",
        hh = "[data-remaining-wrapper]",
        dh = "[data-product-remaining-json]",
        uh = "[data-product-preorder]",
        ph = "hide",
        mh = "variant--soldout",
        gh = "variant--unavailable",
        yh = "product__price--sale",
        fh = "count-is-low",
        wh = "count-is-in",
        vh = "count-is-out",
        bh = "count-is-unavailable";
    let Sh = class extends HTMLElement {
            connectedCallback() {
                this.outerSection = this.container.closest(Hc), this.quickview = this.container.closest(Dc), this.outerWrapper = this.quickview ? this.quickview : this.outerSection, this.productFormElement = this.container.querySelector(_c), this.productForm = this.container.querySelector(_c), this.slideshow = this.outerWrapper.querySelector(Bc), this.enableHistoryState = !(!this.outerSection || !this.outerSection.hasAttribute(Xc)) && "true" === this.outerSection.getAttribute(Xc), this.hasUnitPricing = this.outerWrapper.querySelector(Yc), this.subSelectors = this.outerWrapper.querySelector(eh), this.subPrices = this.outerWrapper.querySelector(th), this.priceOffWrap = this.outerWrapper.querySelector(ih), this.priceOffAmount = this.outerWrapper.querySelector(oh), this.priceOffType = this.outerWrapper.querySelector(sh), this.planDecription = this.outerWrapper.querySelector(ah), this.isPreOrder = this.container.querySelector(uh), this.remainingWrapper = this.outerWrapper.querySelector(hh);
                const t = this.outerWrapper.querySelector(`[${ch}]`);
                this.sellout = null, this.remainingWrapper && t && (this.remainingMaxInt = parseInt(t.getAttribute(ch), 10), this.remainingCount = this.outerWrapper.querySelector(lh), this.remainingJSONWrapper = this.outerWrapper.querySelector(dh), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML ? this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML) : console.warn("Missing product quantity JSON")), Nr(this.outerWrapper);
                let e = null;
                this.productJSON = null;
                const i = this.outerWrapper.querySelector(Uc);
                i && (e = i.innerHTML), e && this.productForm ? (this.productJSON = JSON.parse(e), this.sellout = new class {
                    init() {
                        this.update()
                    }
                    update() {
                        this.getCurrentState(), this.optionElements.forEach((t => {
                            const e = t.value || t.getAttribute($c),
                                i = t.closest(`[${xc}]`).getAttribute(xc),
                                s = parseInt(i, 10) - 1;
                            let o = [...this.selections];
                            o[s] = e;
                            const r = this.productJSON.variants.find((t => {
                                let e = !0;
                                for (let i = 0; i < o.length; i++) t.options[i] !== o[i] && (e = !1);
                                return e
                            }));
                            t.classList.remove(Mc, Ic), void 0 === r ? t.classList.add(Ic) : r && !1 === r.available && t.classList.add(Mc)
                        }))
                    }
                    getCurrentState() {
                        for (var t of (this.formData = new FormData(this.form), this.selections = [], this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1])
                    }
                    constructor(t, e) {
                        this.container = t, this.productJSON = e, this.form = this.container.querySelector(Cc), this.formData = new FormData(this.form), this.optionElements = this.container.querySelectorAll(Pc), this.productJSON && this.form && this.init()
                    }
                }(this.outerWrapper, this.productJSON), this.linkForm()) : console.warn("Missing product form or product JSON"), this.productJSON && new class {
                    updateCookie() {
                        let t = this.cookie.read();
                        const e = t.indexOf(this.handle); - 1 === e ? (t.unshift(this.handle), t = t.splice(0, Z)) : (t.splice(e, 1), t.unshift(this.handle)), this.cookie.write(t)
                    }
                    constructor(t) {
                        this.handle = t, this.cookie = new X(ht), void 0 !== this.handle && (ut.push(this.handle), this.updateCookie())
                    }
                }(this.productJSON.handle)
            }
            destroy() {
                this.productForm.destroy()
            }
            linkForm() {
                this.productForm = new class {
                    destroy() {
                        this._listeners.removeAll()
                    }
                    options() {
                        return this._serializeInputValues(this.optionInputs, (function(t) {
                            return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                        }))
                    }
                    variant() {
                        const t = this.options();
                        return t.length ? yt(this.product, t) : this.product.variants[0]
                    }
                    plan(t) {
                        let e = {
                            allocation: null,
                            group: null,
                            detail: null
                        };
                        const i = new FormData(this.form).get("selling_plan");
                        if (t && t.selling_plan_allocations && t.selling_plan_allocations.length > 0) {
                            const e = [...new Set(t.selling_plan_allocations.map((t => t.selling_plan_group_id)))],
                                i = this.element.querySelectorAll("[data-subscription-group]");
                            if (!i.length) return;
                            i.forEach((t => t.style.display = "none")), e.forEach((t => {
                                this.element.querySelector(`[data-selling-plan-group="${t}"]`).style.display = "block"
                            }))
                        }
                        return i && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                            return t.selling_plan_id.toString() === i.toString()
                        }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                            return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                        }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                            return t.id.toString() === i.toString()
                        }))), e && e.allocation && e.detail && e.allocation ? e : null
                    }
                    properties() {
                        return this._serializeInputValues(this.propertyInputs, (function(t) {
                            return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                        }))
                    }
                    quantity() {
                        return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                    }
                    getFormState() {
                        const t = this.variant();
                        return {
                            options: this.options(),
                            variant: t,
                            properties: this.properties(),
                            quantity: this.quantity(),
                            plan: this.plan(t)
                        }
                    }
                    _setIdInputValue(t) {
                        t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                    }
                    _onSubmit(t, e) {
                        e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                    }
                    _onOptionChange(t) {
                        this._setIdInputValue(t.dataset.variant)
                    }
                    _onFormEvent(t) {
                        return void 0 === t ? Function.prototype : function(e) {
                            e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                        }.bind(this)
                    }
                    _initInputs(t, e) {
                        return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                            return this._listeners.add(t, "change", this._onFormEvent(e)), t
                        }.bind(this))
                    }
                    _serializeInputValues(t, e) {
                        return t.reduce((function(t, i) {
                            return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && t.push(e({
                                name: i.name,
                                value: i.value
                            })), t
                        }), [])
                    }
                    _validateProductObject(t) {
                        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                        if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                        return t
                    }
                    constructor(t, e, i, s) {
                        this.element = t, this.form = "FORM" == e.tagName ? e : e.querySelector("form"), this.product = this._validateProductObject(i), this.variantElement = this.form.querySelector(wt), s = s || {}, this.clickedElement = null, this._listeners = new gt, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)), this.optionInputs = this._initInputs(bt, s.onOptionChange), this.planInputs = this._initInputs(vt, s.onPlanChange), this.quantityInputs = this._initInputs(St, s.onQuantityChange), this.propertyInputs = this._initInputs(Et, s.onPropertyChange)
                    }
                }(this.outerWrapper, this.productFormElement, this.productJSON, {
                    onOptionChange: this.onOptionChange.bind(this),
                    onPlanChange: this.onPlanChange.bind(this),
                    onQuantityChange: this.onQuantityChange.bind(this)
                }), this.pushState(this.productForm.getFormState(), !0), this.subsToggleListeners()
            }
            onOptionChange(t) {
                this.pushState(t.dataset)
            }
            onPlanChange(t) {
                this.subPrices && this.pushState(t.dataset)
            }
            onQuantityChange(t) {
                const e = t.dataset;
                this.productState = this.setProductState(e), this.updateButtonPrices(e)
            }
            pushState(t, e = !1) {
                this.productState = this.setProductState(t), this.updateProductImage(t), this.updateAddToCartState(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSubscriptionText(t), this.updateLegend(t), this.updateRemaining(t), this.fireHookEvent(t), this.sellout && this.sellout.update(t), this.enableHistoryState && !e && this.updateHistoryState(t)
            }
            updateAddToCartState(t) {
                const e = t.variant;
                let i = theme.strings.addToCart;
                const s = this.outerWrapper.querySelectorAll(Vc),
                    o = this.outerWrapper.querySelector(Nc),
                    r = null == o ? void 0 : o.querySelectorAll(Fc),
                    n = null == o ? void 0 : o.querySelectorAll(Wc);
                if (this.isPreOrder && (i = theme.strings.preOrder), s.length && e && s.forEach((t => {
                    t.classList.remove(ph)
                })), (null == r ? void 0 : r.length) && r.forEach((t => {
                    e && e.available ? t.disabled = !1 : t.disabled = !0
                })), (null == n ? void 0 : n.length) && n.forEach((t => {
                    e ? e.available ? t.innerHTML = i : t.innerHTML = theme.strings.soldOut : t.innerHTML = theme.strings.unavailable
                })), o)
                    if (e) {
                        e.available ? o.classList.remove(mh, gh) : (o.classList.add(mh), o.classList.remove(gh));
                        const t = o.querySelector(zc);
                        t && (t.value = e.id)
                    } else o.classList.add(gh), o.classList.remove(mh)
            }
            updateLegend(t) {
                const e = t.variant;
                if (e) {
                    this.container.parentNode.querySelectorAll(Zc).forEach((t => {
                        const i = t.closest(`[${Kc}]`);
                        if (i) {
                            const s = i.getAttribute(Kc),
                                o = parseInt(s, 10) - 1;
                            this.newValue = e.options[o], t.innerHTML = this.newValue
                        }
                    }))
                }
            }
            updateHistoryState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = window.location.href;
                if (e && s.includes("/product")) {
                    const t = new window.URL(s),
                        o = t.searchParams;
                    o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                    const r = t.toString();
                    window.history.replaceState({
                        path: r
                    }, "", r)
                }
            }
            updateRemaining(t) {
                const e = t.variant;
                if (e && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                    const t = this.remainingJSON[e.id];
                    t && t <= this.remainingMaxInt && t > 0 ? (this.remainingWrapper.classList.remove(wh, vh, bh), this.remainingWrapper.classList.add(fh), this.remainingCount.innerHTML = t) : this.productState.soldOut ? (this.remainingWrapper.classList.remove(fh, wh, bh), this.remainingWrapper.classList.add(vh)) : this.productState.available && (this.remainingWrapper.classList.remove(fh, vh, bh), this.remainingWrapper.classList.add(wh))
                } else this.remainingWrapper && (this.remainingWrapper.classList.remove(wh, vh, fh), this.remainingWrapper.classList.add(bh))
            }
            getBaseUnit(t) {
                return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
            }
            subsToggleListeners() {
                this.outerWrapper.querySelectorAll(rh).forEach((t => {
                    t.addEventListener("change", function(t) {
                        const e = t.target.value.toString(),
                            i = this.outerWrapper.querySelector(`[${nh}="${e}"]`),
                            s = this.outerWrapper.querySelectorAll(`[${nh}]`);
                        if (i) {
                            i.classList.remove(ph);
                            const t = i.querySelector('[name="selling_plan"]');
                            t.checked = !0, t.dispatchEvent(new Event("change"))
                        }
                        s.forEach((t => {
                            if (t !== i) {
                                t.classList.add(ph);
                                t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                    t.checked = !1, t.dispatchEvent(new Event("change"))
                                }))
                            }
                        }))
                    }.bind(this))
                }))
            }
            updateSaleText(t) {
                this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(ph)
            }
            updateSaleTextStandard(t) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
                const e = t.variant;
                if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                    const t = (e.compare_at_price - e.price) / e.compare_at_price,
                        i = Math.floor(100 * t);
                    this.priceOffAmount.innerHTML = `${i}%`
                } else {
                    const t = e.compare_at_price - e.price;
                    this.priceOffAmount.innerHTML = this.formattingMoney(t)
                }
                this.priceOffWrap.classList.remove(ph)
            }
            updateSaleTextSubscription(t) {
                this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
                const e = t.variant,
                    i = t.plan.detail.price_adjustments[0],
                    s = i.value;
                i && "percentage" === i.value_type ? this.priceOffAmount.innerHTML = `${s}%` : i && "price" === i.value_type ? this.priceOffAmount.innerHTML = this.formattingMoney(e.price - i.value) : this.priceOffAmount.innerHTML = this.formattingMoney(s), this.priceOffWrap.classList.remove(ph)
            }
            updateSubscriptionText(t) {
                t.plan && this.planDecription && null !== t.plan.detail.description ? (this.planDecription.innerHTML = t.plan.detail.description, this.planDecription.classList.remove(ph)) : this.planDecription && this.planDecription.classList.add(ph)
            }
            getPrices(t) {
                const e = t.variant,
                    i = t.plan;
                let s = "",
                    o = "";
                return this.productState.available && (s = e.compare_at_price, o = e.price), this.productState.hasPlan && (o = i.allocation.price), this.productState.planSale && (s = i.allocation.compare_at_price, o = i.allocation.price), {
                    price: o,
                    comparePrice: s
                }
            }
            updateButtonPrices(t) {
                const e = this.outerWrapper.querySelectorAll(jc),
                    {
                        price: i
                    } = this.getPrices(t);
                e.length && e.forEach((e => {
                    const s = t.quantity * i;
                    e.innerHTML = this.formattingMoney(s)
                }))
            }
            updateProductPrices(t) {
                const e = t.variant,
                    i = this.outerWrapper.querySelectorAll(Vc),
                    s = this.outerWrapper.querySelectorAll(jc),
                    {
                        price: o,
                        comparePrice: r
                    } = this.getPrices(t);
                i.forEach((t => {
                    const i = t.querySelector(Oc),
                        s = t.querySelector(Jc),
                        n = t.querySelector(Rc);
                    i && (this.productState.onSale || this.productState.planSale ? (i.classList.remove(ph), n.classList.remove(ph), s.classList.add(yh)) : (i.classList.add(ph), n.classList.add(ph), s.classList.remove(yh)), i.innerHTML = this.formattingMoney(r)), s && (s.innerHTML = e ? this.formattingMoney(o) : "&nbsp;")
                })), s.length && s.forEach((e => {
                    const i = t.quantity * o;
                    e.innerHTML = this.formattingMoney(i)
                })), this.hasUnitPricing && this.updateProductUnits(t)
            }
            updateProductUnits(t) {
                const e = t.variant,
                    i = t.plan;
                let s = null;
                if (e && e.unit_price && (s = e.unit_price), i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price), s) {
                    const t = this.getBaseUnit(e);
                    this.outerWrapper.querySelector(Qc).innerHTML = this.formattingMoney(s), this.outerWrapper.querySelector(Gc).innerHTML = t, W(this.outerWrapper.querySelector(Yc))
                } else Tn(this.outerWrapper.querySelector(Yc))
            }
            fireHookEvent(t) {
                const e = t.variant;
                this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                    detail: {
                        variant: e
                    },
                    bubbles: !0
                }))
            }
            setProductState(t) {
                const e = t.variant,
                    i = t.plan,
                    s = {
                        available: !0,
                        soldOut: !1,
                        onSale: !1,
                        showUnitPrice: !1,
                        requiresPlan: !1,
                        hasPlan: !1,
                        planPerDelivery: !1,
                        planSale: !1
                    };
                return !e || e.requires_selling_plan && !i ? s.available = !1 : (e.available || (s.soldOut = !0), e.compare_at_price > e.price && (s.onSale = !0), e.unit_price && (s.showUnitPrice = !0), this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), i.allocation.compare_at_price > i.allocation.price && (s.planSale = !0))), s
            }
            updateProductImage(t) {
                const e = t.variant;
                e && this.slideshow && e.featured_media && e.featured_media.id && this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                    detail: {
                        id: e.featured_media.id
                    }
                }))
            }
            formattingMoney(t) {
                return theme.settings.currency_code_enable ? l.formatMoney(t, theme.moneyFormat) + ` ${theme.currencyCode}` : l.formatMoney(t, theme.moneyFormat)
            }
            constructor() {
                super(), this.container = this
            }
        },
        Eh = class extends HTMLElement {
            connectedCallback() {
                fetch(this.dataset.url).then((t => t.text())).then((t => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector("[data-api-content]");
                    i && (this.innerHTML = i.innerHTML);
                    const s = this.closest("[data-product-complimentary-loaded]");
                    s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded")
                })).catch((t => {
                    console.error(t)
                }))
            }
            constructor() {
                super()
            }
        };
    const Lh = "[data-product-slideshow]",
        kh = "[data-product-image]",
        Th = "[data-zoom-button]",
        Ah = "[data-zoom-wrapper]",
        qh = "data-media-id";
    const Ch = "body",
        xh = "[data-related-section]",
        Ph = "[data-tabs-holder]",
        $h = "data-tab",
        Mh = "data-tab-index",
        Ih = "data-block-id",
        Hh = ".tabs > button",
        Dh = ".tab-link",
        _h = ".tab-link__recent",
        Bh = ".tab-content",
        Fh = "[data-scrollbar]",
        Wh = "a:first-child, input:first-child",
        Oh = "current",
        Rh = "hide",
        Nh = "alt",
        zh = "is-focused",
        Vh = {};
    const jh = {
            onLoad() {
                Vh[this.id] = [];
                this.container.querySelectorAll(Ph).forEach((t => {
                    Vh[this.id].push(new class {
                        init() {
                            const t = this.container,
                                e = t.querySelectorAll(Hh),
                                i = t.querySelector(`${Dh}-0`),
                                s = t.querySelector(`${Bh}-0`);
                            s && s.classList.add(Oh), i && i.classList.add(Oh), this.checkVisibleTabLinks(), this.container.addEventListener("theme:tabs:check", (() => this.checkRecentTab())), this.container.addEventListener("theme:tabs:hide", (() => this.hideRelatedTab())), e.length && e.forEach((e => {
                                const i = parseInt(e.getAttribute($h)),
                                    s = t.querySelector(`${Bh}-${i}`);
                                e.addEventListener("click", (() => {
                                    this.tabChange(e, s)
                                })), e.addEventListener("keyup", (t => {
                                    "Space" !== t.code && "Enter" !== t.code || !this.body.classList.contains(zh) || (this.tabChange(e, s), s.querySelector("a, input") && (this.accessibility.lastFocused = e, this.accessibility.a11y.trapFocus(s, {
                                        elementToFocus: s.querySelector(Wh)
                                    })))
                                }))
                            }))
                        }
                        tabChange(t, e) {
                            this.container.querySelector(`${Hh}.${Oh}`).classList.remove(Oh), this.container.querySelector(`${Bh}.${Oh}`).classList.remove(Oh), t.classList.add(Oh), e.classList.add(Oh), t.classList.contains(Rh) && e.classList.add(Rh), this.checkVisibleTabLinks(), this.container.dispatchEvent(new CustomEvent("theme:tab:change"))
                        }
                        initNativeScrollbar() {
                            this.scrollbarHolder.length && this.scrollbarHolder.forEach((t => {
                                new U(t)
                            }))
                        }
                        checkVisibleTabLinks() {
                            const t = this.container.querySelectorAll(Hh),
                                e = this.container.querySelectorAll(`${Dh}.${Rh}`);
                            t.length - e.length < 2 ? this.container.classList.add(Nh) : this.container.classList.remove(Nh)
                        }
                        checkRecentTab() {
                            const t = this.container.querySelector(_h);
                            if (t) {
                                t.classList.remove(Rh);
                                const e = parseInt(t.getAttribute($h)),
                                    i = this.container.querySelector(`${Bh}[${Mh}="${e}"]`);
                                i && i.classList.remove(Rh), this.checkVisibleTabLinks(), this.initNativeScrollbar()
                            }
                        }
                        hideRelatedTab() {
                            const t = this.container.querySelector(xh);
                            if (!t) return;
                            const e = t.closest(`${Bh}.${Oh}`);
                            if (!e) return;
                            const i = parseInt(e.getAttribute(Mh)),
                                s = this.container.querySelectorAll(Hh);
                            if (s.length > i) {
                                const t = s[i].nextElementSibling;
                                t && (s[i].classList.add(Rh), t.dispatchEvent(new Event("click")), this.initNativeScrollbar())
                            }
                        }
                        onBlockSelect(t) {
                            const e = this.container.querySelector(`${Dh}[${Ih}="${t.detail.blockId}"]`);
                            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                                top: 0,
                                left: e.offsetLeft - e.clientWidth,
                                behavior: "smooth"
                            }))
                        }
                        constructor(t) {
                            this.container = t, this.body = document.querySelector(Ch), this.accessibility = window.accessibility, this.container && (this.scrollbarHolder = this.container.querySelectorAll(Fh), this.init(), this.initNativeScrollbar())
                        }
                    }(t))
                }))
            },
            onBlockSelect(t) {
                Vh[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            }
        },
        Uh = "[data-share-url]",
        Jh = "data-section-type",
        Qh = "[data-share-details]",
        Gh = "[data-share-summary]",
        Yh = "[data-share-copy]",
        Xh = "[data-share-button]",
        Kh = "[data-close-button]",
        Zh = "[data-success-message]",
        td = "[data-share-holder]",
        ed = "is-hidden";
    let id = class extends HTMLElement {
        init() {
            navigator.share ? (this.mainDetailsToggle.classList.add(ed), this.shareButton.classList.remove(ed), this.shareButton.addEventListener("click", (() => {
                navigator.share({
                    url: this.urlToShare,
                    title: document.title
                })
            }))) : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)), this.mainDetailsToggle.addEventListener("focusout", (() => {
                setTimeout((() => {
                    this.contains(document.activeElement) || this.close()
                }))
            })), this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)), this.closeButton.addEventListener("click", this.close.bind(this)), this.container.addEventListener("keyup", this.keyboardEvents.bind(this)))
        }
        updateShareLink() {
            "product" == this.container.getAttribute(Jh) && this.container.addEventListener("theme:variant:change", (t => {
                t.detail.variant && (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`, this.urlInput && (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${t.detail.variant.id}`))
            }))
        }
        toggleDetails() {
            this.mainDetailsToggle.open || (this.successMessage.classList.add(ed), this.successMessage.textContent = "", this.closeButton.classList.add(ed), this.shareCopy.focus())
        }
        copyToClipboard() {
            navigator.clipboard.writeText(this.urlInput.value).then((() => {
                this.successMessage.classList.remove(ed), this.successMessage.textContent = theme.strings.successMessage, this.closeButton.classList.remove(ed), this.closeButton.focus()
            }))
        }
        close() {
            this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1)
        }
        keyboardEvents(t) {
            "Escape" === t.code && (this.mainDetailsToggle.focus(), this.close())
        }
        constructor() {
            super(), this.container = this.closest(`[${Jh}]`), this.mainDetailsToggle = this.querySelector(Qh), this.shareButton = this.querySelector(Xh), this.shareCopy = this.querySelector(Yh), this.shareSummary = this.querySelector(Gh), this.closeButton = this.querySelector(Kh), this.successMessage = this.querySelector(Zh), this.shareHolder = this.querySelector(td), this.urlInput = this.querySelector(Uh), this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href, this.init(), this.updateShareLink()
        }
    };
    const sd = "data-image-filter",
        od = "[data-product-slideshow]",
        rd = "[data-product-thumbs]",
        nd = "[data-slideshow-thumbnail]",
        ad = "[data-media-slide]",
        ld = "hide",
        cd = "flickity-enabled";
    const hd = "[data-product-json]",
        dd = "[data-zoom-button]",
        ud = "[data-truncated-holder]",
        pd = "[data-truncated-button]",
        md = "data-truncated-content",
        gd = "is-expanded",
        yd = "is-visible",
        fd = [];
    const wd = {
        onLoad() {
            fd[this.id] = new class {
                init() {
                    var t, e;
                    this.zoomEnabled = null !== this.container.querySelector(dd), this.zoomEnabled && (t = this.container, e = this.product, kt({
                        url: window.theme.assets.photoswipe
                    }).then((() => {
                        const i = window.themePhotoswipe.PhotoSwipe.default,
                            s = window.themePhotoswipe.PhotoSwipeUI.default;
                        t.querySelectorAll(Th).forEach((o => {
                            o.addEventListener("click", (o => {
                                const r = t.querySelector(Ah),
                                    n = o.target.closest(`[${qh}]`).getAttribute(qh).toString(),
                                    a = [];
                                for (let t = 0; t < e.media.length; t++) "image" === e.media[t].media_type && (a[a.length] = {
                                    src: e.media[t].src,
                                    w: e.media[t].width,
                                    h: e.media[t].height,
                                    id: e.media[t].id
                                });
                                const l = {
                                    index: a.findIndex((t => t.id.toString() === n)),
                                    showHideOpacity: !0,
                                    showAnimationDuration: 150,
                                    hideAnimationDuration: 250,
                                    bgOpacity: 1,
                                    spacing: 0,
                                    allowPanToNext: !1,
                                    maxSpreadZoom: 3,
                                    history: !1,
                                    loop: !0,
                                    pinchToClose: !1,
                                    modal: !1,
                                    closeOnScroll: !1,
                                    closeOnVerticalDrag: !0,
                                    getDoubleTapZoom: function(t, e) {
                                        return t ? 1.67 : e.initialZoomLevel < .7 ? 1 : 1.3
                                    },
                                    getThumbBoundsFn: function() {
                                        let e = t.querySelector(Lh);
                                        e || (e = t.querySelector(kh));
                                        const i = window.pageYOffset || document.documentElement.scrollTop,
                                            s = e.getBoundingClientRect();
                                        return {
                                            x: s.left,
                                            y: s.top + i,
                                            w: s.width
                                        }
                                    }
                                };
                                r.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                    bubbles: !0
                                }));
                                const c = new i(r, s, a, l);
                                c.init(), c.listen("close", (function() {
                                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                        bubbles: !0
                                    }))
                                }))
                            }))
                        }))
                    })).catch((t => console.error(t)))), this.truncateElementHolder && this.truncateElement && (setTimeout(this.resizeEventTruncate, 50), document.addEventListener("theme:resize", this.resizeEventTruncate)), new Ie(this.container)
                }
                truncateText() {
                    if (this.truncateElementHolder.classList.contains(yd)) return;
                    const t = this.truncateElement.querySelectorAll("style");
                    t.length && t.forEach((t => {
                        this.truncateElementHolder.prepend(t)
                    }));
                    const e = this.truncateElement.cloneNode(!0),
                        i = this.truncateElement.getAttribute(md),
                        s = this.truncateElement.nextElementSibling;
                    s && s.remove(), this.truncateElement.parentElement.append(e);
                    const o = this.truncateElement.nextElementSibling;
                    o.classList.add(i), o.removeAttribute(md), W(o), ((t = "", e = 1, i = {}) => {
                        const s = {
                                replaceStr: "...",
                                debounceDelay: 250,
                                delimiter: " ",
                                ...i
                            },
                            o = t && (t instanceof NodeList ? t : 1 === t.nodeType ? [t] : document.querySelectorAll(t));
                        for (let t = 0; t < o.length; t++) {
                            const i = o[t],
                                r = /<!--[\s\S]*?-->/g,
                                n = i.innerHTML.replace(r, "").split(s.delimiter);
                            i.innerHTML = "";
                            const a = window.getComputedStyle(i);
                            n.reduce(Xl, {
                                el: i,
                                buffer: i.innerHTML,
                                elStyle: a,
                                elHeight: 0,
                                rowsLimit: e,
                                rowsWrapped: 0,
                                options: s
                            })
                        }
                    })(o, 5, {
                        replaceStr: "",
                        delimiter: " "
                    }), Tn(o), this.truncateElement.innerHTML !== o.innerHTML ? this.truncateElementHolder.classList.add(gd) : (o.remove(), this.truncateElementHolder.classList.remove(gd)), this.toggleTruncatedContent(this.truncateElementHolder)
                }
                toggleTruncatedContent(t) {
                    const e = t.querySelector(pd);
                    e && e.addEventListener("click", (e => {
                        e.preventDefault(), t.classList.remove(gd), t.classList.add(yd)
                    }))
                }
                onBlockSelect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"))
                }
                onBlockDeselect(t) {
                    const e = this.container.querySelector(`[data-block-id="${t.detail.blockId}"]`);
                    e && e.dispatchEvent(new Event("click"))
                }
                onUnload() {
                    this.media.destroy(), this.truncateElementHolder && this.truncateElement && document.removeEventListener("theme:resize", this.resizeEventTruncate)
                }
                constructor(t) {
                    this.section = t, this.id = t.id, this.container = t.container, this.settings = t.settings, Oi(this.id), this.media = new class {
                        init() {
                            this.storeEvents(), this.connectSliderMediaEvents(), this.detectVideos(), this.detect3d(), this.scrollThumbs(), document.addEventListener("theme:resize:width", (() => {
                                this.scrollThumbs()
                            })), mt.onChange((() => {
                                this.connectSliderMediaEvents()
                            }))
                        }
                        connectSliderMediaEvents() {
                            mt.isMobile() ? this.createMobileSlider() : this.createDesktopSlider()
                        }
                        createMobileSlider() {
                            this.hasDesktopSlider && this.flkty && (this.destroySlider(), this.hasDesktopSlider = !1);
                            const t = {
                                autoPlay: !1,
                                prevNextButtons: !1,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                accessibility: !0,
                                watchCSS: !1,
                                wrapAround: !0,
                                rightToLeft: window.isRTL,
                                dragThreshold: 80,
                                contain: !0,
                                fade: !0
                            };
                            "carousel" == this.mobileStyle && (t.contain = !1, t.dragThreshold = 10, t.fade = !1), "slideshow" == this.mobileStyle && (t.pageDots = !0, t.fade = !1, t.dragThreshold = 10), this.createSlider(t), this.hasMobileSlider = !0
                        }
                        createDesktopSlider() {
                            if (this.hasMobileSlider && this.flkty && (this.destroySlider(), this.hasMobileSlider = !1), "none" == this.desktopStyle) return;
                            const t = {
                                autoPlay: !1,
                                prevNextButtons: !1,
                                pageDots: !1,
                                adaptiveHeight: !0,
                                accessibility: !0,
                                watchCSS: !1,
                                wrapAround: !0,
                                rightToLeft: window.isRTL,
                                dragThreshold: 80,
                                contain: !0,
                                fade: !0
                            };
                            this.createSlider(t), this.hasDesktopSlider = !0
                        }
                        createSlider(t) {
                            this.flkty = new s(this.slideshow, t), this.flkty.resize(), this.currentSlide = this.slideshow.querySelectorAll(uc.mediaSlide)[0], this.setDraggable(), this.addEventListeners()
                        }
                        destroySlider() {
                            this.removeEventListeners(), this.flkty.destroy()
                        }
                        storeEvents() {
                            this.storeFlktyChange = t => this.doFlktyChange(t), this.storeFlktySettle = t => this.doFlktySettle(t), this.storeImageChange = t => this.doImageChange(t), this.storeArrowPrevClick = t => this.doArrowPrevClick(t), this.storeArrowNextClick = t => this.doArrowNextClick(t), this.storeThumbClick = t => this.doThumbClick(t), this.storeThumbContainerScroll = t => this.doThumbContainerScroll(t)
                        }
                        addEventListeners() {
                            var t, e, i;
                            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.addEventListener("theme:image:change", this.storeImageChange), null === (t = this.arrowPrev) || void 0 === t || t.addEventListener("click", this.storeArrowPrevClick), null === (e = this.arrowNext) || void 0 === e || e.addEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.addEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((t => {
                                t.addEventListener("click", this.storeThumbClick)
                            }))
                        }
                        removeEventListeners() {
                            var t, e, i;
                            this.flkty.on("change", this.storeFlktyChange), this.flkty.on("settle", this.storeFlktySettle), this.slideshow.removeEventListener("theme:image:change", this.storeImageChange), null === (t = this.arrowPrev) || void 0 === t || t.removeEventListener("click", this.storeArrowPrevClick), null === (e = this.arrowNext) || void 0 === e || e.removeEventListener("click", this.storeArrowNextClick), null === (i = this.thumbs) || void 0 === i || i.removeEventListener("scroll", this.storeThumbContainerScroll), this.thumbImages.forEach((t => {
                                t.removeEventListener("click", this.storeThumbClick)
                            }))
                        }
                        addMediaEventListeners(t) {
                            t && (t.addEventListener("play", (() => {
                                (mt.isMobile() || mt.isTouch()) && this.updateDraggable(!1)
                            })), t.addEventListener("pause", (() => {
                                (mt.isMobile() || mt.isTouch()) && this.updateDraggable(!0)
                            })))
                        }
                        doFlktyChange(t) {
                            var e, i;
                            "model" !== this.mediaType && "video" !== this.mediaType && "external_video" !== this.mediaType || this.currentSlide.dispatchEvent(new CustomEvent("pause")), this.currentSlide = this.flkty.cells[t].element, this.slideshow.classList.remove(uc.flickitylockHeight);
                            const s = this.currentSlide.getAttribute(uc.dataMediaId),
                                o = null === (e = this.thumbWrapper) || void 0 === e ? void 0 : e.querySelector(`[${uc.dataMediaSelect}="${s}"]`);
                            null === (i = this.thumbWrapper) || void 0 === i || i.querySelector(`.${pc}`).classList.remove(pc), null == o || o.classList.add(pc), this.scrollThumbs()
                        }
                        doFlktySettle(t) {
                            this.allSlides = this.flkty.cells, this.currentSlide = this.flkty.cells[t].element, this.setDraggable(), document.body.classList.contains(uc.focusEnabled) && this.currentSlide.dispatchEvent(new Event("focus")), this.scrollThumbs()
                        }
                        doImageChange(t) {
                            var e = t.detail.id;
                            const i = `[${uc.dataMediaId}="${e}"]`,
                                s = this.flkty.cells.findIndex((t => t.element.matches(i)));
                            this.flkty.select(s), this.scrollThumbs()
                        }
                        doThumbContainerScroll() {
                            this.scrollThumbs("scroll")
                        }
                        doArrowPrevClick() {
                            this.scrollThumbs("clickPrev")
                        }
                        doArrowNextClick() {
                            this.scrollThumbs("clickNext")
                        }
                        doThumbClick(t) {
                            const e = t.currentTarget.getAttribute(uc.dataMediaSelect);
                            this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", {
                                detail: {
                                    id: e
                                }
                            }))
                        }
                        setDraggable() {
                            this.currentSlide && (this.mediaType = this.currentSlide.getAttribute(uc.mediaType), "model" === this.mediaType || "video" === this.mediaType || "external_video" === this.mediaType ? mt.isMobile() && mt.isTouch() ? this.updateDraggable(!0) : (this.currentSlide.dispatchEvent(new CustomEvent("play")), this.updateDraggable(!1)) : this.updateDraggable(!0))
                        }
                        updateDraggable(t) {
                            this.flkty && (this.flkty.options.draggable = t, this.flkty.updateDraggable(), this.slideshow.classList.toggle(gc, t))
                        }
                        detect3d() {
                            const t = this.container.querySelectorAll(uc.modelViewer);
                            t && (t.forEach((t => {
                                ! function(t, e) {
                                    Kl[e] = {
                                        loaded: !1
                                    };
                                    const i = t.getAttribute(sc),
                                        s = t.querySelector(rc),
                                        o = s.getAttribute(oc);
                                    if (null !== t.closest(ec)) {
                                        const i = t.closest(ec).parentElement.querySelector(ic);
                                        tc[e] = {
                                            $element: i,
                                            defaultId: o
                                        }
                                    }
                                    Zl[i] = {
                                        modelId: o,
                                        mediaId: i,
                                        sectionId: e,
                                        $container: t,
                                        $element: s
                                    }, window.Shopify.loadFeatures([{
                                        name: "shopify-xr",
                                        version: "1.0",
                                        onLoad: lc
                                    }, {
                                        name: "model-viewer-ui",
                                        version: "1.0",
                                        onLoad: cc
                                    }])
                                }(t, this.section.id), t.addEventListener("theme:media:play", (() => {
                                    this.updateDraggable(!1)
                                })), t.addEventListener("theme:media:pause", (() => {
                                    this.updateDraggable(!0)
                                }))
                            })), document.addEventListener("shopify_xr_launch", function() {
                                this.container.querySelectorAll(uc.allPlayers).forEach((t => {
                                    t.dispatchEvent(new CustomEvent("pause"))
                                }))
                            }.bind(this)))
                        }
                        detectVideos() {
                            const t = this.section.container.querySelectorAll(`${uc.videoPlayerExternal}, ${uc.videoPlayerNative}`);
                            for (var e of t) {
                                const t = e.dataset.player,
                                    i = e.dataset.host;
                                let s;
                                s = "youtube" === i ? Pa(t) : "vimeo" === i ? Ha(t) : dc(t), !0 === this.loopVideo && s.then((t => i ? yc(t, i) : (t.loop = !0, t))).catch((t => {
                                    console.error(t)
                                })), this.addMediaEventListeners(e)
                            }
                        }
                        pauseAllMedia() {
                            this.container.querySelector(uc.mediaSlide).dispatchEvent(new CustomEvent("pause"))
                        }
                        pauseOtherMedia(t) {
                            this.container.querySelector(`${uc.mediaSlide}:not([data-player="${t}"])`).dispatchEvent(new CustomEvent("pause"))
                        }
                        destroy() {
                            this.container.querySelectorAll(uc.allPlayers).forEach((t => {
                                t.dispatchEvent(new CustomEvent("destroy"))
                            }))
                        }
                        scrollThumbs(t) {
                            if (this.thumbs = this.container.querySelector(uc.productThumbs), this.thumbs) {
                                if (this.thumb = this.thumbs.querySelector(`.${pc}`), this.thumbItems = this.container.querySelectorAll(uc.thumbImage), this.lastThumb = this.thumbItems[this.thumbItems.length - 1], !this.thumb) return;
                                this.thumbsScrollTop = this.thumbs.scrollTop, this.thumbsScrollLeft = this.thumbs.scrollLeft, this.thumbsWidth = this.thumbs.offsetWidth, this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(uc.aspectRatio), this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight, this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth, this.checkThumbPositions(), this.toggleToActiveThumb(t), this.toggleArrows()
                            }
                        }
                        checkThumbPositions() {
                            this.thumbWidth = this.thumb.offsetWidth, this.thumbHeight = this.thumb.offsetHeight, this.thumbPosTop = this.thumb.offsetTop, this.thumbPosLeft = this.thumb.offsetLeft, this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth, this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight, this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2, this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2, this.topCheck = this.thumbsScrollTop > 0, this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos, this.leftCheck = this.thumbsScrollLeft > 0, this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos, this.verticalCheck = this.bottomCheck || this.topCheck, this.horizontalCheck = this.rightCheck || this.leftCheck
                        }
                        toggleToActiveThumb(t) {
                            "scroll" !== t && ("clickPrev" == t && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth)), "clickNext" == t && (this.verticalCheck ? (this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight, this.scrollLeftPosition = 0) : (this.scrollTopPosition = 0, this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth)), this.thumbs.scrollTo({
                                top: this.scrollTopPosition,
                                left: this.scrollLeftPosition,
                                behavior: "smooth"
                            }))
                        }
                        toggleArrows() {
                            (this.verticalCheck || this.verticalAlignment && !this.verticalCheck) && (this.arrowPrev.classList.toggle(mc, this.topCheck), this.arrowNext.classList.toggle(mc, this.bottomCheck)), (this.horizontalCheck || !this.verticalAlignment && !this.horizontalCheck) && (this.arrowPrev.classList.toggle(mc, this.leftCheck), this.arrowNext.classList.toggle(mc, this.rightCheck))
                        }
                        constructor(t) {
                            this.section = t, this.container = t.container, this.slideshow = this.container.querySelector(uc.productSlideshow), this.mobileStyle = this.slideshow.getAttribute(uc.slideshowMobileStyle), this.desktopStyle = this.slideshow.getAttribute(uc.slideshowDesktopStyle), this.arrowPrev = this.container.querySelector(uc.arrowPrev), this.arrowNext = this.container.querySelector(uc.arrowNext), this.leftThumbsHolder = this.container.querySelector(uc.leftThumbsHolder), this.thumbWrapper = this.container.querySelector(uc.productThumbs), this.thumbImages = this.container.querySelectorAll(uc.thumbImage), this.loopVideo = "true" === this.container.getAttribute(uc.loopVideo), this.verticalAlignment = Boolean(this.container.querySelector(uc.verticalAlignment)), this.flkty = null, this.thumbs = this.container.querySelector(uc.productThumbs), this.currentSlide = null, this.mediaType = null, this.hasMobileSlider = !1, this.hasDesktopSlider = !1, this.init()
                        }
                    }(t), new class {
                        listen() {
                            this.container.addEventListener("theme:variant:change", (t => {
                                t.detail.variant && (this.variantImage = t.detail.variant.featured_image, this.filterImages())
                            }))
                        }
                        filterImages() {
                            null !== this.variantImage && null !== this.variantImage.alt ? (this.variantImageAlt = this.variantImage.alt.split("#")[1], this.showImages()) : this.resetImages(), this.refreshSliders()
                        }
                        resetImages() {
                            this.thumbs.forEach((t => t.classList.remove(ld))), this.slides.forEach((t => t.classList.remove(ld)))
                        }
                        showImages() {
                            this.thumbs.forEach((t => {
                                "" === t.getAttribute(sd) || t.getAttribute(sd) === this.variantImageAlt ? t.classList.remove(ld) : t.classList.add(ld)
                            })), this.slides.forEach((t => {
                                "" === t.getAttribute(sd) || t.getAttribute(sd) === this.variantImageAlt ? t.classList.remove(ld) : t.classList.add(ld)
                            }))
                        }
                        refreshSliders() {
                            if (null !== this.slider && this.slider.classList.contains(cd)) {
                                const t = e.data(this.slider);
                                void 0 !== t && t.reloadCells()
                            }
                            if (null !== this.thumbSlider && this.thumbSlider.classList.contains(cd)) {
                                const t = h.data(this.thumbSlider);
                                void 0 !== t && t.reloadCells()
                            }
                        }
                        constructor(t) {
                            this.section = t, this.container = t.container, this.slider = this.container.querySelector(od), this.thumbSlider = this.container.querySelector(rd), this.thumbs = this.container.querySelectorAll(nd), this.slides = this.container.querySelectorAll(ad), this.variantImage = null, this.listen()
                        }
                    }(t);
                    const i = this.container.querySelector(hd);
                    i && "" !== i.innerHTML ? (this.product = JSON.parse(i.innerHTML), this.truncateElementHolder = this.container.querySelector(ud), this.truncateElement = this.container.querySelector(`[${md}]`), this.resizeEventTruncate = () => this.truncateText(), this.init()) : console.error("Missing product JSON")
                }
            }(this)
        },
        onUnload() {
            "function" == typeof fd[this.id].unload && fd[this.id].unload()
        },
        onBlockSelect(t) {
            "function" == typeof fd[this.id].onBlockSelect && fd[this.id].onBlockSelect(t)
        },
        onBlockDeselect(t) {
            "function" == typeof fd[this.id].onBlockDeselect && fd[this.id].onBlockDeselect(t)
        }
    };
    Ii("product", [wd, qc, kn, jh, Pt]), customElements.get("product-form") || customElements.define("product-form", Sh), customElements.get("product-complimentary") || customElements.define("product-complimentary", Eh), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("popout-select") || customElements.define("popout-select", br), customElements.get("share-button") || customElements.define("share-button", id);
    const vd = "data-toggle-grid",
        bd = "data-grid-large",
        Sd = "data-grid-small",
        Ed = "is-active",
        Ld = window.theme.sizes.small;
    var kd = {};
    const Td = {
            onLoad() {
                kd[this.id] = [];
                this.container.querySelectorAll(`[${vd}]`).forEach((t => {
                    kd[this.id].push(new class {
                        init() {
                            this.toggle.addEventListener("click", this.toggleFunction), document.addEventListener("theme:resize:width", this.toggleFunction), this.toggleEvent(!1)
                        }
                        unload() {
                            this.toggle.removeEventListener("click", this.toggleFunction), document.removeEventListener("theme:resize:width", this.toggleFunction)
                        }
                        toggleEvent(t = !0) {
                            const e = t && "click" === t.type,
                                i = window.innerWidth >= Ld ? bd : Sd,
                                s = this.container.querySelector(`[${i}]`),
                                o = s.getAttribute(i),
                                r = this.toggle.parentElement.querySelector(`[${vd}].${Ed}`);
                            let n = this.toggle.parentElement.querySelector(`[${vd}="${o}"]`);
                            e && (n = this.toggle, s.setAttribute(i, this.value)), r && r.classList.remove(Ed), n && n.classList.add(Ed)
                        }
                        constructor(t, e) {
                            this.container = e || document, this.toggle = t, this.value = this.toggle.getAttribute(vd), this.toggleFunction = t => this.toggleEvent(t), this.init()
                        }
                    }(t, this.container))
                }))
            },
            onUnload: function() {
                kd[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Ad = "data-sort-enabled",
        qd = "[data-sort-link]",
        Cd = "[data-sort-button-text]",
        xd = "data-value",
        Pd = "popout-list__item--current";
    var $d = "data-swatch";
    Ii("collection", [{
        onLoad() {
            this.collection = new class {
                init() {
                    new class {
                        init() {
                            this.sortLinks.forEach((t => {
                                t.addEventListener("click", (t => {
                                    t.preventDefault(), this.sortingResults(t)
                                }))
                            }))
                        }
                        sortingResults(t) {
                            const e = t.currentTarget,
                                i = e.getAttribute(xd),
                                s = e.innerText;
                            this.sortButtonText.innerText = s, this.sortButtonText.parentNode.dispatchEvent(new Event("click")), this.sort.querySelector(`.${Pd}`).classList.remove(Pd), e.parentNode.classList.add(Pd), this.sort.setAttribute(Ad, i), this.container.dispatchEvent(new CustomEvent("theme:form:filter", {
                                bubbles: !0,
                                detail: {
                                    params: i
                                }
                            }))
                        }
                        constructor(t) {
                            this.container = t.container, this.sort = this.container.querySelector(`[${Ad}]`), this.sortLinks = this.container.querySelectorAll(qd), this.sortButtonText = this.container.querySelector(Cd), this.sort && this.init()
                        Nr(this.container)
                        }
                    }(this.section)
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.swatches = this.container.querySelectorAll(`[${$d}]`), this.init()
                }
            }(this)
        }
    }, Wl, jl, Td, Ut, kn, G]), customElements.get("popout-select") || customElements.define("popout-select", br), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr), Ii("collection-row", [Ut, G, Zt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr), Ii("collection-tabs", [jh, tl, Ut]), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr);
    var Md = {};

    function Id(t) {
        return Md[t]
    }
    Md.basic = [], Md.light = [{
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "on"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], Md.light_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            lightness: "64"
        }, {
            hue: "#ff0000"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#bdbdbd"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f0f0f0"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "labels",
        stylers: [{
            lightness: "100"
        }]
    }, {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{
            visibility: "on"
        }]
    }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
            saturation: "-41"
        }, {
            color: "#e8ede7"
        }]
    }, {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: "-100"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            lightness: "25"
        }, {
            gamma: "1.06"
        }, {
            saturation: "-100"
        }, {
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            gamma: "10.00"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            gamma: "10.00"
        }, {
            lightness: "100"
        }, {
            weight: "0.4"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }, {
            weight: "0.01"
        }, {
            lightness: "39"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.50"
        }, {
            gamma: "10.00"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#cfe5ee"
        }, {
            visibility: "on"
        }]
    }], Md.white_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#444444"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], Md.white_label = [{
        featureType: "all",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            gamma: "3.86"
        }, {
            lightness: "100"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{
            color: "#cccccc"
        }]
    }, {
        featureType: "landscape",
        elementType: "all",
        stylers: [{
            color: "#f2f2f2"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road",
        elementType: "all",
        stylers: [{
            saturation: -100
        }, {
            lightness: 45
        }]
    }, {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "water",
        elementType: "all",
        stylers: [{
            color: "#e4e4e4"
        }, {
            visibility: "on"
        }]
    }], Md.dark_blank = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], Md.dark_label = [{
        featureType: "all",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{
            saturation: 36
        }, {
            color: "#000000"
        }, {
            lightness: 40
        }]
    }, {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [{
            visibility: "on"
        }, {
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: 1.2
        }]
    }, {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }, {
            lightness: "-82"
        }]
    }, {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{
            invert_lightness: !0
        }, {
            weight: "7.15"
        }]
    }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 20
        }]
    }, {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 21
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "simplified"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }, {
            weight: "0.8"
        }]
    }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 29
        }, {
            weight: "0.01"
        }]
    }, {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 18
        }]
    }, {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 16
        }]
    }, {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{
            weight: "0.01"
        }]
    }, {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "all",
        stylers: [{
            visibility: "off"
        }]
    }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 19
        }]
    }, {
        featureType: "water",
        elementType: "geometry",
        stylers: [{
            color: "#000000"
        }, {
            lightness: 17
        }]
    }], window.theme.allMaps = window.theme.allMaps || {};
    let Hd = window.theme.allMaps;
    const Dd = "[data-map-container]",
        _d = "data-style",
        Bd = "data-api-key",
        Fd = "data-zoom",
        Wd = "data-address",
        Od = "data-latlong-correction",
        Rd = "data-lat",
        Nd = "data-long";
    const zd = {
        onLoad() {
            Hd[this.id] = new class {
                initMaps() {
                    kt({
                        url: `https://maps.googleapis.com/maps/api/js?key=${this.key}`
                    }).then((() => {
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long ? new window.google.maps.LatLng(this.lat, this.long) : (t = this.address, new Promise(((e, i) => {
                            (new window.google.maps.Geocoder).geocode({
                                address: t
                            }, (function(t, s) {
                                if ("OK" == s) {
                                    var o = {
                                        lat: t[0].geometry.location.lat(),
                                        lng: t[0].geometry.location.lng()
                                    };
                                    e(o)
                                } else i(s)
                            }))
                        })));
                        var t
                    })).then((t => {
                        var e = {
                            zoom: parseInt(this.zoomString, 10),
                            styles: Id(this.styleString),
                            center: t,
                            draggable: !0,
                            clickableIcons: !1,
                            scrollwheel: !1,
                            zoomControl: !1,
                            disableDefaultUI: !0
                        };
                        const i = function(t, e) {
                            var i = new window.google.maps.Map(t, e),
                                s = i.getCenter();
                            return new window.google.maps.Marker({
                                map: i,
                                position: s
                            }), window.google.maps.event.addDomListener(window, "resize", (function() {
                                window.google.maps.event.trigger(i, "resize"), i.setCenter(s)
                            })), i
                        }(this.mapWrap, e);
                        return i
                    })).then((t => {
                        this.map = t, Hd[this.id] = t
                    })).catch((t => {
                        console.log("Failed to load Google Map"), console.log(t)
                    }))
                }
                onUnload() {
                    void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize")
                }
                constructor(t) {
                    this.container = t.container, this.mapWrap = this.container.querySelector(Dd), this.styleString = this.container.getAttribute(_d) || "", this.key = this.container.getAttribute(Bd), this.zoomString = this.container.getAttribute(Fd) || 14, this.address = this.container.getAttribute(Wd), this.enableCorrection = this.container.getAttribute(Od), this.lat = this.container.getAttribute(Rd), this.long = this.container.getAttribute(Nd), this.key && this.initMaps()
                }
            }(this)
        },
        onUnload() {
            "function" == typeof Hd[this.id].unload && Hd[this.id].unload()
        }
    };
    Ii("section-map", zd), Ii("section-columns", [Ra, Zt]);
    const Vd = "[data-related-section]",
        jd = "[data-grid-item]",
        Ud = "[data-carousel]",
        Jd = "data-limit",
        Qd = "data-minimum",
        Gd = "data-layout-desktop",
        Yd = "data-layout-tablet",
        Xd = "data-layout-mobile",
        Kd = "[data-recent-wrapper]",
        Zd = "[data-recently-viewed-wrapper]",
        tu = "data-product-id";
    Ii("related", [{
        onLoad() {
            this.section = new class {
                init() {
                    const t = this.container.querySelector(Vd);
                    if (!t) return;
                    const e = t.getAttribute(tu),
                        i = t.getAttribute(Jd),
                        s = t.getAttribute(Gd),
                        o = t.getAttribute(Yd),
                        r = t.getAttribute(Xd),
                        a = `${window.theme.routes.product_recommendations_url||"/recommendations/products/"}?section_id=related&limit=${i}&product_id=${e}`;
                    n.get(a).then((e => {
                        const i = document.createElement("div");
                        i.innerHTML = e.data;
                        const n = i.querySelector(Vd);
                        if (n.querySelector(jd)) {
                            const e = n.innerHTML;
                            t.innerHTML = e, t.querySelector(Ud).style.setProperty("--grid-large-items", s), t.querySelector(Ud).style.setProperty("--grid-medium-items", o), t.querySelector(Ud).style.setProperty("--grid-small-items", r), t.dispatchEvent(new CustomEvent("theme:related-products:added", {
                                bubbles: !0
                            }))
                        } else t.dispatchEvent(new CustomEvent("theme:tabs:hide", {
                            bubbles: !0
                        }))
                    })).catch((function(t) {
                        console.warn(t)
                    }))
                }
                recent() {
                    const t = this.container.querySelector(Kd),
                        e = this.container.querySelector(Zd),
                        i = this.container.querySelectorAll(jd),
                        s = t.hasAttribute(Qd) ? parseInt(t.getAttribute(Qd)) : 4,
                        o = !e && i.length > 0,
                        r = e && i.length >= s;
                    (o || r) && t.dispatchEvent(new CustomEvent("theme:tabs:check", {
                        bubbles: !0
                    }))
                }
                constructor(t) {
                    this.section = t, this.container = t.container, this.init(), this.container.addEventListener("theme:recent-products:added", (() => {
                        this.recent()
                    }))
                }
            }(this)
        }
    }, jh, pt]), customElements.get("radio-swatch") || customElements.define("radio-swatch", Vt), customElements.get("product-grid-item") || customElements.define("product-grid-item", No), customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", sr), customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", nr);
    const eu = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellWrapper: "[data-cart-page-upsell-wrapper]"
        },
        iu = "cart--dirty",
        su = "heart-beat",
        ou = {
            onLoad() {
                if (this.container.querySelector(eu.shipping) && new Br(this), this.disabled = "true" == this.container.getAttribute(eu.ajaxDisable), this.disabled) return void(this.cart = new ru(this));
                this.cart = new pn(this);
                this.cart.init().then((() => {
                    this.cart.loadHTML()
                }))
            }
        };
    let ru = class {
        initQuantity() {
            Nr(this.container)
        }
        moveUpsell() {
            const t = this.container.querySelector(eu.bottom);
            t.insertBefore(this.upsellWrapper, t.firstChild)
        }
        initInputs() {
            this.inputs.forEach((t => {
                t.addEventListener("change", function() {
                    this.updateBtn.classList.add(iu), this.updateBtn.classList.add(su), setTimeout(function() {
                        this.updateBtn.classList.remove(su)
                    }.bind(this), 1300)
                }.bind(this))
            }))
        }
        constructor(t) {
            window.theme.state.cartOpen = !0, this.section = t, this.container = t.container, this.inputs = this.container.querySelectorAll(eu.input), this.quantityWrappers = this.container.querySelectorAll(eu.qty), this.updateBtn = this.container.querySelector(eu.update), this.upsellWrapper = this.container.querySelector(eu.upsellWrapper), this.initQuantity(), this.initInputs(), this.upsellWrapper && this.moveUpsell()
        }
    };
    Ii("cart", [ou, kn]), Ii("accordion-single", kn);
    const nu = (t, e, i = null) => {
            t.style.opacity = 0, t.style.display = e || "block",
                function e() {
                    let s = parseFloat(t.style.opacity);
                    (s += .1) > 1 || (t.style.opacity = s, requestAnimationFrame(e)), 1 === s && "function" == typeof i && i()
                }()
        },
        au = (t, e = null) => {
            t.style.opacity = 1,
                function i() {
                    (t.style.opacity -= .1) < 0 ? t.style.display = "none" : requestAnimationFrame(i), 0 === parseFloat(t.style.opacity) && "function" == typeof e && e()
                }()
        },
        lu = "[data-tracking-consent]",
        cu = "[data-confirm-cookies]",
        hu = "[data-close-modal]",
        du = "[data-popup-inner]",
        uu = "[data-newsletter]",
        pu = "[data-newsletter-holder]",
        mu = "[data-newsletter-field]",
        gu = "[data-newsletter-form]",
        yu = "[data-promo-text]",
        fu = "data-popup-delay",
        wu = "data-cookie-name",
        vu = "data-target-referrer",
        bu = "has-value",
        Su = "has-success",
        Eu = "has-error",
        Lu = "desktop",
        ku = "mobile";
    let Tu = {},
        Au = class {
            write() {
                (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            read() {
                if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                    return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
                }
                return !1
            }
            destroy() {
                document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`)
            }
            constructor(t, e) {
                this.configuration = {
                    expires: null,
                    path: "/",
                    domain: window.location.hostname
                }, this.name = t, this.value = e
            }
        },
        qu = class {
            hide() {
                this.show = !1
            }
            always() {
                this.show && nu(this.element)
            }
            delayed() {
                setTimeout((() => {
                    this.always()
                }), 1e4)
            }
            bottom() {
                let t;
                const e = () => {
                    t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((() => {
                        window.requestIdleCallback((() => {
                            Math.round(window.scrollY + window.innerHeight) >= Math.round(document.body.clientHeight) && (this.always(), window.removeEventListener("scroll", e, {
                                passive: !0
                            }))
                        }), {
                            timeout: 300
                        })
                    }))
                };
                window.addEventListener("scroll", e, {
                    passive: !0
                })
            }
            onScroll() {}
            idle() {
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        t = setTimeout((() => {
                            t = 0, this.always()
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), i.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), i.forEach((t => {
                            window.removeEventListener(t, o)
                        })), s()
                    };
                s()
            }
            constructor(t, e) {
                this.show = !0, this.element = e, this.delay = t.getAttribute(fu), "always" === this.delay && this.always(), "delayed" === this.delay && this.delayed(), "bottom" === this.delay && this.bottom(), "idle" === this.delay && this.idle()
            }
        },
        Cu = class {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(vu)) || window.Shopify.designMode || this.el.parentNode.removeChild(this.el)
            }
            constructor(t) {
                this.el = t, this.locationPath = location.href, this.el.hasAttribute(vu) && this.init()
            }
        };
    Ii("popups", [Aa, {
        onLoad() {
            Tu[this.id] = [];
            this.container.querySelectorAll(lu).forEach((t => {
                Tu[this.id].push(new class {
                    init() {
                        this.showPopup && nu(this.modalInner), this.clickEvents()
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, (() => au(this.modalInner)))
                        })), this.acceptButton.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => au(this.modalInner)))
                        })), document.addEventListener("trackingConsentAccepted", (function() {
                            console.log("trackingConsentAccepted event fired")
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && this.showPopup && nu(this.modalInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && au(this.modalInner)
                    }
                    constructor(t) {
                        this.popup = t, this.modal = document.querySelector(lu), this.modalInner = this.popup.querySelector(du), this.close = this.modal.querySelector(hu), this.acceptButton = this.modal.querySelector(cu), this.enable = "true" === this.modal.getAttribute("data-enable"), this.showPopup = !1, window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (t => {
                            if (t) throw t;
                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.showPopup = !e && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.showPopup = !0), this.init()
                        }))
                    }
                }(t))
            }));
            this.container.querySelectorAll(uu).forEach((t => {
                Tu[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (this.show(), this.checkForSuccess())
                    }
                    show() {
                        window.Shopify.designMode ? nu(this.popupInner) : this.delayShow = new qu(this.popup, this.popupInner), this.inputField(), this.closePopup()
                    }
                    preventDelayShow() {
                        this.delayShow && this.delayShow.hide()
                    }
                    checkForSuccess() {
                        const t = this.form.classList.contains(Eu),
                            e = this.form.classList.contains(Su);
                        (e || t) && (nu(this.popupInner), this.preventDelayShow(), e && this.cookie.write())
                    }
                    closePopup() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), au(this.popupInner), this.cookie.write(), this.preventDelayShow()
                        }))
                    }
                    inputField() {
                        this.newsletterField.addEventListener("input", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(bu, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focus", (() => {
                            "" !== this.newsletterField.value && this.holder.classList.add(bu, "" !== this.newsletterField.value)
                        })), this.newsletterField.addEventListener("focusout", (() => {
                            setTimeout((() => {
                                this.holder.classList.remove(bu)
                            }), 2e3)
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.contains(t.target) && nu(this.popupInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && au(this.popupInner)
                    }
                    constructor(t) {
                        this.popup = t, this.popupInner = this.popup.querySelector(du), this.holder = this.popup.querySelector(pu), this.close = this.popup.querySelector(hu), this.newsletterField = this.popup.querySelector(mu), this.cookie = new Au(this.popup.getAttribute(wu), "newsletter_is_closed"), this.form = this.popup.querySelector(gu), this.isTargeted = new Cu(this.popup), this.delayShow = null, this.init()
                    }
                }(t))
            }));
            this.container.querySelectorAll(yu).forEach((t => {
                Tu[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? nu(this.popupInner) : new qu(this.popup, this.popupInner), this.clickEvents())
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), au(this.popupInner), this.cookie.write()
                        }))
                    }
                    onBlockSelect(t) {
                        this.popup.classList.contains(ku) && (this.hasDeviceClass = ku), this.popup.classList.contains(Lu) && (this.hasDeviceClass = Lu), "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass), this.popup.contains(t.target) && nu(this.popupInner)
                    }
                    onBlockDeselect(t) {
                        this.popup.contains(t.target) && au(this.popupInner), "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass)
                    }
                    constructor(t) {
                        this.popup = t, this.popupInner = this.popup.querySelector(du), this.close = this.popup.querySelector(hu), this.cookie = new Au(this.popup.getAttribute(wu), "user_has_closed"), this.isTargeted = new Cu(this.popup), this.hasDeviceClass = "", this.init()
                    }
                }(t))
            }))
        },
        onBlockSelect(t) {
            Tu[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Tu[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    }]), Ii("tabs", jh);
    const xu = "data-look-dot",
        Pu = "data-products-holder",
        $u = "[data-carousel]",
        Mu = "[data-button-close-holder]",
        Iu = "data-carousel-index",
        Hu = "data-block-id",
        Du = "button",
        _u = "is-active",
        Bu = "is-expanded",
        Fu = {};
    Ii("look", [{
        onLoad() {
            Fu[this.id] = [], Fu[this.id].push(new class {
                init() {
                    this.keyEvents = t => this.keyboardEventShowProductHolder(t), this.keyCloseEvent = t => this.hideProductsHolder(t), this.clickEventsDot = t => this.clickEventShowProductsHolder(t), this.clickEventToClose = t => this.clickEventCloseProductsHolder(t), this.toggleOnResize = t => k(this.onResize(t), 200), this.initSlider(), this.addEvents()
                }
                initSlider() {
                    this.slider && (this.carousel = s.data(this.slider), this.carousel.options.wrapAround = !0, this.carousel.options.freeScroll = !1, this.carousel.resize(), this.carousel.on("change", (t => {
                        this.currentDot = this.container.querySelector(`[${xu}="${t}"]`), this.currentDot.classList.add(_u), this.removeClassOnSiblingDots()
                    })))
                }
                addEvents() {
                    this.dots.forEach((t => {
                        t.addEventListener("click", this.clickEventsDot), t.addEventListener("keyup", this.keyEvents)
                    })), document.addEventListener("keyup", this.keyCloseEvent), document.addEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose)
                }
                showProductsHolder() {
                    const t = !this.productsHolder.classList.contains(Bu);
                    this.currentDot.classList.toggle(_u), this.productsHolder.classList.toggle(Bu, this.currentDot.classList.contains(_u)), this.currentDot.classList.contains(_u) && (this.hasDefaultOpen = !0, this.carousel.selectCell(Number(this.currentDot.getAttribute(xu)), !0, t)), this.removeClassOnSiblingDots()
                }
                hideProductsHolder(t) {
                    "Escape" === t.code && (this.removeClasses(), qe(), this.currentDot.focus())
                }
                removeClasses() {
                    this.productsHolder.classList.remove(Bu), this.currentDot.classList.remove(_u), this.hasDefaultOpen = !1
                }
                clickEventShowProductsHolder(t) {
                    this.currentDot = t.currentTarget, this.showProductsHolder()
                }
                clickEventCloseProductsHolder() {
                    this.removeClasses()
                }
                keyboardEventShowProductHolder(t) {
                    "Enter" !== t.code && "Space" !== t.code || setTimeout((() => {
                        const t = this.productsHolder.querySelector(Du);
                        Ae(this.productsHolder, {
                            elementToFocus: t
                        })
                    }), 400)
                }
                onResize() {
                    this.currentDot && (window.innerWidth < window.theme.sizes.medium ? (this.currentDot.classList.remove(_u), this.productsHolder.classList.remove(Bu)) : this.hasDefaultOpen && (this.currentDot.classList.add(_u), this.productsHolder.classList.add(Bu)))
                }
                removeEvents() {
                    this.dots.forEach((t => {
                        t.removeEventListener("click", this.clickEventsDot), t.removeEventListener("keyup", this.keyEvents)
                    })), document.removeEventListener("keyup", this.keyCloseEvent), document.removeEventListener("theme:resize", this.toggleOnResize), this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose)
                }
                removeClassOnSiblingDots() {
                    for (let t of this.currentDot.parentNode.children) t !== this.currentDot && t.classList.remove(_u)
                }
                onUnload() {
                    this.slider && this.carousel && this.carousel.destroy(), this.removeEvents()
                }
                onBlockSelect(t) {
                    if (this.slider && this.carousel) {
                        const e = this.container.querySelector(`[${Hu}="${t.detail.blockId}"]`);
                        this.productsHolder.classList.add(Bu), this.carousel.selectCell(Number(e.getAttribute(Iu)), !0, !0)
                    }
                }
                onBlockDeselect() {
                    window.innerWidth < window.theme.sizes.medium && (this.productsHolder.classList.remove(Bu), this.currentDot.classList.remove(_u))
                }
                constructor(t) {
                    this.section = t, this.container = this.section.container, this.dots = this.container.querySelectorAll(`[${xu}]`), this.productsHolder = this.container.querySelector(`[${Pu}]`), this.slider = this.container.querySelector($u), this.buttonClose = this.container.querySelector(Mu), this.currentDot = this.container.querySelector(`[${xu}].${_u}`), this.hasDefaultOpen = Boolean(this.currentDot), this.init()
                }
            }(this))
        },
        onUnload() {
            Fu[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        },
        onBlockSelect(t) {
            Fu[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        },
        onBlockDeselect(t) {
            Fu[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }
    }]);
    const Wu = (t, e = "", i) => ((i = i || document.createElement("div")).classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t));
    window.theme.settings.animate_scroll && t.init({
        once: !0
    }), document.addEventListener("DOMContentLoaded", (function() {
        const t = document.querySelector("[data-header-height]");
        if (t) {
            const e = t.clientHeight || 0;
            document.documentElement.style.setProperty("--menu-height", `${e}px`)
        }
        Hi("*"), window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover");
        document.querySelectorAll(".rte table").forEach((t => {
            Wu(t, "rte__table-wrapper")
        }));
        document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe').forEach((t => {
            Wu(t, "rte__video-wrapper")
        })), document.addEventListener("mousedown", (() => {
            document.body.classList.remove("focus-enabled")
        })), document.addEventListener("keyup", (t => {
            "Tab" === t.code && document.body.classList.add("focus-enabled")
        })), window.navigator.cookieEnabled && (document.documentElement.className = document.documentElement.className.replace("supports-no-cookies", "supports-cookies")), Ee(), Le(), "scrollBehavior" in document.documentElement.style || kt({
            url: window.theme.assets.smoothscroll
        })
    }))
}(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.BodyScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.axios, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.themeAddresses, themeVendor.FlickitySync);


// $(window).on('load', function() {
//   // Function to swap the order of elements
//   function swapElements() {
//     if (window.matchMedia('(min-width: 480px)').matches) {
//       // If screen width is greater than or equal to 480px
//       $('.header__desktop').insertBefore('.header__mobile');
//     } else {
//       // If screen width is less than 480px
//       $('.header__mobile').insertBefore('.header__desktop');
//     }
//   }

//   // Call the swapElements function initially
//   swapElements();

//   // Attach the swapElements function to the window resize event
//   $(window).resize(function() {
//     swapElements();
//   });
// });